(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as CS, getPartnerDevApiHeaders as FS, WidgetContextProvider as IS, makeExecuteQuery as ES, makeUseLazyQuery as TS, makeUseQuery as $S, makeUseMutation as DS, validateApiHostName as pb, useTracking as kn, useWidgetContext as un, hasDownstreamApiForbiddenError as Nm, hasDownstreamApiAuthorizationError as jm, DisplayErrors as In, useCopyWithDelay as er, defaultDateFormat as dt, displayAttributeValue as fb, OAuthSettings as eo, useData as wm, isDownstreamApiNotFoundError as RS, isDownstreamApiAuthorizationError as hb, KlaviyoSubscribeSetting as OS, isDownstreamApiPermissionError as PS, capitalizeFirstCharacter as Es, hasDownstreamApiTooManyRequestsError as AS, hasDownstreamApiPermissionError as yb, hasDownstreamApiNotFoundError as no, getCountryNameFromCountryCode as LS, IntegrationModal as gb, useInboundOAuthContext as VS } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Se, { useMemo as qn, useState as se, useEffect as He, useRef as ui, useCallback as tt, useReducer as zS, useLayoutEffect as US, useContext as Cm, createContext as vb, isValidElement as MS, createElement as BS, Fragment as qS } from "react";
import { Text as A, FlexBox as b, Spinner as cn, Icon as ue, Tooltip as Ge, List as Ke, Badge as Un, Button as Kn, IconButton as Yt, Tag as Pn, NavigationButton as St, Select as _r, CollapseCard as ar, Box as Qn, Modal as Nt, ModalHead as jt, ModalBody as wt, FormGrid as Ut, FormField as tn, FieldWrapper as Ln, ModalFoot as It, InputText as kr, Textarea as Bu, TagsInput as Ts, Image as Mi, Banner as $s, Divider as Fm, InputSelectionList as Yr, SelectionList as ot, FieldText as or, FieldTextarea as HS, CopyToClipboardButton as WS, getSelectionListContext as KS, Avatar as Im, Timestamp as GS, Attachment as YS, Switch as qu, FieldLabel as JS, EmptyState as ss, Table as Xn, Checkbox as qp, TextWithHighlight as QS, ErrorBoundaryContext as kb, FieldSwitch as bb } from "@dixa/lib-shared-habla";
import { ApolloLink as Em, Observable as _b, ApolloClient as XS, InMemoryCache as ZS, createHttpLink as e0, ApolloProvider as n0, useApolloClient as t0, ApolloConsumer as r0, NetworkStatus as Gt, isApolloError as xb, ApolloError as i0, gql as Zr, useQuery as a0, useMutation as Hp } from "@apollo/client";
import o0 from "cross-fetch";
import { config as Ja } from "lib-shared-backend-config";
import ut from "classnames";
import An from "moment";
import { __rest as s0, __assign as Zs } from "tslib";
import "moment-timezone";
import { useLocation as l0 } from "react-router-dom";
function Tm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ho = { exports: {} }, Xi = {};
var Wp;
function c0() {
  if (Wp) return Xi;
  Wp = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Xi.Fragment = r, Xi.jsx = s, Xi.jsxs = s, Xi;
}
var Zi = {};
var Kp;
function d0() {
  return Kp || (Kp = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c, P));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Zi.Fragment = i, Zi.jsx = Rn, Zi.jsxs = Bn;
  })()), Zi;
}
var Gp;
function u0() {
  return Gp || (Gp = 1, process.env.NODE_ENV === "production" ? ho.exports = c0() : ho.exports = d0()), ho.exports;
}
var Me = u0();
function Sb(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: m0 } = Object.prototype, { getPrototypeOf: $m } = Object, { iterator: Ds, toStringTag: Nb } = Symbol, Rs = /* @__PURE__ */ ((e) => (n) => {
  const r = m0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), xr = (e) => (e = e.toLowerCase(), (n) => Rs(n) === e), Os = (e) => (n) => typeof n === e, { isArray: Bi } = Array, Li = Os("undefined");
function to(e) {
  return e !== null && !Li(e) && e.constructor !== null && !Li(e.constructor) && Ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const jb = xr("ArrayBuffer");
function p0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && jb(e.buffer), n;
}
const f0 = Os("string"), Ht = Os("function"), wb = Os("number"), ro = (e) => e !== null && typeof e == "object", h0 = (e) => e === !0 || e === !1, Ho = (e) => {
  if (Rs(e) !== "object")
    return !1;
  const n = $m(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Nb in e) && !(Ds in e);
}, y0 = (e) => {
  if (!ro(e) || to(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, g0 = xr("Date"), v0 = xr("File"), k0 = xr("Blob"), b0 = xr("FileList"), _0 = (e) => ro(e) && Ht(e.pipe), x0 = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || Ht(e.append) && ((n = Rs(e)) === "formdata" || // detect form-data instance
  n === "object" && Ht(e.toString) && e.toString() === "[object FormData]"));
}, S0 = xr("URLSearchParams"), [N0, j0, w0, C0] = ["ReadableStream", "Request", "Response", "Headers"].map(xr), F0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function io(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Bi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (to(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Cb(e, n) {
  if (to(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const si = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Fb = (e) => !Li(e) && e !== si;
function Hu() {
  const { caseless: e, skipUndefined: n } = Fb(this) && this || {}, r = {}, i = (a, o) => {
    const s = e && Cb(r, o) || o;
    Ho(r[s]) && Ho(a) ? r[s] = Hu(r[s], a) : Ho(a) ? r[s] = Hu({}, a) : Bi(a) ? r[s] = a.slice() : (!n || !Li(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && io(arguments[a], i);
  return r;
}
const I0 = (e, n, r, { allOwnKeys: i } = {}) => (io(n, (a, o) => {
  r && Ht(a) ? e[o] = Sb(a, r) : e[o] = a;
}, { allOwnKeys: i }), e), E0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), T0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, $0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && $m(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, D0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, R0 = (e) => {
  if (!e) return null;
  if (Bi(e)) return e;
  let n = e.length;
  if (!wb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, O0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && $m(Uint8Array)), P0 = (e, n) => {
  const i = (e && e[Ds]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, A0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, L0 = xr("HTMLFormElement"), V0 = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, a) {
    return i.toUpperCase() + a;
  }
), Yp = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), z0 = xr("RegExp"), Ib = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  io(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, U0 = (e) => {
  Ib(e, (n, r) => {
    if (Ht(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Ht(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, M0 = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Bi(e) ? i(e) : i(String(e).split(n)), r;
}, B0 = () => {
}, q0 = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function H0(e) {
  return !!(e && Ht(e.append) && e[Nb] === "FormData" && e[Ds]);
}
const W0 = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (ro(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (to(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Bi(i) ? [] : {};
        return io(i, (s, l) => {
          const d = r(s, a + 1);
          !Li(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, K0 = xr("AsyncFunction"), G0 = (e) => e && (ro(e) || Ht(e)) && Ht(e.then) && Ht(e.catch), Eb = ((e, n) => e ? setImmediate : n ? ((r, i) => (si.addEventListener("message", ({ source: a, data: o }) => {
  a === si && o === r && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), si.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  Ht(si.postMessage)
), Y0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(si) : typeof process < "u" && process.nextTick || Eb, J0 = (e) => e != null && Ht(e[Ds]), ve = {
  isArray: Bi,
  isArrayBuffer: jb,
  isBuffer: to,
  isFormData: x0,
  isArrayBufferView: p0,
  isString: f0,
  isNumber: wb,
  isBoolean: h0,
  isObject: ro,
  isPlainObject: Ho,
  isEmptyObject: y0,
  isReadableStream: N0,
  isRequest: j0,
  isResponse: w0,
  isHeaders: C0,
  isUndefined: Li,
  isDate: g0,
  isFile: v0,
  isBlob: k0,
  isRegExp: z0,
  isFunction: Ht,
  isStream: _0,
  isURLSearchParams: S0,
  isTypedArray: O0,
  isFileList: b0,
  forEach: io,
  merge: Hu,
  extend: I0,
  trim: F0,
  stripBOM: E0,
  inherits: T0,
  toFlatObject: $0,
  kindOf: Rs,
  kindOfTest: xr,
  endsWith: D0,
  toArray: R0,
  forEachEntry: P0,
  matchAll: A0,
  isHTMLForm: L0,
  hasOwnProperty: Yp,
  hasOwnProp: Yp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ib,
  freezeMethods: U0,
  toObjectSet: M0,
  toCamelCase: V0,
  noop: B0,
  toFiniteNumber: q0,
  findKey: Cb,
  global: si,
  isContextDefined: Fb,
  isSpecCompliantForm: H0,
  toJSONObject: W0,
  isAsyncFn: K0,
  isThenable: G0,
  setImmediate: Eb,
  asap: Y0,
  isIterable: J0
};
function Fn(e, n, r, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), r && (this.config = r), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ve.inherits(Fn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ve.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Tb = Fn.prototype, $b = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  $b[e] = { value: e };
});
Object.defineProperties(Fn, $b);
Object.defineProperty(Tb, "isAxiosError", { value: !0 });
Fn.from = (e, n, r, i, a, o) => {
  const s = Object.create(Tb);
  ve.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", d = n == null && e ? e.code : n;
  return Fn.call(s, l, d, r, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const Q0 = null;
function Wu(e) {
  return ve.isPlainObject(e) || ve.isArray(e);
}
function Db(e) {
  return ve.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Jp(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Db(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function X0(e) {
  return ve.isArray(e) && !e.some(Wu);
}
const Z0 = ve.toFlatObject(ve, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Ps(e, n, r) {
  if (!ve.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ve.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(j, w) {
    return !ve.isUndefined(w[j]);
  });
  const i = r.metaTokens, a = r.visitor || u, o = r.dots, s = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && ve.isSpecCompliantForm(n);
  if (!ve.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(N) {
    if (N === null) return "";
    if (ve.isDate(N))
      return N.toISOString();
    if (ve.isBoolean(N))
      return N.toString();
    if (!d && ve.isBlob(N))
      throw new Fn("Blob is not supported. Use a Buffer instead.");
    return ve.isArrayBuffer(N) || ve.isTypedArray(N) ? d && typeof Blob == "function" ? new Blob([N]) : Buffer.from(N) : N;
  }
  function u(N, j, w) {
    let F = N;
    if (N && !w && typeof N == "object") {
      if (ve.endsWith(j, "{}"))
        j = i ? j : j.slice(0, -2), N = JSON.stringify(N);
      else if (ve.isArray(N) && X0(N) || (ve.isFileList(N) || ve.endsWith(j, "[]")) && (F = ve.toArray(N)))
        return j = Db(j), F.forEach(function(H, T) {
          !(ve.isUndefined(H) || H === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Jp([j], T, o) : s === null ? j : j + "[]",
            m(H)
          );
        }), !1;
    }
    return Wu(N) ? !0 : (n.append(Jp(w, j, o), m(N)), !1);
  }
  const f = [], h = Object.assign(Z0, {
    defaultVisitor: u,
    convertValue: m,
    isVisitable: Wu
  });
  function v(N, j) {
    if (!ve.isUndefined(N)) {
      if (f.indexOf(N) !== -1)
        throw Error("Circular reference detected in " + j.join("."));
      f.push(N), ve.forEach(N, function(F, y) {
        (!(ve.isUndefined(F) || F === null) && a.call(
          n,
          F,
          ve.isString(y) ? y.trim() : y,
          j,
          h
        )) === !0 && v(F, j ? j.concat(y) : [y]);
      }), f.pop();
    }
  }
  if (!ve.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), n;
}
function Qp(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function Dm(e, n) {
  this._pairs = [], e && Ps(e, this, n);
}
const Rb = Dm.prototype;
Rb.append = function(n, r) {
  this._pairs.push([n, r]);
};
Rb.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, Qp);
  } : Qp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function eN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ob(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || eN;
  ve.isFunction(r) && (r = {
    serialize: r
  });
  const a = r && r.serialize;
  let o;
  if (a ? o = a(n, r) : o = ve.isURLSearchParams(n) ? n.toString() : new Dm(n, r).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Xp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ve.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Pb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, nN = typeof URLSearchParams < "u" ? URLSearchParams : Dm, tN = typeof FormData < "u" ? FormData : null, rN = typeof Blob < "u" ? Blob : null, iN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: nN,
    FormData: tN,
    Blob: rN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Rm = typeof window < "u" && typeof document < "u", Ku = typeof navigator == "object" && navigator || void 0, aN = Rm && (!Ku || ["ReactNative", "NativeScript", "NS"].indexOf(Ku.product) < 0), oN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", sN = Rm && window.location.href || "http://localhost", lN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Rm,
  hasStandardBrowserEnv: aN,
  hasStandardBrowserWebWorkerEnv: oN,
  navigator: Ku,
  origin: sN
}, Symbol.toStringTag, { value: "Module" })), Ct = {
  ...lN,
  ...iN
};
function cN(e, n) {
  return Ps(e, new Ct.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ct.isNode && ve.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function dN(e) {
  return ve.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function uN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Ab(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ve.isArray(a) ? a.length : s, d ? (ve.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ve.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ve.isArray(a[s]) && (a[s] = uN(a[s])), !l);
  }
  if (ve.isFormData(e) && ve.isFunction(e.entries)) {
    const r = {};
    return ve.forEachEntry(e, (i, a) => {
      n(dN(i), a, r, 0);
    }), r;
  }
  return null;
}
function mN(e, n, r) {
  if (ve.isString(e))
    try {
      return (n || JSON.parse)(e), ve.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const ao = {
  transitional: Pb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, r) {
    const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ve.isObject(n);
    if (o && ve.isHTMLForm(n) && (n = new FormData(n)), ve.isFormData(n))
      return a ? JSON.stringify(Ab(n)) : n;
    if (ve.isArrayBuffer(n) || ve.isBuffer(n) || ve.isStream(n) || ve.isFile(n) || ve.isBlob(n) || ve.isReadableStream(n))
      return n;
    if (ve.isArrayBufferView(n))
      return n.buffer;
    if (ve.isURLSearchParams(n))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return cN(n, this.formSerializer).toString();
      if ((l = ve.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Ps(
          l ? { "files[]": n } : n,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), mN(n)) : n;
  }],
  transformResponse: [function(n) {
    const r = this.transitional || ao.transitional, i = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (ve.isResponse(n) || ve.isReadableStream(n))
      return n;
    if (n && ve.isString(n) && (i && !this.responseType || a)) {
      const s = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Fn.from(l, Fn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ct.classes.FormData,
    Blob: Ct.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ve.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ao.headers[e] = {};
});
const pN = ve.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), fN = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && pN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, Zp = Symbol("internals");
function ea(e) {
  return e && String(e).trim().toLowerCase();
}
function Wo(e) {
  return e === !1 || e == null ? e : ve.isArray(e) ? e.map(Wo) : String(e);
}
function hN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const yN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function el(e, n, r, i, a) {
  if (ve.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ve.isString(n)) {
    if (ve.isString(i))
      return n.indexOf(i) !== -1;
    if (ve.isRegExp(i))
      return i.test(n);
  }
}
function gN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function vN(e, n) {
  const r = ve.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Wt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = ea(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ve.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Wo(l));
    }
    const s = (l, d) => ve.forEach(l, (m, u) => o(m, u, d));
    if (ve.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ve.isString(n) && (n = n.trim()) && !yN(n))
      s(fN(n), r);
    else if (ve.isObject(n) && ve.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ve.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ve.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = ea(n), n) {
      const i = ve.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return hN(a);
        if (ve.isFunction(r))
          return r.call(this, a, i);
        if (ve.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = ea(n), n) {
      const i = ve.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || el(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = ea(s), s) {
        const l = ve.findKey(i, s);
        l && (!r || el(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || el(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ve.forEach(this, (a, o) => {
      const s = ve.findKey(i, o);
      if (s) {
        r[s] = Wo(a), delete r[o];
        return;
      }
      const l = n ? gN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Wo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ve.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ve.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Zp] = this[Zp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = ea(s);
      i[l] || (vN(a, s), i[l] = !0);
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Wt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ve.reduceDescriptors(Wt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ve.freezeMethods(Wt);
function nl(e, n) {
  const r = this || ao, i = n || r, a = Wt.from(i.headers);
  let o = i.data;
  return ve.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Lb(e) {
  return !!(e && e.__CANCEL__);
}
function qi(e, n, r) {
  Fn.call(this, e ?? "canceled", Fn.ERR_CANCELED, n, r), this.name = "CanceledError";
}
ve.inherits(qi, Fn, {
  __CANCEL__: !0
});
function Vb(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new Fn(
    "Request failed with status code " + r.status,
    [Fn.ERR_BAD_REQUEST, Fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function kN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function bN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function _N(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ls = (e, n, r = 3) => {
  let i = 0;
  const a = bN(50, 250);
  return _N((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = s - i, m = a(d), u = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: d,
      rate: m || void 0,
      estimated: m && l && u ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, ef = (e, n) => {
  const r = e != null;
  return [(i) => n[0]({
    lengthComputable: r,
    total: e,
    loaded: i
  }), n[1]];
}, nf = (e) => (...n) => ve.asap(() => e(...n)), xN = Ct.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ct.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ct.origin),
  Ct.navigator && /(msie|trident)/i.test(Ct.navigator.userAgent)
) : () => !0, SN = Ct.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ve.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), ve.isString(i) && s.push("path=" + i), ve.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function NN(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function jN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function zb(e, n, r) {
  let i = !NN(n);
  return e && (i || r == !1) ? jN(e, n) : n;
}
const tf = (e) => e instanceof Wt ? { ...e } : e;
function yi(e, n) {
  n = n || {};
  const r = {};
  function i(m, u, f, h) {
    return ve.isPlainObject(m) && ve.isPlainObject(u) ? ve.merge.call({ caseless: h }, m, u) : ve.isPlainObject(u) ? ve.merge({}, u) : ve.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ve.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (f in n)
      return i(m, u);
    if (f in e)
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(tf(m), tf(u), f, !0)
  };
  return ve.forEach(Object.keys({ ...e, ...n }), function(u) {
    const f = d[u] || a, h = f(e[u], n[u], u);
    ve.isUndefined(h) && f !== l || (r[u] = h);
  }), r;
}
const Ub = (e) => {
  const n = yi({}, e);
  let { data: r, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = Wt.from(s), n.url = Ob(zb(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ve.isFormData(r)) {
    if (Ct.hasStandardBrowserEnv || Ct.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ve.isFunction(r.getHeaders)) {
      const d = r.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, f]) => {
        m.includes(u.toLowerCase()) && s.set(u, f);
      });
    }
  }
  if (Ct.hasStandardBrowserEnv && (i && ve.isFunction(i) && (i = i(n)), i || i !== !1 && xN(n.url))) {
    const d = a && o && SN.read(o);
    d && s.set(a, d);
  }
  return n;
}, wN = typeof XMLHttpRequest < "u", CN = wN && function(e) {
  return new Promise(function(r, i) {
    const a = Ub(e);
    let o = a.data;
    const s = Wt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, N;
    function j() {
      v && v(), N && N(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let w = new XMLHttpRequest();
    w.open(a.method.toUpperCase(), a.url, !0), w.timeout = a.timeout;
    function F() {
      if (!w)
        return;
      const H = Wt.from(
        "getAllResponseHeaders" in w && w.getAllResponseHeaders()
      ), E = {
        data: !l || l === "text" || l === "json" ? w.responseText : w.response,
        status: w.status,
        statusText: w.statusText,
        headers: H,
        config: e,
        request: w
      };
      Vb(function(U) {
        r(U), j();
      }, function(U) {
        i(U), j();
      }, E), w = null;
    }
    "onloadend" in w ? w.onloadend = F : w.onreadystatechange = function() {
      !w || w.readyState !== 4 || w.status === 0 && !(w.responseURL && w.responseURL.indexOf("file:") === 0) || setTimeout(F);
    }, w.onabort = function() {
      w && (i(new Fn("Request aborted", Fn.ECONNABORTED, e, w)), w = null);
    }, w.onerror = function(T) {
      const E = T && T.message ? T.message : "Network Error", $ = new Fn(E, Fn.ERR_NETWORK, e, w);
      $.event = T || null, i($), w = null;
    }, w.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const E = a.transitional || Pb;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(new Fn(
        T,
        E.clarifyTimeoutError ? Fn.ETIMEDOUT : Fn.ECONNABORTED,
        e,
        w
      )), w = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in w && ve.forEach(s.toJSON(), function(T, E) {
      w.setRequestHeader(E, T);
    }), ve.isUndefined(a.withCredentials) || (w.withCredentials = !!a.withCredentials), l && l !== "json" && (w.responseType = a.responseType), m && ([h, N] = ls(m, !0), w.addEventListener("progress", h)), d && w.upload && ([f, v] = ls(d), w.upload.addEventListener("progress", f), w.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (H) => {
      w && (i(!H || H.type ? new qi(null, e, w) : H), w.abort(), w = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = kN(a.url);
    if (y && Ct.protocols.indexOf(y) === -1) {
      i(new Fn("Unsupported protocol " + y + ":", Fn.ERR_BAD_REQUEST, e));
      return;
    }
    w.send(o || null);
  });
}, FN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(u instanceof Fn ? u : new qi(u instanceof Error ? u.message : u));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new Fn(`timeout ${n} of ms exceeded`, Fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ve.asap(l), d;
  }
}, IN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, EN = async function* (e, n) {
  for await (const r of TN(e))
    yield* IN(r, n);
}, TN = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, rf = (e, n, r, i) => {
  const a = EN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: m, value: u } = await a.next();
        if (m) {
          l(), d.close();
          return;
        }
        let f = u.byteLength;
        if (r) {
          let h = o += f;
          r(h);
        }
        d.enqueue(new Uint8Array(u));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(d) {
      return l(d), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, af = 64 * 1024, { isFunction: yo } = ve, $N = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ve.global), {
  ReadableStream: of,
  TextEncoder: sf
} = ve.global, lf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, DN = (e) => {
  e = ve.merge.call({
    skipUndefined: !0
  }, $N, e);
  const { fetch: n, Request: r, Response: i } = e, a = n ? yo(n) : typeof fetch == "function", o = yo(r), s = yo(i);
  if (!a)
    return !1;
  const l = a && yo(of), d = a && (typeof sf == "function" ? /* @__PURE__ */ ((N) => (j) => N.encode(j))(new sf()) : async (N) => new Uint8Array(await new r(N).arrayBuffer())), m = o && l && lf(() => {
    let N = !1;
    const j = new r(Ct.origin, {
      body: new of(),
      method: "POST",
      get duplex() {
        return N = !0, "half";
      }
    }).headers.has("Content-Type");
    return N && !j;
  }), u = s && l && lf(() => ve.isReadableStream(new i("").body)), f = {
    stream: u && ((N) => N.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((N) => {
    !f[N] && (f[N] = (j, w) => {
      let F = j && j[N];
      if (F)
        return F.call(j);
      throw new Fn(`Response type '${N}' is not supported`, Fn.ERR_NOT_SUPPORT, w);
    });
  });
  const h = async (N) => {
    if (N == null)
      return 0;
    if (ve.isBlob(N))
      return N.size;
    if (ve.isSpecCompliantForm(N))
      return (await new r(Ct.origin, {
        method: "POST",
        body: N
      }).arrayBuffer()).byteLength;
    if (ve.isArrayBufferView(N) || ve.isArrayBuffer(N))
      return N.byteLength;
    if (ve.isURLSearchParams(N) && (N = N + ""), ve.isString(N))
      return (await d(N)).byteLength;
  }, v = async (N, j) => {
    const w = ve.toFiniteNumber(N.getContentLength());
    return w ?? h(j);
  };
  return async (N) => {
    let {
      url: j,
      method: w,
      data: F,
      signal: y,
      cancelToken: H,
      timeout: T,
      onDownloadProgress: E,
      onUploadProgress: $,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ie
    } = Ub(N), J = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let M = FN([y, H && H.toAbortSignal()], T), R = null;
    const q = M && M.unsubscribe && (() => {
      M.unsubscribe();
    });
    let ee;
    try {
      if ($ && m && w !== "get" && w !== "head" && (ee = await v(Z, F)) !== 0) {
        let ke = new r(j, {
          method: "POST",
          body: F,
          duplex: "half"
        }), Ce;
        if (ve.isFormData(F) && (Ce = ke.headers.get("content-type")) && Z.setContentType(Ce), ke.body) {
          const [K, qe] = ef(
            ee,
            ls(nf($))
          );
          F = rf(ke.body, af, K, qe);
        }
      }
      ve.isString(Q) || (Q = Q ? "include" : "omit");
      const ge = o && "credentials" in r.prototype, de = {
        ...ie,
        signal: M,
        method: w.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: F,
        duplex: "half",
        credentials: ge ? Q : void 0
      };
      R = o && new r(j, de);
      let le = await (o ? J(R, ie) : J(j, de));
      const pe = u && (U === "stream" || U === "response");
      if (u && (E || pe && q)) {
        const ke = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          ke[Be] = le[Be];
        });
        const Ce = ve.toFiniteNumber(le.headers.get("content-length")), [K, qe] = E && ef(
          Ce,
          ls(nf(E), !0)
        ) || [];
        le = new i(
          rf(le.body, af, K, () => {
            qe && qe(), q && q();
          }),
          ke
        );
      }
      U = U || "text";
      let W = await f[ve.findKey(f, U) || "text"](le, N);
      return !pe && q && q(), await new Promise((ke, Ce) => {
        Vb(ke, Ce, {
          data: W,
          headers: Wt.from(le.headers),
          status: le.status,
          statusText: le.statusText,
          config: N,
          request: R
        });
      });
    } catch (ge) {
      throw q && q(), ge && ge.name === "TypeError" && /Load failed|fetch/i.test(ge.message) ? Object.assign(
        new Fn("Network Error", Fn.ERR_NETWORK, N, R),
        {
          cause: ge.cause || ge
        }
      ) : Fn.from(ge, ge && ge.code, N, R);
    }
  };
}, RN = /* @__PURE__ */ new Map(), Mb = (e) => {
  let n = e ? e.env : {};
  const { fetch: r, Request: i, Response: a } = n, o = [
    i,
    a,
    r
  ];
  let s = o.length, l = s, d, m, u = RN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : DN(n)), u = m;
  return m;
};
Mb();
const Gu = {
  http: Q0,
  xhr: CN,
  fetch: {
    get: Mb
  }
};
ve.forEach(Gu, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const cf = (e) => `- ${e}`, ON = (e) => ve.isFunction(e) || e === null || e === !1, Bb = {
  getAdapter: (e, n) => {
    e = ve.isArray(e) ? e : [e];
    const { length: r } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < r; s++) {
      i = e[s];
      let l;
      if (a = i, !ON(i) && (a = Gu[(l = String(i)).toLowerCase()], a === void 0))
        throw new Fn(`Unknown adapter '${l}'`);
      if (a && (ve.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? s.length > 1 ? `since :
` + s.map(cf).join(`
`) : " " + cf(s[0]) : "as no adapter specified";
      throw new Fn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Gu
};
function tl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new qi(null, e);
}
function df(e) {
  return tl(e), e.headers = Wt.from(e.headers), e.data = nl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Bb.getAdapter(e.adapter || ao.adapter, e)(e).then(function(i) {
    return tl(e), i.data = nl.call(
      e,
      e.transformResponse,
      i
    ), i.headers = Wt.from(i.headers), i;
  }, function(i) {
    return Lb(i) || (tl(e), i && i.response && (i.response.data = nl.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = Wt.from(i.response.headers))), Promise.reject(i);
  });
}
const qb = "1.12.2", As = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  As[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const uf = {};
As.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + qb + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new Fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        Fn.ERR_DEPRECATED
      );
    return r && !uf[s] && (uf[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
As.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function PN(e, n, r) {
  if (typeof e != "object")
    throw new Fn("options must be an object", Fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new Fn("option " + o + " must be " + d, Fn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Fn("Unknown option " + o, Fn.ERR_BAD_OPTION);
  }
}
const Ko = {
  assertOptions: PN,
  validators: As
}, Sr = Ko.validators;
let mi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Xp(),
      response: new Xp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = yi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Ko.assertOptions(i, {
      silentJSONParsing: Sr.transitional(Sr.boolean),
      forcedJSONParsing: Sr.transitional(Sr.boolean),
      clarifyTimeoutError: Sr.transitional(Sr.boolean)
    }, !1), a != null && (ve.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Ko.assertOptions(a, {
      encode: Sr.function,
      serialize: Sr.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ko.assertOptions(r, {
      baseUrl: Sr.spelling("baseURL"),
      withXsrfToken: Sr.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ve.merge(
      o.common,
      o[r.method]
    );
    o && ve.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (N) => {
        delete o[N];
      }
    ), r.headers = Wt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(j) {
      typeof j.runWhen == "function" && j.runWhen(r) === !1 || (d = d && j.synchronous, l.unshift(j.fulfilled, j.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(j) {
      m.push(j.fulfilled, j.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const N = [df.bind(this), void 0];
      for (N.unshift(...l), N.push(...m), h = N.length, u = Promise.resolve(r); f < h; )
        u = u.then(N[f++], N[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const N = l[f++], j = l[f++];
      try {
        v = N(v);
      } catch (w) {
        j.call(this, w);
        break;
      }
    }
    try {
      u = df.call(this, v);
    } catch (N) {
      return Promise.reject(N);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = yi(this.defaults, n);
    const r = zb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return Ob(r, n.params, n.paramsSerializer);
  }
};
ve.forEach(["delete", "get", "head", "options"], function(n) {
  mi.prototype[n] = function(r, i) {
    return this.request(yi(i || {}, {
      method: n,
      url: r,
      data: (i || {}).data
    }));
  };
});
ve.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(yi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  mi.prototype[n] = r(), mi.prototype[n + "Form"] = r(!0);
});
let AN = class Hb {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new qi(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Hb(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function LN(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function VN(e) {
  return ve.isObject(e) && e.isAxiosError === !0;
}
const Yu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Yu).forEach(([e, n]) => {
  Yu[n] = e;
});
function Wb(e) {
  const n = new mi(e), r = Sb(mi.prototype.request, n);
  return ve.extend(r, mi.prototype, n, { allOwnKeys: !0 }), ve.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Wb(yi(e, a));
  }, r;
}
const mt = Wb(ao);
mt.Axios = mi;
mt.CanceledError = qi;
mt.CancelToken = AN;
mt.isCancel = Lb;
mt.VERSION = qb;
mt.toFormData = Ps;
mt.AxiosError = Fn;
mt.Cancel = mt.CanceledError;
mt.all = function(n) {
  return Promise.all(n);
};
mt.spread = LN;
mt.isAxiosError = VN;
mt.mergeConfig = yi;
mt.AxiosHeaders = Wt;
mt.formToJSON = (e) => Ab(ve.isHTMLForm(e) ? new FormData(e) : e);
mt.getAdapter = Bb.getAdapter;
mt.HttpStatusCode = Yu;
mt.default = mt;
const {
  Axios: f4,
  AxiosError: h4,
  CanceledError: y4,
  isCancel: g4,
  CancelToken: v4,
  VERSION: k4,
  all: b4,
  Cancel: _4,
  isAxiosError: zN,
  spread: x4,
  toFormData: S4,
  AxiosHeaders: N4,
  HttpStatusCode: j4,
  formToJSON: w4,
  getAdapter: C4,
  mergeConfig: F4
} = mt;
class UN {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const mf = new UN();
function MN(e, n) {
  return pf(e), pf(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function pf(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const BN = Object.prototype.toString;
function qN(e, n) {
  return BN.call(e) === `[object ${n}]`;
}
function HN(e) {
  return qN(e, "Object");
}
function WN(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Va = "8.36.0", qr = globalThis;
function Om(e, n, r) {
  const i = r || qr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Va] = a[Va] || {};
  return o[e] || (o[e] = n());
}
const Kb = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, KN = "Sentry Logger ", ff = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], hf = {};
function Gb(e) {
  if (!("console" in qr))
    return e();
  const n = qr.console, r = {}, i = Object.keys(hf);
  i.forEach((a) => {
    const o = hf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function GN() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Kb ? ff.forEach((r) => {
    n[r] = (...i) => {
      e && Gb(() => {
        qr.console[r](`${KN}[${r}]:`, ...i);
      });
    };
  }) : ff.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Go = Om("logger", GN);
function YN(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Kb && Go.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Yb = 1e3;
function Pm() {
  return Date.now() / Yb;
}
function JN() {
  const { performance: e } = qr;
  if (!e || !e.now)
    return Pm;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Yb;
}
const QN = JN();
(() => {
  const { performance: e } = qr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Di() {
  const e = qr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function yf() {
  return {
    traceId: Di(),
    spanId: Di().substring(16)
  };
}
function Am() {
  return Lm(qr), qr;
}
function Lm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Va, n[Va] = n[Va] || {};
}
function XN(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || QN(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Di()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Ju = "_sentrySpan";
function gf(e, n) {
  n ? YN(e, Ju, n) : delete e[Ju];
}
function vf(e) {
  return e[Ju];
}
const ZN = 100;
class Vm {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = yf();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Vm();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, gf(n, vf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && XN(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Vi ? [r.getScopeData(), r.getRequestSession()] : HN(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, gf(this, void 0), this._attachments = [], this._propagationContext = yf(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : ZN;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Pm(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: vf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Di();
    if (!this._client)
      return Go.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Di();
    if (!this._client)
      return Go.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Di();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Go.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Vi = Vm;
function ej() {
  return Om("defaultCurrentScope", () => new Vi());
}
function nj() {
  return Om("defaultIsolationScope", () => new Vi());
}
class tj {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Vi();
    let a;
    r ? a = r : a = new Vi(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return WN(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function zi() {
  const e = Am(), n = Lm(e);
  return n.stack = n.stack || new tj(ej(), nj());
}
function rj(e) {
  return zi().withScope(e);
}
function ij(e, n) {
  const r = zi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function kf(e) {
  return zi().withScope(() => e(zi().getIsolationScope()));
}
function aj() {
  return {
    withIsolationScope: kf,
    withScope: rj,
    withSetScope: ij,
    withSetIsolationScope: (e, n) => kf(n),
    getCurrentScope: () => zi().getScope(),
    getIsolationScope: () => zi().getIsolationScope()
  };
}
function Jb(e) {
  const n = Lm(e);
  return n.acs ? n.acs : aj();
}
function zm() {
  const e = Am();
  return Jb(e).getCurrentScope();
}
function Qb() {
  const e = Am();
  return Jb(e).getIsolationScope();
}
function oj() {
  return zm().getClient();
}
function sj(e) {
  if (e)
    return lj(e) ? { captureContext: e } : dj(e) ? {
      captureContext: e
    } : e;
}
function lj(e) {
  return e instanceof Vi || typeof e == "function";
}
const cj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function dj(e) {
  return Object.keys(e).some((n) => cj.includes(n));
}
function bf(e, n) {
  return zm().captureException(e, sj(n));
}
function uj(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return zm().captureMessage(e, r, i);
}
function mj(e, n) {
  Qb().setContext(e, n);
}
const pj = 100;
function ii(e, n) {
  const r = oj(), i = Qb();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = pj } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Pm(), ...e }, d = a ? Gb(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Qa;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Qa || (Qa = {}));
function Ri(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const fj = Ja.backendDomain ? {
  "backend-domain": Ja.backendDomain
} : void 0;
function Yo() {
  const e = new URLSearchParams({
    noToken: "true",
    ...fj
  }).toString();
  document.location.href = `${Ja.url.logIn}?${e}`;
}
const rl = "authData", il = 30, hj = 600, al = 5;
class yj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= al || this.clientServerTimeDiff <= -al ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + hj, a = Ri(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > al) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(rl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(rl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(rl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - il;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Ri(n), i = r.exp - il;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - il - this.estimatedServerTime()) * 1e3;
  }
}
const vt = new yj();
async function gj(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Ri(o).exp : "None", l = await Ls.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Ri(m).exp : "None", h = u ? Ri(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", N = typeof f == "number" ? d - f : "Unknown", j = typeof h == "number" ? d - h : "Unknown", w = e.response.headers["x-dixa-rid"];
      mj("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: N,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: j,
        xDixaRid: w,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    uj("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Qa.Platform,
        domain: n
      }
    });
  }
}
const ol = /* @__PURE__ */ new Map(), vj = 3;
function kj(e) {
  e.interceptors.response.use((n) => (ol.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Qu.Unauthorized:
          if (!Ls.isRefreshTokenExpired() && n.config) {
            ii({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = ol.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= vj)
              return ol.set(n.config.url, i + 1), e(n.config);
          }
          gj(n), console.error("401 unauthorized interceptor"), Yo();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Xb = mt.create();
kj(Xb);
const Ar = console.log;
async function _f(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class bj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function _j(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const xj = 5;
class Sj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      vt.setAuthData(r);
    else {
      const i = vt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new bj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = vt.getAccessToken();
    if (!n)
      return {};
    const r = Ri(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return vt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = vt.getAuthData();
    return r ? vt.isAccessTokenExpired() ? (ii({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && vt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return vt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return vt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return vt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = vt.getAuthData();
    return n ? vt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!mf.isElectron())
      return !0;
    const n = await mf.getVersion();
    return MN(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = xj) {
    try {
      return await Xb.post(`${Ja.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ar("AUTH", "Network connection offline - waiting..."), ii({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await _f(5);
    n && (Ar("AUTH", "Network connection restored"), ii({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = _j(this.retryCount);
    return Ar("AUTH", `Retrying in ${i} seconds`), await _f(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (vt.isRefreshTokenExpired(r))
      return Ar("AUTH", "Refresh token expired"), ii({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), vt.removeAuthData(), Yo(), null;
    if (zN(n)) {
      if (n.message === "timeout exceeded")
        return Ar("AUTH", "Timeout exceeded"), ii({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ar("AUTH", "Network error"), ii({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ar("AUTH", "Refresh token invalid (401)"), vt.removeAuthData(), Yo(), null;
      bf(n, {
        level: "error",
        tags: {
          team: Qa.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ar("AUTH", "Retries exhausted, logging out"), bf(n, {
      level: "error",
      tags: {
        team: Qa.Platform,
        errorSource: "authManager.refresh"
      }
    }), vt.removeAuthData(), Yo(), null) : (Ar("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return vt.accessTokenExpiresInMs();
  }
}
const Ls = new Sj();
var Qu;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Qu || (Qu = {}));
const Nj = new Em((e, n) => new _b((r) => {
  Ls.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), jj = new Em(
  (e, n) => new _b((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ls.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...CS(Ja.url.partnerIntegrations) && d?.access_token && FS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), wj = new AbortController(), Zb = (e) => new XS({
  queryDeduplication: !1,
  cache: new ZS(),
  link: Em.from([
    Nj,
    jj,
    e0({
      uri: `${e}/graphql`,
      fetch: o0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: wj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), Cj = ({
  configuration: e,
  children: n
}) => {
  const r = qn(
    () => Zb(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Me.jsx(n0, { client: r, children: n });
};
function Fj() {
  try {
    return t0(), !0;
  } catch {
    return !1;
  }
}
const Ij = ({
  configuration: e,
  children: n
}) => Fj() ? n : /* @__PURE__ */ Me.jsx(Cj, { configuration: e, children: n }), Ej = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Me.jsx(r0, { children: (o) => /* @__PURE__ */ Me.jsx(
  IS,
  {
    value: {
      useMutation: DS(e, n),
      useQuery: $S(e, n),
      useLazyQuery: TS(e, n),
      executeQuery: ES(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), e_ = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Me.jsx(Ij, { configuration: r, children: s ? /* @__PURE__ */ Me.jsx(
    Ej,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var sl = { exports: {} }, na = {}, xf;
function Tj() {
  if (xf) return na;
  xf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return na.Fragment = r, na.jsx = s, na.jsxs = s, na;
}
var go = {}, Sf;
function $j() {
  return Sf || (Sf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    go.Fragment = i, go.jsx = Rn, go.jsxs = Bn;
  })()), go;
}
var Nf;
function Dj() {
  return Nf || (Nf = 1, process.env.NODE_ENV === "production" ? sl.exports = Tj() : sl.exports = $j()), sl.exports;
}
var ae = Dj();
const Rj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Oj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, Pj = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": Rj,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Oj
};
function n_(e) {
  return Pj[e] ?? {};
}
const Aj = n_(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Lj = n_(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Vj = "_copyIcon_1wjfs_48", zj = "_list_1wjfs_53", Uj = "_listItem_1wjfs_63", Mj = "_collapsible_1wjfs_72", Bj = "_collapsibleIsOpen_1wjfs_80", qj = "_collapsibleHeader_1wjfs_83", Hj = "_collapsibleIconTrue_1wjfs_86", Wj = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: Vj,
  list: zj,
  listItem: Uj,
  collapsible: Mj,
  collapsibleIsOpen: Bj,
  collapsibleHeader: qj,
  collapsibleIconTrue: Hj,
  collapsibleIconFalse: Wj
}, Kj = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(Ke, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(d).format(dt) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(m).format(dt) })
          ] }) })
        ] })
      ]
    }
  );
}, Gj = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Kj, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Yj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(Ke, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      Ke.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: i }),
          fb(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Jj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(Ke, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      Ke.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ge,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${An(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${An(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, cs = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(Ge, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(ue, { size: 14, name: o(), color: s() }) }) });
}, Qj = "_wrapper_1xucg_1", Xj = "_externalLink_1xucg_7", ll = {
  wrapper: Qj,
  externalLink: Xj
}, Zj = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = er(), { isCopied: i, copy: a } = er(), { isCopied: o, copy: s } = er(), { isCopied: l, copy: d } = er(), { isCopied: m, copy: u } = er();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: N,
    home_city: j,
    country: w,
    email: F,
    phone: y,
    dob: H,
    created_at: T,
    email_subscribe: E,
    push_subscribe: $
  } = e, U = 14, Z = `${v || ""} ${N || ""}`.trim() || "A customer has no name", Q = `${j ? `${j} /` : ""} ${w || ""}`.trim(), ie = H ? An(H).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: ll.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ll.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-2", children: Z }),
          ie && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    T && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: An(T).format(dt) })
    ] }),
    Q && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: Q })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(Q),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    F && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: ll.externalLink, children: F })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(F),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "phone" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "user" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "tag" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(A.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(Ge, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        ue,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    E && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(cs, { state: E })
    ] }),
    $ && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: U, name: "bell" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(cs, { isPush: !0, state: $ })
    ] })
  ] }) });
}, ew = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: ut(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(Ke, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              ue,
              {
                size: a,
                className: ut({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ge, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, nw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Un, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(ew, { device: r, openByDefault: i === 0 }, i))
  ] });
}, ta = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, vo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = kn(), { useMutation: a } = un(), [o, s] = se(!1), [l] = a(
    Lj,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: ta[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(Ge, { content: ta[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Kn,
    {
      variant: "secondary",
      color: ta[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          cs,
          {
            noTooltip: !0,
            state: ta[n].parameter
          }
        ),
        ta[n].label
      ] })
    }
  ) });
}, tw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(Ke, { className: On.list, children: /* @__PURE__ */ ae.jsx(Ke.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(ue, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(cs, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          vo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          vo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        vo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        vo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, rw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(Ke, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      Ke.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            Ge,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${An(a?.first).format(
                  dt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${An(a?.last).format(
                  dt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, iw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), { useMutation: i } = un(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, N = n.displayCustomAttributes ?? !1, j = n.displayCustomEvents ?? !1, w = n.displayPuchases ?? !1, F = n.displayDevices ?? !1, y = n.displayApps ?? !1, H = !h && !v && !N && !j && !w, [T, { error: E }] = i(
    Aj,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), $ = async () => {
    u || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (He(() => {
    async function U() {
      m(!0), await $();
    }
    U().finally(() => m(!1));
  }, [u, f]), E) {
    const U = E.graphQLErrors;
    return Nm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : jm({ errors: U }) ? /* @__PURE__ */ ae.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(In, { error: E });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(cn, {}) }) : H ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(Zj, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ae.jsx(
          tw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await $()
          }
        ),
        N && !!a && /* @__PURE__ */ ae.jsx(Yj, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ ae.jsx(Jj, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ ae.jsx(rw, { customerDetails: a }),
        F && !!a && /* @__PURE__ */ ae.jsx(nw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ ae.jsx(Gj, { apps: a?.apps })
      ]
    }
  );
}, aw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => pb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function ow() {
  var e = ui(!1), n = tt(function() {
    return e.current;
  }, []);
  return He(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var sw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = tt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, lw = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, jf = function(e) {
  return zS(lw, e);
}, cl, wf;
function cw() {
  return wf || (wf = 1, cl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), cl;
}
var dl, Cf;
function dw() {
  if (Cf) return dl;
  Cf = 1;
  var e = cw(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(j) {
        if (j.stopPropagation(), s.format)
          if (j.preventDefault(), typeof j.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var w = n[s.format] || n.default;
            window.clipboardData.setData(w, o);
          } else
            j.clipboardData.clearData(), j.clipboardData.setData(s.format, o);
        s.onCopy && (j.preventDefault(), s.onCopy(j.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var N = document.execCommand("copy");
      if (!N)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (j) {
      l && console.error("unable to copy using execCommand: ", j), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (w) {
        l && console.error("unable to copy using clipboardData: ", w), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return dl = a, dl;
}
var uw = dw();
const mw = /* @__PURE__ */ Tm(uw);
var t_ = function() {
  var e = ow(), n = sw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = tt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = mw(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function pw(e, n) {
  n === void 0 && (n = 0);
  var r = ui(!1), i = ui(), a = ui(e), o = tt(function() {
    return r.current;
  }, []), s = tt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = tt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return He(function() {
    a.current = e;
  }, [e]), He(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function gi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = pw(e, n), a = i[0], o = i[1], s = i[2];
  return He(s, r), [a, o];
}
var fw = function(e) {
  He(e, []);
}, hw = function(e, n) {
  var r = ui(function() {
  });
  He(function() {
    r.current = e;
  }), He(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, yw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = qn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return Zs(Zs({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = s0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = Zs({ get: tt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, gw = function(e) {
  var n = ui(e);
  n.current = e, fw(function() {
    return function() {
      return n.current();
    };
  });
}, oo = (e) => e.type === "checkbox", li = (e) => e instanceof Date, Ot = (e) => e == null;
const r_ = (e) => typeof e == "object";
var st = (e) => !Ot(e) && !Array.isArray(e) && r_(e) && !li(e), i_ = (e) => st(e) && e.target ? oo(e.target) ? e.target.checked : e.target.value : e, vw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, a_ = (e, n) => e.has(vw(n)), kw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, Um = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function bt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Um && (e instanceof Blob || i)) && (r || st(e)))
    if (n = r ? [] : {}, !r && !kw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = bt(e[a]));
  else
    return e;
  return n;
}
var Vs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Ye = (e, n, r) => {
  if (!n || !st(e))
    return r;
  const i = Vs(n.split(/[,[\].]+?/)).reduce((a, o) => Ot(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? r : e[n] : i;
}, Qt = (e) => typeof e == "boolean", Mm = (e) => /^\w*$/.test(e), o_ = (e) => Vs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, r) => {
  let i = -1;
  const a = Mm(n) ? [n] : o_(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ds = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, pr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, s_ = Se.createContext(null), Or = () => Se.useContext(s_), Bm = (e) => {
  const { children: n, ...r } = e;
  return Se.createElement(s_.Provider, { value: r }, n);
};
var l_ = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== pr.all && (n._proxyFormState[s] = !i || pr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function bw(e) {
  const n = Or(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => l_(s, r, d.current, !1), [s, r]);
}
var Er = (e) => typeof e == "string", c_ = (e, n, r, i, a) => Er(e) ? (i && n.watch.add(e), Ye(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(r, o))) : (i && (n.watchAll = !0), r);
function Jo(e) {
  const n = Or(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(c_(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function qm(e) {
  const n = Or(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = a_(a._names.array, r), l = Jo({
    control: a,
    name: r,
    defaultValue: Ye(a._formValues, r, Ye(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = bw({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ye(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((w) => u.current.onChange({
    target: {
      value: i_(w),
      name: r
    },
    type: ds.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Ye(a._formValues, r),
      name: r
    },
    type: ds.BLUR
  }), [r, a._formValues]), N = Se.useCallback((w) => {
    const F = Ye(a._fields, r);
    F && w && (F._f.ref = {
      focus: () => w.focus(),
      select: () => w.select(),
      setCustomValidity: (y) => w.setCustomValidity(y),
      reportValidity: () => w.reportValidity()
    });
  }, [a._fields, r]), j = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Qt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: N
  }), [r, i, d.disabled, h, v, N, l]);
  return Se.useEffect(() => {
    const w = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, H) => {
      const T = Ye(a._fields, y);
      T && T._f && (T._f.mount = H);
    };
    if (F(r, !0), w) {
      const y = bt(Ye(a._options.defaultValues, r));
      Gn(a._defaultValues, r, y), rt(Ye(a._formValues, r)) && Gn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? w && !a._state.action : w) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
const Lt = (e) => e.render(qm(e));
var _w = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, za = (e) => Array.isArray(e) ? e : [e], Ff = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Xu = (e) => Ot(e) || !r_(e);
function Jr(e, n) {
  if (Xu(e) || Xu(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !Jr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var $t = (e) => st(e) && !Object.keys(e).length, Hm = (e) => e.type === "file", fr = (e) => typeof e == "function", us = (e) => {
  if (!Um)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, d_ = (e) => e.type === "select-multiple", Wm = (e) => e.type === "radio", xw = (e) => Wm(e) || oo(e), ul = (e) => us(e) && e.isConnected;
function Sw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function Nw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function ft(e, n) {
  const r = Array.isArray(n) ? n : Mm(n) ? [n] : o_(n), i = r.length === 1 ? e : Sw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (st(i) && $t(i) || Array.isArray(i) && Nw(i)) && ft(e, r.slice(0, -1)), e;
}
var u_ = (e) => {
  for (const n in e)
    if (fr(e[n]))
      return !0;
  return !1;
};
function ms(e, n = {}) {
  const r = Array.isArray(e);
  if (st(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !u_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ms(e[i], n[i])) : Ot(e[i]) || (n[i] = !0);
  return n;
}
function m_(e, n, r) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !u_(e[a]) ? rt(n) || Xu(r[a]) ? r[a] = Array.isArray(e[a]) ? ms(e[a], []) : { ...ms(e[a]) } : m_(e[a], Ot(n) ? {} : n[a], r[a]) : r[a] = !Jr(e[a], n[a]);
  return r;
}
var ra = (e, n) => m_(e, n, ms(n));
const If = {
  value: !1,
  isValid: !1
}, Ef = { value: !0, isValid: !0 };
var p_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? Ef : { value: e[0].value, isValid: !0 } : Ef
    ) : If;
  }
  return If;
}, f_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : r && Er(e) ? new Date(e) : i ? i(e) : e;
const Tf = {
  isValid: !1,
  value: null
};
var h_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Tf) : Tf;
function $f(e) {
  const n = e.ref;
  return Hm(n) ? n.files : Wm(n) ? h_(e.refs).value : d_(n) ? [...n.selectedOptions].map(({ value: r }) => r) : oo(n) ? p_(e.refs).value : f_(rt(n.value) ? e.ref.value : n.value, e);
}
var jw = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, ps = (e) => e instanceof RegExp, ia = (e) => rt(e) ? e : ps(e) ? e.source : st(e) ? ps(e.value) ? e.value.source : e.value : e, Df = (e) => ({
  isOnSubmit: !e || e === pr.onSubmit,
  isOnBlur: e === pr.onBlur,
  isOnChange: e === pr.onChange,
  isOnAll: e === pr.all,
  isOnTouch: e === pr.onTouched
});
const Rf = "AsyncFunction";
var ww = (e) => !!e && !!e.validate && !!(fr(e.validate) && e.validate.constructor.name === Rf || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Rf)), Cw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Of = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ua = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ua(l, n))
          break;
      } else if (st(l) && Ua(l, n))
        break;
    }
  }
};
function Pf(e, n, r) {
  const i = Ye(e, r);
  if (i || Mm(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Fw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return $t(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || pr.all));
}, Iw = (e, n, r) => !e || !n || e === n || za(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), Ew = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, Tw = (e, n) => !Vs(Ye(e, n)).length && ft(e, n), $w = (e, n, r) => {
  const i = za(Ye(e, r));
  return Gn(i, "root", n[r]), Gn(e, r, i), e;
}, Qo = (e) => Er(e);
function Af(e, n, r = "validate") {
  if (Qo(e) || Array.isArray(e) && e.every(Qo) || Qt(e) && !e)
    return {
      type: r,
      message: Qo(e) ? e : "",
      ref: n
    };
}
var xi = (e) => st(e) && !ps(e) ? e : {
  value: e,
  message: ""
}, Lf = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: N, name: j, valueAsNumber: w, mount: F } = e._f, y = Ye(r, j);
  if (!F || n.has(j))
    return {};
  const H = l ? l[0] : s, T = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Qt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, $ = Wm(s), U = oo(s), Z = $ || U, Q = (w || Hm(s)) && rt(s.value) && rt(y) || us(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = _w.bind(null, j, i, E), J = (M, R, q, ee = Lr.maxLength, ge = Lr.minLength) => {
    const de = M ? R : q;
    E[j] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || Ot(y)) || Qt(y) && !y || U && !p_(l).isValid || $ && !h_(l).isValid)) {
    const { value: M, message: R } = Qo(d) ? { value: !!d, message: d } : xi(d);
    if (M && (E[j] = {
      type: Lr.required,
      message: R,
      ref: H,
      ...ie(Lr.required, R)
    }, !i))
      return T(R), E;
  }
  if (!Q && (!Ot(f) || !Ot(h))) {
    let M, R;
    const q = xi(h), ee = xi(f);
    if (!Ot(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      Ot(q.value) || (M = ge > q.value), Ot(ee.value) || (R = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Er(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), Er(ee.value) && y && (R = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || R) && (J(!!M, q.message, ee.message, Lr.max, Lr.min), !i))
      return T(E[j].message), E;
  }
  if ((m || u) && !Q && (Er(y) || o && Array.isArray(y))) {
    const M = xi(m), R = xi(u), q = !Ot(M.value) && y.length > +M.value, ee = !Ot(R.value) && y.length < +R.value;
    if ((q || ee) && (J(q, M.message, R.message), !i))
      return T(E[j].message), E;
  }
  if (v && !Q && Er(y)) {
    const { value: M, message: R } = xi(v);
    if (ps(M) && !y.match(M) && (E[j] = {
      type: Lr.pattern,
      message: R,
      ref: s,
      ...ie(Lr.pattern, R)
    }, !i))
      return T(R), E;
  }
  if (N) {
    if (fr(N)) {
      const M = await N(y, r), R = Af(M, H);
      if (R && (E[j] = {
        ...R,
        ...ie(Lr.validate, R.message)
      }, !i))
        return T(R.message), E;
    } else if (st(N)) {
      let M = {};
      for (const R in N) {
        if (!$t(M) && !i)
          break;
        const q = Af(await N[R](y, r), H, R);
        q && (M = {
          ...q,
          ...ie(R, q.message)
        }, T(q.message), i && (E[j] = M));
      }
      if (!$t(M) && (E[j] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const Dw = {
  mode: pr.onSubmit,
  reValidateMode: pr.onChange,
  shouldFocusError: !0
};
function Rw(e = {}) {
  let n = {
    ...Dw,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: fr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? bt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : bt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ff(),
    state: Ff()
  }, v = Df(n.mode), N = Df(n.reValidateMode), j = n.criteriaMode === pr.all, w = (_) => (D) => {
    clearTimeout(m), m = setTimeout(_, D);
  }, F = async (_) => {
    if (!n.disabled && (u.isValid || f.isValid || _)) {
      const D = n.resolver ? $t((await Q()).errors) : await J(i, !0);
      D !== r.isValid && h.state.next({
        isValid: D
      });
    }
  }, y = (_, D) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((G) => {
      G && (D ? Gn(r.validatingFields, G, D) : ft(r.validatingFields, G));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !$t(r.validatingFields)
    }));
  }, H = (_, D = [], G, Y, O = !0, z = !0) => {
    if (Y && G && !n.disabled) {
      if (s.action = !0, z && Array.isArray(Ye(i, _))) {
        const re = G(Ye(i, _), Y.argA, Y.argB);
        O && Gn(i, _, re);
      }
      if (z && Array.isArray(Ye(r.errors, _))) {
        const re = G(Ye(r.errors, _), Y.argA, Y.argB);
        O && Gn(r.errors, _, re), Tw(r.errors, _);
      }
      if ((u.touchedFields || f.touchedFields) && z && Array.isArray(Ye(r.touchedFields, _))) {
        const re = G(Ye(r.touchedFields, _), Y.argA, Y.argB);
        O && Gn(r.touchedFields, _, re);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = ra(a, o)), h.state.next({
        name: _,
        isDirty: R(_, D),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Gn(o, _, D);
  }, T = (_, D) => {
    Gn(r.errors, _, D), h.state.next({
      errors: r.errors
    });
  }, E = (_) => {
    r.errors = _, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (_, D, G, Y) => {
    const O = Ye(i, _);
    if (O) {
      const z = Ye(o, _, rt(G) ? Ye(a, _) : G);
      rt(z) || Y && Y.defaultChecked || D ? Gn(o, _, D ? z : $f(O._f)) : ge(_, z), s.mount && F();
    }
  }, U = (_, D, G, Y, O) => {
    let z = !1, re = !1;
    const fe = {
      name: _
    };
    if (!n.disabled) {
      if (!G || Y) {
        (u.isDirty || f.isDirty) && (re = r.isDirty, r.isDirty = fe.isDirty = R(), z = re !== fe.isDirty);
        const be = Jr(Ye(a, _), D);
        re = !!Ye(r.dirtyFields, _), be ? ft(r.dirtyFields, _) : Gn(r.dirtyFields, _, !0), fe.dirtyFields = r.dirtyFields, z = z || (u.dirtyFields || f.dirtyFields) && re !== !be;
      }
      if (G) {
        const be = Ye(r.touchedFields, _);
        be || (Gn(r.touchedFields, _, G), fe.touchedFields = r.touchedFields, z = z || (u.touchedFields || f.touchedFields) && be !== G);
      }
      z && O && h.state.next(fe);
    }
    return z ? fe : {};
  }, Z = (_, D, G, Y) => {
    const O = Ye(r.errors, _), z = (u.isValid || f.isValid) && Qt(D) && r.isValid !== D;
    if (n.delayError && G ? (d = w(() => T(_, G)), d(n.delayError)) : (clearTimeout(m), d = null, G ? Gn(r.errors, _, G) : ft(r.errors, _)), (G ? !Jr(O, G) : O) || !$t(Y) || z) {
      const re = {
        ...Y,
        ...z && Qt(D) ? { isValid: D } : {},
        errors: r.errors,
        name: _
      };
      r = {
        ...r,
        ...re
      }, h.state.next(re);
    }
  }, Q = async (_) => {
    y(_, !0);
    const D = await n.resolver(o, n.context, jw(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(_), D;
  }, ie = async (_) => {
    const { errors: D } = await Q(_);
    if (_)
      for (const G of _) {
        const Y = Ye(D, G);
        Y ? Gn(r.errors, G, Y) : ft(r.errors, G);
      }
    else
      r.errors = D;
    return D;
  }, J = async (_, D, G = {
    valid: !0
  }) => {
    for (const Y in _) {
      const O = _[Y];
      if (O) {
        const { _f: z, ...re } = O;
        if (z) {
          const fe = l.array.has(z.name), be = O._f && ww(O._f);
          be && u.validatingFields && y([Y], !0);
          const en = await Lf(O, l.disabled, o, j, n.shouldUseNativeValidation && !D, fe);
          if (be && u.validatingFields && y([Y]), en[z.name] && (G.valid = !1, D))
            break;
          !D && (Ye(en, z.name) ? fe ? $w(r.errors, en, z.name) : Gn(r.errors, z.name, en[z.name]) : ft(r.errors, z.name));
        }
        !$t(re) && await J(re, D, G);
      }
    }
    return G.valid;
  }, M = () => {
    for (const _ of l.unMount) {
      const D = Ye(i, _);
      D && (D._f.refs ? D._f.refs.every((G) => !ul(G)) : !ul(D._f.ref)) && Le(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (_, D) => !n.disabled && (_ && D && Gn(o, _, D), !Jr(Ce(), a)), q = (_, D, G) => c_(_, l, {
    ...s.mount ? o : rt(D) ? a : Er(_) ? { [_]: D } : D
  }, G, D), ee = (_) => Vs(Ye(s.mount ? o : a, _, n.shouldUnregister ? Ye(a, _, []) : [])), ge = (_, D, G = {}) => {
    const Y = Ye(i, _);
    let O = D;
    if (Y) {
      const z = Y._f;
      z && (!z.disabled && Gn(o, _, f_(D, z)), O = us(z.ref) && Ot(D) ? "" : D, d_(z.ref) ? [...z.ref.options].forEach((re) => re.selected = O.includes(re.value)) : z.refs ? oo(z.ref) ? z.refs.length > 1 ? z.refs.forEach((re) => (!re.defaultChecked || !re.disabled) && (re.checked = Array.isArray(O) ? !!O.find((fe) => fe === re.value) : O === re.value)) : z.refs[0] && (z.refs[0].checked = !!O) : z.refs.forEach((re) => re.checked = re.value === O) : Hm(z.ref) ? z.ref.value = "" : (z.ref.value = O, z.ref.type || h.state.next({
        name: _,
        values: bt(o)
      })));
    }
    (G.shouldDirty || G.shouldTouch) && U(_, O, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && ke(_);
  }, de = (_, D, G) => {
    for (const Y in D) {
      const O = D[Y], z = `${_}.${Y}`, re = Ye(i, z);
      (l.array.has(_) || st(O) || re && !re._f) && !li(O) ? de(z, O, G) : ge(z, O, G);
    }
  }, le = (_, D, G = {}) => {
    const Y = Ye(i, _), O = l.array.has(_), z = bt(D);
    Gn(o, _, z), O ? (h.array.next({
      name: _,
      values: bt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && G.shouldDirty && h.state.next({
      name: _,
      dirtyFields: ra(a, o),
      isDirty: R(_, z)
    })) : Y && !Y._f && !Ot(z) ? de(_, z, G) : ge(_, z, G), Of(_, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? _ : void 0,
      values: bt(o)
    });
  }, pe = async (_) => {
    s.mount = !0;
    const D = _.target;
    let G = D.name, Y = !0;
    const O = Ye(i, G), z = (re) => {
      Y = Number.isNaN(re) || li(re) && isNaN(re.getTime()) || Jr(re, Ye(o, G, re));
    };
    if (O) {
      let re, fe;
      const be = D.type ? $f(O._f) : i_(_), en = _.type === ds.BLUR || _.type === ds.FOCUS_OUT, pn = !Cw(O._f) && !n.resolver && !Ye(r.errors, G) && !O._f.deps || Ew(en, Ye(r.touchedFields, G), r.isSubmitted, N, v), rn = Of(G, l, en);
      Gn(o, G, be), en ? (O._f.onBlur && O._f.onBlur(_), d && d(0)) : O._f.onChange && O._f.onChange(_);
      const dn = U(G, be, en), mn = !$t(dn) || rn;
      if (!en && h.state.next({
        name: G,
        type: _.type,
        values: bt(o)
      }), pn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && F() : en || F()), mn && h.state.next({ name: G, ...rn ? {} : dn });
      if (!en && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: ln } = await Q([G]);
        if (z(be), Y) {
          const vn = Pf(r.errors, i, G), Ze = Pf(ln, i, vn.name || G);
          re = Ze.error, G = Ze.name, fe = $t(ln);
        }
      } else
        y([G], !0), re = (await Lf(O, l.disabled, o, j, n.shouldUseNativeValidation))[G], y([G]), z(be), Y && (re ? fe = !1 : (u.isValid || f.isValid) && (fe = await J(i, !0)));
      Y && (O._f.deps && ke(O._f.deps), Z(G, fe, re, dn));
    }
  }, W = (_, D) => {
    if (Ye(r.errors, D) && _.focus)
      return _.focus(), 1;
  }, ke = async (_, D = {}) => {
    let G, Y;
    const O = za(_);
    if (n.resolver) {
      const z = await ie(rt(_) ? _ : O);
      G = $t(z), Y = _ ? !O.some((re) => Ye(z, re)) : G;
    } else _ ? (Y = (await Promise.all(O.map(async (z) => {
      const re = Ye(i, z);
      return await J(re && re._f ? { [z]: re } : re);
    }))).every(Boolean), !(!Y && !r.isValid) && F()) : Y = G = await J(i);
    return h.state.next({
      ...!Er(_) || (u.isValid || f.isValid) && G !== r.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: G } : {},
      errors: r.errors
    }), D.shouldFocus && !Y && Ua(i, W, _ ? O : l.mount), Y;
  }, Ce = (_) => {
    const D = {
      ...s.mount ? o : a
    };
    return rt(_) ? D : Er(_) ? Ye(D, _) : _.map((G) => Ye(D, G));
  }, K = (_, D) => ({
    invalid: !!Ye((D || r).errors, _),
    isDirty: !!Ye((D || r).dirtyFields, _),
    error: Ye((D || r).errors, _),
    isValidating: !!Ye(r.validatingFields, _),
    isTouched: !!Ye((D || r).touchedFields, _)
  }), qe = (_) => {
    _ && za(_).forEach((D) => ft(r.errors, D)), h.state.next({
      errors: _ ? r.errors : {}
    });
  }, Be = (_, D, G) => {
    const Y = (Ye(i, _, { _f: {} })._f || {}).ref, O = Ye(r.errors, _) || {}, { ref: z, message: re, type: fe, ...be } = O;
    Gn(r.errors, _, {
      ...be,
      ...D,
      ref: Y
    }), h.state.next({
      name: _,
      errors: r.errors,
      isValid: !1
    }), G && G.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (_, D) => fr(_) ? h.state.subscribe({
    next: (G) => _(q(void 0, D), G)
  }) : q(_, D, !0), Ue = (_) => h.state.subscribe({
    next: (D) => {
      Iw(_.name, D.name, _.exact) && Fw(D, _.formState || u, Re, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...r,
        ...D
      });
    }
  }).unsubscribe, je = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Ue({
    ..._,
    formState: f
  })), Le = (_, D = {}) => {
    for (const G of _ ? za(_) : l.mount)
      l.mount.delete(G), l.array.delete(G), D.keepValue || (ft(i, G), ft(o, G)), !D.keepError && ft(r.errors, G), !D.keepDirty && ft(r.dirtyFields, G), !D.keepTouched && ft(r.touchedFields, G), !D.keepIsValidating && ft(r.validatingFields, G), !n.shouldUnregister && !D.keepDefaultValue && ft(a, G);
    h.state.next({
      values: bt(o)
    }), h.state.next({
      ...r,
      ...D.keepDirty ? { isDirty: R() } : {}
    }), !D.keepIsValid && F();
  }, Te = ({ disabled: _, name: D }) => {
    (Qt(_) && s.mount || _ || l.disabled.has(D)) && (_ ? l.disabled.add(D) : l.disabled.delete(D));
  }, an = (_, D = {}) => {
    let G = Ye(i, _);
    const Y = Qt(D.disabled) || Qt(n.disabled);
    return Gn(i, _, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...D
      }
    }), l.mount.add(_), G ? Te({
      disabled: Qt(D.disabled) ? D.disabled : n.disabled,
      name: _
    }) : $(_, !0, D.value), {
      ...Y ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: ia(D.min),
        max: ia(D.max),
        minLength: ia(D.minLength),
        maxLength: ia(D.maxLength),
        pattern: ia(D.pattern)
      } : {},
      name: _,
      onChange: pe,
      onBlur: pe,
      ref: (O) => {
        if (O) {
          an(_, D), G = Ye(i, _);
          const z = rt(O.value) && O.querySelectorAll && O.querySelectorAll("input,select,textarea")[0] || O, re = xw(z), fe = G._f.refs || [];
          if (re ? fe.find((be) => be === z) : z === G._f.ref)
            return;
          Gn(i, _, {
            _f: {
              ...G._f,
              ...re ? {
                refs: [
                  ...fe.filter(ul),
                  z,
                  ...Array.isArray(Ye(a, _)) ? [{}] : []
                ],
                ref: { type: z.type, name: _ }
              } : { ref: z }
            }
          }), $(_, !1, void 0, z);
        } else
          G = Ye(i, _, {}), G._f && (G._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(a_(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, we = () => n.shouldFocusError && Ua(i, W, l.mount), We = (_) => {
    Qt(_) && (h.state.next({ disabled: _ }), Ua(i, (D, G) => {
      const Y = Ye(i, G);
      Y && (D.disabled = Y._f.disabled || _, Array.isArray(Y._f.refs) && Y._f.refs.forEach((O) => {
        O.disabled = Y._f.disabled || _;
      }));
    }, 0, !1));
  }, Xe = (_, D) => async (G) => {
    let Y;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let O = bt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: z, values: re } = await Q();
      r.errors = z, O = re;
    } else
      await J(i);
    if (l.disabled.size)
      for (const z of l.disabled)
        Gn(O, z, void 0);
    if (ft(r.errors, "root"), $t(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(O, G);
      } catch (z) {
        Y = z;
      }
    } else
      D && await D({ ...r.errors }, G), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $t(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, me = (_, D = {}) => {
    Ye(i, _) && (rt(D.defaultValue) ? le(_, bt(Ye(a, _))) : (le(_, D.defaultValue), Gn(a, _, bt(D.defaultValue))), D.keepTouched || ft(r.touchedFields, _), D.keepDirty || (ft(r.dirtyFields, _), r.isDirty = D.defaultValue ? R(_, bt(Ye(a, _))) : R()), D.keepError || (ft(r.errors, _), u.isValid && F()), h.state.next({ ...r }));
  }, he = (_, D = {}) => {
    const G = _ ? bt(_) : a, Y = bt(G), O = $t(_), z = O ? a : Y;
    if (D.keepDefaultValues || (a = G), !D.keepValues) {
      if (D.keepDirtyValues) {
        const re = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(ra(a, o))
        ]);
        for (const fe of Array.from(re))
          Ye(r.dirtyFields, fe) ? Gn(z, fe, Ye(o, fe)) : le(fe, Ye(z, fe));
      } else {
        if (Um && rt(_))
          for (const re of l.mount) {
            const fe = Ye(i, re);
            if (fe && fe._f) {
              const be = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (us(be)) {
                const en = be.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const re of l.mount)
          le(re, Ye(z, re));
      }
      o = bt(z), h.array.next({
        values: { ...z }
      }), h.state.next({
        values: { ...z }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? r.submitCount : 0,
      isDirty: O ? !1 : D.keepDirty ? r.isDirty : !!(D.keepDefaultValues && !Jr(_, a)),
      isSubmitted: D.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: O ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? ra(a, o) : r.dirtyFields : D.keepDefaultValues && _ ? ra(a, _) : D.keepDirty ? r.dirtyFields : {},
      touchedFields: D.keepTouched ? r.touchedFields : {},
      errors: D.keepErrors ? r.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (_, D) => he(fr(_) ? _(o) : _, D), Ae = (_, D = {}) => {
    const G = Ye(i, _), Y = G && G._f;
    if (Y) {
      const O = Y.refs ? Y.refs[0] : Y.ref;
      O.focus && (O.focus(), D.shouldSelect && fr(O.select) && O.select());
    }
  }, Re = (_) => {
    r = {
      ...r,
      ..._
    };
  }, C = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Xe,
      setError: Be,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: R,
      _setValid: F,
      _setFieldArray: H,
      _setDisabledField: Te,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => fr(n.defaultValues) && n.defaultValues().then((_) => {
        Ie(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: je,
    trigger: ke,
    register: an,
    handleSubmit: Xe,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...C,
    formControl: C
  };
}
function lr(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: fr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: fr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Rw(e),
    formState: i
  }, e.formControl && e.defaultValues && !fr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Jr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !$t(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = l_(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ml = { exports: {} }, aa = {}, Vf;
function Ow() {
  if (Vf) return aa;
  Vf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return aa.Fragment = r, aa.jsx = s, aa.jsxs = s, aa;
}
var ko = {}, zf;
function Pw() {
  return zf || (zf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    ko.Fragment = i, ko.jsx = Rn, ko.jsxs = Bn;
  })()), ko;
}
var Uf;
function Aw() {
  return Uf || (Uf = 1, process.env.NODE_ENV === "production" ? ml.exports = Ow() : ml.exports = Pw()), ml.exports;
}
var _e = Aw();
const Lw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, Vw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, zw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, Uw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, Mw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, Bw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, qw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Hw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, Ww = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zw,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": Uw,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": Mw,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Lw,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": Vw,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Bw,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": qw,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": Hw
};
function Hi(e) {
  return Ww[e] ?? {};
}
const Kw = Hi(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), Gw = Hi(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Yw = Hi(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Mf = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, rr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, Jw = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Bf = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Zu = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ _e.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ _e.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function Qw({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: N, executeQuery: j } = un(), { track: w } = kn(), {
    loading: F,
    data: y,
    error: H,
    store: T
  } = wm(e ?? null), E = y?.github?.issues || [], $ = y?.github?.pullRequests || [], [U, Z] = se(!1), [Q, ie] = se();
  He(
    () => h(H || Q || void 0),
    [H, Q]
  ), He(
    () => {
      !F && (E?.length || $?.length) ? (a(E), s($), M(E, $)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const J = async (pe, W) => {
    await T(pe).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((ke) => {
      v({
        title: W.error.title,
        text: `${W.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, M = (pe, W) => {
    if (!pe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const ke = (pe || []).map(
      (qe) => j(Gw, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), Ce = (W || []).map(
      (qe) => j(Yw, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), K = [...ke, ...Ce];
    Z(!0), Promise.all(K).then((qe) => {
      const Be = [], Pe = [];
      qe.forEach((Ue) => {
        const je = Ue?.data?.GitHub;
        if (!je) {
          d([]), u([]);
          return;
        }
        Object.keys(je).forEach((Le) => {
          if (Le.startsWith("repository")) {
            const Te = je[Le];
            Object.keys(Te).forEach((an) => {
              const we = Te[an], We = {
                number: we?.number,
                owner: we?.repository?.owner?.login,
                repository: we?.repository?.name
              };
              an.startsWith("issue") && Be.push({
                ...we,
                type: "ISSUE",
                key: We
              }), an.startsWith("pullRequest") && Pe.push({
                ...we,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), d(Be), u(Pe);
    }).catch(ie).finally(() => {
      Z(!1);
    });
  }, R = ({ key: pe, type: W }) => {
    w("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = y && (E.length || $.length) ? y : r, Ce = W === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ce] = Array.from(
      new Set(ke.github[Ce]).add(pe)
    ), J(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${rr(
          pe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${rr(pe)} failed. Please try again.`
      }
    });
  }, q = async ({ key: pe, type: W }) => {
    w("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = y && (E.length || $.length) ? y : r, Ce = W === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ce] = Array.from(
      new Set(ke.github[Ce]).add(pe)
    ), await T(ke).catch((K) => {
      v({
        title: "Linking failed",
        text: `Linking ${pe} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: pe, type: W }) => {
    w("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = W === "ISSUE" ? "issue" : "pull request";
    N({
      headline: `Unlink ${ke} ${rr(pe)}?`,
      text: `You are about to unlink the ${ke} ${rr(
        pe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Ce]: y?.github?.[Ce].filter(
              (qe) => qe.number !== pe.number || qe.owner !== pe.owner || qe.repository !== pe.repository
            )
          }
        };
        w("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), J(K, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${rr(
              pe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${rr(pe)} failed.`
          }
        });
      },
      onCancel: () => {
        w("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ge = () => {
    w("github:unlink:all:clicked", {
      githubOrganization: n
    }), N({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        w("github:unlink:all:confirmed", {
          githubOrganization: n
        }), J(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        w("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, de = E.filter(
    (pe) => !i?.includes(pe)
  ) || [], le = $.filter(
    (pe) => !o?.includes(pe)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: q,
    unlinkGithubItem: ee,
    loadGithubItems: M,
    removeDanglingGithubItemLinks: () => {
      const pe = {
        ...y,
        github: {
          ...y?.github,
          issues: E.filter(
            (W) => !de.includes(W)
          ) || [],
          pullRequests: $.filter(
            (W) => !le.includes(W)
          ) || []
        }
      };
      T(pe);
    },
    unlinkAllGithubItems: ge,
    isLoadingGithubItemLinks: F,
    danglingIssueLinks: de,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const Xw = "_contentWrapper_1vx3c_1", Zw = "_contentWrapperHeadline_1vx3c_4", eC = "_contentWrapperBody_1vx3c_11", nC = "_contentWrapperAssigneeIcon_1vx3c_15", tC = "_contentWrapperStatusTag_1vx3c_20", Vr = {
  contentWrapper: Xw,
  contentWrapperHeadline: Zw,
  contentWrapperBody: eC,
  contentWrapperAssigneeIcon: nC,
  contentWrapperStatusTag: tC
}, y_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
  e && /* @__PURE__ */ _e.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ _e.jsxs(Qn, { className: Vr.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ _e.jsxs(Qn, { margin: "100 0", children: [
        /* @__PURE__ */ _e.jsx(
          "img",
          {
            className: Vr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ _e.jsx(Qn, { className: Vr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ _e.jsx(
      Pn,
      {
        className: Vr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), rC = "_collapse_1bdjy_1", iC = "_collapseHeader_1bdjy_10", aC = "_collapseHeaderKey_1bdjy_31", oC = "_collapseHeaderKeyIcon_1bdjy_36", sC = "_collapseHeaderKeyLink_1bdjy_41", lC = "_collapseHeaderIcon_1bdjy_44", cC = "_collapseHeaderTitle_1bdjy_49", dC = "_collapseContent_1bdjy_57", uC = "_collapseContentButtonSpacer_1bdjy_60", mC = "_collapseContentButtonLink_1bdjy_63", Nr = {
  collapse: rC,
  collapseHeader: iC,
  collapseHeaderKey: aC,
  collapseHeaderKeyIcon: oC,
  collapseHeaderKeyLink: sC,
  collapseHeaderIcon: lC,
  collapseHeaderTitle: cC,
  collapseContent: dC,
  collapseContentButtonSpacer: uC,
  collapseContentButtonLink: mC
}, pC = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ _e.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: N,
      type: j,
      state: w,
      assignees: F,
      labels: y
    } = d, H = a[m];
    return /* @__PURE__ */ _e.jsxs(
      ar,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: H,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ _e.jsx(ar.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ _e.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _e.jsx(Qn, { children: /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: Nr.collapseHeaderKey, children: [
                  Zu(
                    j,
                    w,
                    Nr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ _e.jsxs(
                    "a",
                    {
                      href: Mf(f),
                      className: Nr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        rr(f),
                        /* @__PURE__ */ _e.jsx(
                          ue,
                          {
                            className: Nr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ _e.jsx(Qn, { className: Nr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ _e.jsx(ar.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ _e.jsx(
              y_,
              {
                description: v,
                assignees: F,
                labels: y
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: N?.owner.login,
                    repository: d.repository.name
                  },
                  type: j
                }),
                children: [
                  "Unlink ",
                  Bf(j)
                ]
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              St,
              {
                slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Mf(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Bf(j),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ _e.jsx(_e.Fragment, {}) });
}, fC = "_result_1uaom_1", hC = "_resultName_1uaom_21", yC = "_resultItemIcon_1uaom_29", gC = "_resultDescription_1uaom_34", vC = "_resultLinkIcon_1uaom_46", kC = "_tooltip_1uaom_55", bC = "_tooltipName_1uaom_61", _C = "_tooltipTag_1uaom_71", zr = {
  result: fC,
  resultName: hC,
  resultItemIcon: yC,
  resultDescription: gC,
  resultLinkIcon: vC,
  tooltip: kC,
  tooltipName: bC,
  tooltipTag: _C
}, xC = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ _e.jsx(
    Ge,
    {
      className: zr.tooltip,
      content: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: zr.tooltipName, children: [
                Zu(a, o, zr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ _e.jsx(Pn, { className: zr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ _e.jsx(
          y_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ _e.jsxs(
        "button",
        {
          className: zr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ _e.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsxs(Qn, { as: "span", className: zr.resultName, children: [
                    Zu(a, o, zr.resultItemIcon),
                    rr(r)
                  ] }) }),
                  /* @__PURE__ */ _e.jsx(Qn, { className: zr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ _e.jsx(
              ue,
              {
                className: zr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, SC = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ _e.jsx(
  St,
  {
    slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), fs = "[a-zA-z0-9_.-]+", g_ = "[0-9]+", NC = new RegExp(
  `(${fs})/(${fs})/(?:issues|pull)/(${g_})`,
  "i"
), qf = new RegExp(`^${NC.source}$`), Hf = new RegExp(
  `https://github.com/(${fs})/(${fs})/(?:issues|pull)/(${g_})`,
  "i"
), jC = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = qn(() => r?.map(($) => $.id) || [], [r]), o = qn(() => i?.map(($) => $.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = un(), [m, u] = se(), [f, { loading: h, error: v, data: N, networkStatus: j }] = d(Kw, {
    notifyOnNetworkStatusChange: !0
  });
  gi(
    () => {
      !h && m && j === Gt.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), He(() => {
    let $ = N?.GitHub?.issues?.nodes || [], U = N?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && ($ = $.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...$.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [N, a, o]);
  function w($) {
    const U = $?.trim();
    if (qf.test(U)) {
      const [Z, Q, ie, J] = U.match(qf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(J)
      };
    }
    if (Hf.test(U)) {
      const [Z, Q, ie, J] = U.match(Hf) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(J)
      };
    }
  }
  const F = ($) => {
    e({
      key: Jw($),
      type: $.type
    }), u(void 0);
  }, y = ($) => {
    const U = w($);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${$}`
    );
  }, H = () => {
    u(void 0);
  }, T = ({ className: $, searched: U }) => /* @__PURE__ */ _e.jsx(
    SC,
    {
      className: $,
      searched: U,
      githubOrganization: n
    }
  ), E = ({ item: $, onSelect: U }) => /* @__PURE__ */ _e.jsx(xC, { item: $, onSelect: U });
  return !h && v ? /* @__PURE__ */ _e.jsx(In, { error: v }) : /* @__PURE__ */ _e.jsx(
    _r,
    {
      items: s?.map(($) => ({ name: $.title, ...$ })),
      loading: h,
      onSearch: y,
      onSelect: F,
      onClear: H,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: E,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, wC = "_itemButton_3sxfy_1", CC = "_result_3sxfy_6", FC = "_resultName_3sxfy_30", IC = "_resultCheckIcon_3sxfy_38", EC = "_resultAssigneeIcon_3sxfy_41", oa = {
  itemButton: wC,
  result: CC,
  resultName: FC,
  resultCheckIcon: IC,
  resultAssigneeIcon: EC
}, v_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ _e.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ _e.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: oa.itemButton,
        children: /* @__PURE__ */ _e.jsxs(b, { className: oa.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ _e.jsx(Qn, { margin: "100 0", children: /* @__PURE__ */ _e.jsx(
            "img",
            {
              className: oa.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ _e.jsx(Qn, { className: oa.resultName, children: e.name }),
          n && /* @__PURE__ */ _e.jsx(Qn, { className: oa.resultCheckIcon, children: /* @__PURE__ */ _e.jsx(ue, { name: "done" }) })
        ] })
      }
    )
  }
), TC = Hi(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), $C = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: N }] = a(
    TC,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return gi(
    () => {
      !f && l && l.length >= m && N === Gt.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const j = v?.GitHub?.organization?.teams || { edges: [] }, w = [];
    j?.edges?.forEach((F) => {
      const y = F?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((H) => {
        const T = H?.node;
        T && (T?.id && w.find((E) => E.id === T.id) || w.push(T));
      });
    }), s(
      w.sort((F, y) => {
        const H = F.name?.toLowerCase() || F.login?.toLowerCase(), T = y.name?.toLowerCase() || y.login?.toLowerCase();
        return H.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ _e.jsx(In, { error: h }) : /* @__PURE__ */ _e.jsx(
    _r,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: j, name: w, login: F, avatarUrl: y }) => ({
        id: j,
        name: w || F,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (j) => d(j),
      onChange: (j, w) => {
        const F = j.id;
        i ? (w && !n.find(
          (y) => y.id === F
        ) && n.push(j), w || (n = n.filter(
          (y) => y.id !== F
        ))) : n = w ? [j] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: j, onSelect: w, checked: F }) => /* @__PURE__ */ _e.jsx(
        v_,
        {
          item: j,
          checked: F,
          onSelectItem: w
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, DC = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ _e.jsx(kr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ _e.jsx(
        _r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ _e.jsx(
        Ts,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ _e.jsx(kr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ _e.jsx(
        _r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ _e.jsx(kr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ _e.jsx(Bu, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ _e.jsx(
        $C,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, RC = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ _e.jsx(
  Lt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ _e.jsx(
      Ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: DC({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), OC = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ _e.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ _e.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ _e.jsx(ue, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ _e.jsx(Ln, { label: "GitHub issue link", children: /* @__PURE__ */ _e.jsx(
          kr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, PC = "_modalBody_1hk1o_1", AC = "_modalBodyFormFields_1hk1o_4", pl = {
  modalBody: PC,
  modalBodyFormFields: AC
}, LC = Hi(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), VC = Hi(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), zC = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], UC = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = un(), { track: d } = kn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = lr(), [N, j] = se(""), [w, F] = se([]), [y, H] = se(), [T, E] = se(!1), [$, U] = se(!1), [Z, Q] = t_(), [
    ie,
    {
      loading: J,
      error: M,
      networkStatus: R
    }
  ] = s(LC, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      F(
        Ce.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), F([]);
    }
  });
  gi(
    () => {
      !J && N && R === Gt.ready ? ie({
        variables: {
          query: N,
          maxResults: 10
        }
      }) : F([]);
    },
    500,
    [N]
  );
  const [q, { error: ee }] = l(
    VC,
    {
      onError: (Ce) => {
        E(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        E(!1);
        const K = Ce.GitHub.createIssue?.issue;
        H(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ge = (Ce) => {
    j(`org:${a} ${Ce}`);
  }, de = (Ce, K) => {
    K(Ce), j("");
  }, le = () => {
    j("");
  }, pe = (Ce) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), E(!0), q({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  He(() => {
    const Ce = $ ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [$]);
  const W = () => {
    j(""), F([]), H(void 0), E(!1), U(!1);
  }, ke = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ _e.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ _e.jsx(
          jt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ _e.jsxs(wt, { className: pl.modalBody, children: [
          !J && M && /* @__PURE__ */ _e.jsx(In, { error: M }),
          !T && ee && /* @__PURE__ */ _e.jsx(In, { error: ee }),
          y ? /* @__PURE__ */ _e.jsx(
            OC,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: $,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ _e.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(pe),
              children: /* @__PURE__ */ _e.jsxs(Ut, { children: [
                /* @__PURE__ */ _e.jsx(tn, { children: /* @__PURE__ */ _e.jsx(Ln, { label: "Repository", required: !0, children: /* @__PURE__ */ _e.jsx(
                  Lt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: K } }) => /* @__PURE__ */ _e.jsx(
                      _r,
                      {
                        className: pl.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: ge,
                        onSelect: (qe) => de(qe, Ce),
                        onClear: le,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: M ? "No repositories found" : "No repositories available",
                        items: w || [],
                        itemComponent: ({ item: qe, onSelect: Be, checked: Pe }) => /* @__PURE__ */ _e.jsx(
                          v_,
                          {
                            item: qe,
                            checked: Pe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ _e.jsx(tn, { className: pl.modalBodyFormFields, children: /* @__PURE__ */ _e.jsx(
                  RC,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: zC
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ _e.jsx(
          It,
          {
            confirmOnClick: y ? ke : u(pe),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ _e.jsx(cn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : ke
          }
        )
      ]
    }
  );
}, MC = "_wrapper_19v8w_1", BC = "_inputWrapper_19v8w_6", qC = "_buttonLink_19v8w_19", HC = "_noItemsFound_19v8w_23", WC = "_createIssueButton_19v8w_28", Si = {
  wrapper: MC,
  inputWrapper: BC,
  buttonLink: qC,
  noItemsFound: HC,
  createIssueButton: WC
}, KC = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = kn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: N,
    danglingPullRequestLinks: j,
    isLoadingGithubItems: w,
    issues: F,
    pullRequests: y,
    error: H
  } = Qw({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (Q) => d({ key: Q, type: "ISSUE" }), E = !(!!F?.length).valueOf() && !(!!y?.length).valueOf() && !(!!N?.length).valueOf() && !(!!j?.length).valueOf(), $ = !v && !w && !!N?.length && !!j?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!F?.length || !!y?.length;
  return !w && H ? /* @__PURE__ */ _e.jsx(In, { error: H, retry: () => u() }) : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { className: Si.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsxs(b, { className: Si.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
          /* @__PURE__ */ _e.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Si.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ _e.jsx("div", { className: Si.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ _e.jsx(
          jC,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: F,
            linkedPullRequests: y
          }
        )
      ] }),
      w ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(cn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ _e.jsx(
        pC,
        {
          items: [...F, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ _e.jsx(A.Paragraph, { align: "center", className: Si.noItemsFound, children: "No linked items found." }),
      $ && /* @__PURE__ */ _e.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ _e.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ _e.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              N.map((Q) => /* @__PURE__ */ _e.jsx(
                Pn,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: rr(Q)
                },
                rr(Q)
              )),
              j.map((Q) => /* @__PURE__ */ _e.jsx(
                Pn,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: rr(Q)
                },
                rr(Q)
              ))
            ] }),
            /* @__PURE__ */ _e.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ _e.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: E,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ _e.jsx(
        St,
        {
          slotEnd: /* @__PURE__ */ _e.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: Si.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsx(
      UC,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, GC = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: eo
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fl = { exports: {} }, sa = {}, Wf;
function YC() {
  if (Wf) return sa;
  Wf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return sa.Fragment = r, sa.jsx = s, sa.jsxs = s, sa;
}
var bo = {}, Kf;
function JC() {
  return Kf || (Kf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    bo.Fragment = i, bo.jsx = Rn, bo.jsxs = Bn;
  })()), bo;
}
var Gf;
function QC() {
  return Gf || (Gf = 1, process.env.NODE_ENV === "production" ? fl.exports = YC() : fl.exports = JC()), fl.exports;
}
var Ee = QC(), Pa = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Pa || {}), ai = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ai || {}), Mt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Mt || {});
const XC = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ZC = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": XC
};
function e1(e) {
  return ZC[e] ?? {};
}
const n1 = e1(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Yf = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, k_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, t1 = "_listItem_16pij_4", r1 = "_clickableIcon_16pij_15", hs = {
  listItem: t1,
  clickableIcon: r1
}, b_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Ee.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: hs.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Ee.jsx(Ke, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, N = l.currency ?? r;
      return /* @__PURE__ */ Ee.jsx(
        Ke.Item,
        {
          contentLeft: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: u }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: k_(f / 100, N) })
          ] }),
          contentRight: h && /* @__PURE__ */ Ee.jsx(Mi, { src: h, alt: m ?? "Product image" }),
          className: hs.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, i1 = "_boxWrapper_89s7l_1", a1 = "_trackButton_89s7l_10", Jf = {
  boxWrapper: i1,
  trackButton: a1
}, o1 = {
  [Mt.StepUnknown]: "Unknown",
  [Mt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Mt.StepPreparedByMerchant]: "Prepared by merchant",
  [Mt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Mt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Mt.StepOnRoute]: "On route",
  [Mt.StepDeliveredToPickupPoint]: "At pickup point",
  [Mt.StepDeliveredToConsumer]: "Delivered to customer",
  [Mt.StepDeliveredToMerchant]: "Returned to merchant",
  [Mt.StepReturnRequested]: "Return requested",
  [Mt.StepSentBack]: "Sent back",
  [Mt.StepTerminated]: "Terminated",
  [Mt.StepAwaitingSupplier]: "Awaiting supplier"
}, s1 = {
  [ai.Delivery]: "Home delivery",
  [ai.Pickup]: "Pickup point",
  [ai.Instore]: "In-store pickup",
  [ai.Mailbox]: "Mailbox",
  [ai.Inwarehouse]: "Warehouse",
  [ai.Unknown]: "Unknown"
}, l1 = {
  [Pa.Outbound]: "From merchant to customer",
  [Pa.Return]: "Return from customer to merchant",
  [Pa.Unspecified]: "Unspecified",
  [Pa.UnknownDirectionType]: "Unknown"
}, c1 = (e) => e ? o1[e] ?? e : "", d1 = (e) => e ? s1[e] ?? e : "", u1 = (e) => e ? l1[e] ?? e : "", m1 = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, p1 = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = er();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, N = a?.filter((T) => T?.time !== ""), j = c1(N?.[0]?.step), w = d1(u), F = u1(f), y = m1(e.location?.address), H = 14;
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Jf.boxWrapper,
      children: [
        /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: H,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Ee.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ee.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ Ee.jsx(
            ue,
            {
              size: H,
              name: n ? "done" : "copy",
              className: hs.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        j && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        F && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: F })
          ] })
        ] }),
        h && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Yf(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Yf(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        y && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(ue, { size: H, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ Ee.jsx(b_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ Ee.jsxs(
          St,
          {
            variant: "secondary",
            className: Jf.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Ee.jsx(ue, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, f1 = "_order_135ze_1", h1 = "_orderIsOpen_135ze_9", y1 = "_orderHeader_135ze_12", hl = {
  order: f1,
  orderIsOpen: h1,
  orderHeader: y1
}, g1 = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = er();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: d,
    sender_name: m,
    tos_id: u
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, v = k_(h / 100, f), N = 14, j = m && m.trim() !== "" ? m : "unknown sender";
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      className: ut(hl.order, {
        [hl.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: hl.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  j
                ] }),
                /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  d
                ] })
              ] }),
              /* @__PURE__ */ Ee.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ee.jsx(
                ue,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !u && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  u && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: u })
                ] })
              ] })
            ] }),
            u && /* @__PURE__ */ Ee.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ee.jsx(Ge, { content: "Copy tracking ID", children: /* @__PURE__ */ Ee.jsx(
              ue,
              {
                size: N,
                name: a ? "done" : "copy",
                className: hs.clickableIcon,
                onClick: () => o(u)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ Ee.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ee.jsx(ue, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: v })
            ] })
          ] }),
          /* @__PURE__ */ Ee.jsx(
            b_,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((w) => w),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ Ee.jsx(Un, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((w, F) => /* @__PURE__ */ Ee.jsx(
              p1,
              {
                parcel: w
              },
              `parcel-${F}-${w?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, v1 = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, k1 = ({
  customerEmail: e
}) => {
  const { useQuery: n } = un(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(n1, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? RS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? hb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return He(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(v1(f.orders));
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ee.jsx(cn, {}) }) : m || !d && !l ? /* @__PURE__ */ Ee.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Ee.jsx(A.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Ee.jsx(In, { error: l }) : /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Ee.jsx(Un, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Ee.jsx(
      g1,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, b1 = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Ee.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Ee.jsx(k1, { customerEmail: n })
    }
  );
}, _1 = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yl = { exports: {} }, la = {}, Qf;
function x1() {
  if (Qf) return la;
  Qf = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return la.Fragment = r, la.jsx = s, la.jsxs = s, la;
}
var _o = {}, Xf;
function S1() {
  return Xf || (Xf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    _o.Fragment = i, _o.jsx = Rn, _o.jsxs = Bn;
  })()), _o;
}
var Zf;
function N1() {
  return Zf || (Zf = 1, process.env.NODE_ENV === "production" ? yl.exports = x1() : yl.exports = S1()), yl.exports;
}
var ye = N1();
const Km = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Km(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, j1 = "_jiraCode_h30p6_1", w1 = "_jiraCodeInline_h30p6_8", gl = {
  jiraCode: j1,
  jiraCodeInline: w1
}, __ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ ye.jsx(ye.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ ye.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ ye.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ ye.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ ye.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ ye.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ ye.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ ye.jsx("pre", { children: /* @__PURE__ */ ye.jsx("code", { className: gl.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ ye.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ ye.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ ye.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ ye.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ ye.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ ye.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ ye.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ ye.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ ye.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ ye.jsx("code", { className: ut(gl.jiraCode, gl.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ys = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ ye.jsx(ue, { size: r, name: "question", className: n }) : /* @__PURE__ */ ye.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, C1 = "_collapse_m2gjh_1", F1 = "_collapseHeader_m2gjh_10", I1 = "_collapseHeaderLink_m2gjh_31", E1 = "_collapseHeaderStatus_m2gjh_40", T1 = "_collapseHeaderTitle_m2gjh_51", $1 = "_collapseContent_m2gjh_59", D1 = "_collapseContentHeadline_m2gjh_62", R1 = "_collapseContentButtonSpacer_m2gjh_68", O1 = "_collapseContentButtonLink_m2gjh_71", P1 = "_collapseContentStatusTag_m2gjh_74", A1 = "_collapseContentDescription_m2gjh_77", ur = {
  collapse: C1,
  collapseHeader: F1,
  collapseHeaderLink: I1,
  collapseHeaderStatus: E1,
  collapseHeaderTitle: T1,
  collapseContent: $1,
  collapseContentHeadline: D1,
  collapseContentButtonSpacer: R1,
  collapseContentButtonLink: O1,
  collapseContentStatusTag: P1,
  collapseContentDescription: A1
}, x_ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, L1 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = kn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = x_({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), N = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ ye.jsxs(
      ar,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: N,
        className: ur.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(ar.Header, { className: ur.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ ye.jsx(ys, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ ye.jsx(
                      "a",
                      {
                        className: ur.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (j) => {
                          j.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ ye.jsx(ue, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ ye.jsx("span", { className: ur.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ ye.jsx(Pn, { className: ur.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ ye.jsx("div", { className: ur.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(ar.Content, { className: ur.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx("div", { className: ur.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ ye.jsx(Qn, { className: ur.collapseContentDescription, children: u ? Km(u, __) : "" }),
            /* @__PURE__ */ ye.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: ur.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ ye.jsx(
              St,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
                variant: "tertiary",
                className: ur.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, V1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, z1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, U1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, M1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, B1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, q1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, H1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, W1 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': V1,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": z1,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": U1,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": M1,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': B1,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': q1,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": H1
};
function vi(e) {
  return W1[e] ?? {};
}
const S_ = vi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), K1 = vi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), G1 = vi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), Y1 = vi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), J1 = vi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), Q1 = vi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), X1 = vi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Gm = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), Z1 = new RegExp(`^${Gm.source}$`), eF = new RegExp(`/${Gm.source}$`), eh = new RegExp(
  `.+?[&?]selectedIssue=(${Gm.source})[&?]?.*`
);
function N_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = kn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = un(), {
    loading: N,
    data: j,
    error: w,
    store: F
  } = wm(e ?? null), [
    y,
    { loading: H, error: T, data: E }
  ] = h(S_, {
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    const le = E?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((pe) => pe?.key).filter(Boolean)));
  }, [E]), He(
    () => d(w || T || void 0),
    [w, T]
  ), He(
    () => {
      N || M();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [j?.jira?.issues, N]
  );
  const $ = async (le, pe) => {
    await F(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: pe.success.title,
        text: pe.success.text
      });
    }).catch((W) => {
      u({
        title: pe.error.title,
        text: `${pe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v(K1, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (le, pe) => {
    const W = window.location.href, ke = pe ? W.replace(
      e?.toString() ?? "",
      pe?.toString()
    ) : W, Ce = pe ? `# ${pe}` : `# ${e}`;
    U({
      variables: {
        issueKey: le,
        title: Ce,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [Q] = v(G1, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ie = (le) => {
    const pe = window.location.href;
    Q({
      variables: {
        issueKey: le,
        globalId: `system=${pe}`
      }
    });
  }, J = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), M = () => {
    j && j.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${j?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (le, pe) => {
    m("jira:issue:link:clicked", J(le));
    const W = j?.jira?.issues ? j : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(le)
    ), await F(W, pe?.toString()).then(() => Z(le, pe)).catch((ke) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (le) => {
    m("jira:issue:link:clicked", J(le));
    const pe = j?.jira?.issues ? j : r;
    pe.jira.issues = Array.from(
      new Set(pe.jira.issues).add(le)
    ), $(pe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => Z(le));
  }, ee = (le) => {
    m("jira:issue:unlink:clicked", J(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", J(le));
        const pe = {
          ...j,
          jira: {
            ...j?.jira,
            issues: j?.jira?.issues.filter((W) => W !== le) || []
          }
        };
        $(pe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => ie(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", J(le))
    });
  }, ge = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && ie(le.key)), $(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, de = j?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: R,
    unlinkIssue: ee,
    loadIssues: M,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...j,
        jira: {
          ...j?.jira,
          issues: j?.jira?.issues.filter(
            (pe) => !de.includes(pe)
          ) || []
        }
      };
      F(le);
    },
    unlinkAllIssues: ge,
    maybeExtractIssueKey: (le) => {
      const pe = le.replace(/\s/g, "");
      if (Z1.test(pe))
        return pe;
      if (eh.test(le))
        return le.match(eh)?.[1];
      if (le.startsWith(n) && eF.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: N,
    danglingIssueLinks: de,
    isLoadingIssues: H,
    issues: o,
    error: l
  };
}
function nF(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const tF = "_result_axxxc_48", rF = "_resultName_axxxc_68", iF = "_resultNameIcon_axxxc_76", aF = "_resultDescription_axxxc_81", oF = "_resultLinkIcon_axxxc_93", sF = "_tooltip_axxxc_102", lF = "_tooltipContent_axxxc_108", cF = "_tooltipName_axxxc_115", dF = "_tooltipNameIcon_axxxc_120", uF = "_tooltipDescription_axxxc_125", mF = "_tooltipSummary_axxxc_133", pF = "_tooltipTag_axxxc_137", tr = {
  result: tF,
  resultName: rF,
  resultNameIcon: iF,
  resultDescription: aF,
  resultLinkIcon: oF,
  tooltip: sF,
  tooltipContent: lF,
  tooltipName: cF,
  tooltipNameIcon: dF,
  tooltipDescription: uF,
  tooltipSummary: mF,
  tooltipTag: pF
}, fF = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = x_({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ ye.jsx(
    Ge,
    {
      disabled: i,
      className: tr.tooltip,
      content: /* @__PURE__ */ ye.jsxs("div", { className: tr.tooltipContent, children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ ye.jsxs("span", { className: tr.tooltipName, children: [
                /* @__PURE__ */ ye.jsx(
                  ys,
                  {
                    width: 16,
                    iconUrl: h,
                    className: tr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ ye.jsx(Pn, { className: tr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ ye.jsx("div", { className: tr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ ye.jsx("div", { className: tr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          ...a,
          className: tr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs("span", { className: tr.resultName, children: [
                    /* @__PURE__ */ ye.jsx(
                      ys,
                      {
                        width: 16,
                        iconUrl: h,
                        className: tr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ ye.jsx("div", { className: tr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ ye.jsx(
              ue,
              {
                className: tr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, hF = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ ye.jsx(
  St,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), yF = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(S_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: N } = N_(null, n);
  gi(
    () => {
      !u && l && v === Gt.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((E) => ({
        id: E?.key ?? "",
        name: E?.key ?? "",
        description: E?.fields.summary,
        status: E?.fields.status,
        issuetype: E?.fields.issuetype,
        text: E?.fields.description ? Km(E?.fields.description, __) : /* @__PURE__ */ ye.jsx(ye.Fragment, {})
      }))
    );
  }, [h]);
  const j = (T) => {
    e(T.id), d("");
  }, w = (T) => {
    const E = T.trim(), $ = N(E);
    if ($) {
      const U = $.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else E !== "" && d(
      `text ~ '${E}'${r ? " and project = " + r : ""}`
    );
  }, F = () => {
    d("");
  }, y = (T) => /* @__PURE__ */ ye.jsx(hF, { ...T, jiraInstanceUrl: n }), H = (T) => /* @__PURE__ */ ye.jsx(
    fF,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ ye.jsx(In, { error: f }) : /* @__PURE__ */ ye.jsx(
    _r,
    {
      items: o,
      loading: u,
      onSearch: w,
      onSelect: j,
      onClear: F,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: H,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, gF = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return He(() => {
    r(i);
  }, [i]), /* @__PURE__ */ ye.jsx(
    _r,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, vF = "_itemButton_1hl53_1", kF = "_result_1hl53_6", bF = "_resultIcon_1hl53_26", _F = "_resultName_1hl53_30", xF = "_resultCheckIcon_1hl53_38", ca = {
  itemButton: vF,
  result: kF,
  resultIcon: bF,
  resultName: _F,
  resultCheckIcon: xF
}, em = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ ye.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ ye.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: ca.itemButton,
          children: /* @__PURE__ */ ye.jsxs(b, { className: ca.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ ye.jsx(
              ys,
              {
                width: 36,
                iconUrl: o || "",
                className: ca.resultIcon
              }
            ),
            /* @__PURE__ */ ye.jsx(Qn, { className: ca.resultName, children: e.name }),
            n && /* @__PURE__ */ ye.jsx(Qn, { className: ca.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(ue, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, SF = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: N }] = a(X1, {
    notifyOnNetworkStatusChange: !0
  });
  return gi(
    () => {
      !f && l && l.length >= m && N === Gt.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((j) => {
      if (j?.data?.Jira.findUsers?.length === 1) {
        const w = j?.data?.Jira?.findUsers[0];
        r(w.accountId), s([
          {
            id: w.accountId,
            name: w.displayName
          }
        ]);
      }
    });
  }, []), He(() => {
    const j = v?.Jira?.findUsers || [];
    s(
      j.filter(({ active: w }) => w).map(({ accountId: w, displayName: F, avatarUrls: y, active: H }) => ({
        id: w,
        name: F,
        avatarUrls: y,
        active: H
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ ye.jsx(In, { error: h }) : /* @__PURE__ */ ye.jsx(
    _r,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (j) => d(j),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: j, onSelect: w, checked: F }) => /* @__PURE__ */ ye.jsx(
        em,
        {
          item: j,
          checked: F,
          onSelectItem: w,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, nh = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = t_();
  return He(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ ye.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ ye.jsx(b, { children: /* @__PURE__ */ ye.jsx(ue, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ ye.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ ye.jsx(Ge, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ ye.jsx(
      Yt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, NF = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ ye.jsx(nh, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ ye.jsx(Bu, { onChange: n, value: r }) : /* @__PURE__ */ ye.jsx(kr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(Bu, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ ye.jsx(kr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        SF,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ ye.jsx(
        _r,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ ye.jsx(gF, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ ye.jsx(nh, { field: e });
  }
}, jF = ["description", "reporter", "summary"], wF = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || jF.includes(o)
).map((o) => /* @__PURE__ */ ye.jsx(
  Lt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      Ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: NF({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), CF = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ ye.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ ye.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ ye.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ ye.jsx(ue, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ ye.jsx(Ln, { label: "Jira issue link", children: /* @__PURE__ */ ye.jsx(
        kr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), FF = "_modalBody_1hk1o_1", IF = "_modalBodyFormFields_1hk1o_4", th = {
  modalBody: FF,
  modalBodyFormFields: IF
}, EF = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), TF = (e) => e?.custom?.split(":")?.[1] || null, $F = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, DF = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = $F(a, n), l = TF(s) ?? a;
        return r.includes(l) ? i[a] = EF(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, RF = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, N] = se([]), [j, w] = se([]), [F, y] = se(!1), [H, T] = se(!1), [E, $] = se({}), { track: U } = kn(), { isCopied: Z, copyToClipboard: Q } = nF(), ie = qn(() => i?.conversationId, [e]), { useMutation: J, useLazyQuery: M, showNotification: R } = un(), {
    control: q,
    handleSubmit: ee,
    formState: { errors: ge },
    reset: de,
    setValue: le,
    getValues: pe
  } = lr({
    defaultValues: s
  }), W = j.length > 0, ke = `${a}/browse`, Ce = Object.keys(E).length > 0, [K, { loading: qe, error: Be }] = M(Y1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      d(he.Jira.getAllProjects);
    },
    onError: (he) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", he), d([]);
    }
  }), [
    Pe,
    { loading: Ue, error: je }
  ] = M(J1, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (he) => {
      h(0);
      const Ie = he?.Jira?.getCreateIssueMeta?.projects[0];
      if (Ie) {
        const Ae = Ie?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        N(Ae || []), le(
          "issuetype",
          Ae.length > 0 ? Ae[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), N([]), w([]);
    },
    onError: (he) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", he), N([]), w([]), h(0);
    }
  }), [Le, { error: Te }] = J(
    Q1,
    {
      onError: () => {
        y(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (he) => {
        if (y(!1), he?.Jira && "key" in he.Jira.createIssue)
          u(he?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${he.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: he.Jira.createIssue.key
          }), ie && r(
            he.Jira.createIssue.key,
            ie
          );
        else if ("errorMessages" in he.Jira.createIssue || "errors" in he.Jira.createIssue) {
          const Ie = he?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Ie), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), an = (he) => {
    y(!0), $({}), Le({
      variables: {
        input: DF(he, j)
      }
    });
  };
  He(() => {
    if (e)
      try {
        K();
      } catch (he) {
        console.warn("Error when fetching initial projects", he);
      }
  }, [e]), He(() => {
    const he = H ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(he);
  }, [H]), He(() => {
    if (v?.length > 0) {
      le("issuetype", v[f]);
      const he = v[f]?.fields?.additionalProperties;
      if (he?.length > 0) {
        const Ie = he.map(
          ({ value: C }) => C
        ), Ae = (o ? Ie.sort(({ name: C }, { name: _ }) => C.localeCompare(_)) : Ie).sort(
          ({ required: C }, { required: _ }) => Number(_) - Number(C)
        ), { project: Re, issuetype: ze } = pe();
        de({ project: Re, issuetype: ze }), w(Ae);
      }
    } else
      w([]), le("issuetype", void 0);
  }, [v, le, f]), He(() => {
    if (Te && xb(Te)) {
      if (Te?.graphQLErrors?.length > 0) {
        const { graphQLErrors: he } = Te, Ie = he[0].extensions?.integration?.responseBody;
        try {
          const Ae = JSON.parse(Ie);
          if (Ae?.errors) {
            const Re = Object.keys(Ae.errors).reduce(
              (ze, C) => ({
                ...ze,
                [C]: {
                  type: "required",
                  message: Ae.errors[C],
                  ref: {
                    name: C
                  }
                }
              }),
              {}
            );
            $(Re);
          }
        } catch {
        }
      }
    } else
      $({});
  }, [Te]);
  const we = () => {
    d([]), w([]), N([]), u(void 0), h(0), y(!1), $({});
  }, We = () => {
    we(), de(s), n();
  }, Xe = (he) => {
    he && Pe({
      variables: {
        projectKey: he
      }
    });
  }, me = (he) => {
    const Ie = v.map((Ae) => Ae.id).indexOf(he);
    h(Ie ?? 0);
  };
  return /* @__PURE__ */ ye.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ ye.jsx(
          jt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ ye.jsxs(wt, { className: th.modalBody, children: [
          !qe && Be && /* @__PURE__ */ ye.jsx(In, { error: Be, retry: K }),
          !Ue && je && /* @__PURE__ */ ye.jsx(
            In,
            {
              error: je,
              retry: Pe
            }
          ),
          !F && Ce && /* @__PURE__ */ ye.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ye.jsx(
            $s,
            {
              variant: "warning",
              description: /* @__PURE__ */ ye.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ ye.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ ye.jsx(
                      Kn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(j, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ ye.jsx(
            CF,
            {
              createdIssue: m,
              issueBaseLink: ke,
              issueLinkCopied: H,
              setIssueLinkCopied: T,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(an),
              children: /* @__PURE__ */ ye.jsxs(Ut, { children: [
                /* @__PURE__ */ ye.jsx(tn, { span: 3, children: /* @__PURE__ */ ye.jsx(Ln, { label: "Project", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Lt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: he, value: Ie } }) => /* @__PURE__ */ ye.jsx(
                      _r,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Ae) => {
                          Xe(Ae.key), he(Ae);
                        },
                        selectedItems: [Ie],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ae, onSelect: Re, checked: ze }) => /* @__PURE__ */ ye.jsx(
                          em,
                          {
                            item: Ae,
                            checked: ze,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(tn, { span: 3, children: /* @__PURE__ */ ye.jsx(Ln, { label: "Issue type", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Lt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: he, value: Ie } }) => /* @__PURE__ */ ye.jsx(
                      _r,
                      {
                        disabled: v.length === 0,
                        loading: Ue,
                        onSelect: (Ae) => {
                          me(Ae.id), he(Ae);
                        },
                        selectedItems: [Ie],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: je ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Ae, onSelect: Re, checked: ze }) => /* @__PURE__ */ ye.jsx(
                          em,
                          {
                            item: Ae,
                            checked: ze,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ ye.jsx(tn, { className: th.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  wF,
                  {
                    control: q,
                    errors: { ...ge, ...E },
                    getValues: pe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: j
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          It,
          {
            confirmOnClick: m ? We : ee(an),
            confirmProps: {
              disabled: !W,
              isLoading: F,
              loadingIndicator: /* @__PURE__ */ ye.jsx(cn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, OF = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, PF = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, AF = "_wrapper_1bylq_1", LF = "_inputWrapper_1bylq_6", VF = "_inputSeparator_1bylq_18", zF = "_buttonLink_1bylq_23", UF = "_noIssuesFound_1bylq_27", da = {
  wrapper: AF,
  inputWrapper: LF,
  inputSeparator: VF,
  buttonLink: zF,
  noIssuesFound: UF
}, MF = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = kn(), i = OF(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: N,
    isLoadingIssues: j,
    issues: w,
    error: F
  } = N_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, H = !!n?.enableSortIssueTypeByLabel, T = !!(w?.length || v?.length), E = !!n?.enableRemoveAllLinks && T, $ = !N && !j && v?.length > 0 && !!n?.showDanglingLinks;
  return !j && F ? /* @__PURE__ */ ye.jsx(In, { error: F, retry: () => f() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: da.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: da.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: da.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          yF,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      j ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ye.jsx(cn, { "data-testid": "jira-widget-issue-spinner" }) }) : w?.length ? /* @__PURE__ */ ye.jsx(
        L1,
        {
          issues: w,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ ye.jsx(A.Paragraph, { align: "center", className: da.noIssuesFound, children: "No linked issues found" }),
      E && w?.length > 0 && /* @__PURE__ */ ye.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !w?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      $ && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ ye.jsx(Pn, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ ye.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ ye.jsx(
        St,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(ue, { name: "external-link" }),
          variant: "tertiary",
          className: da.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ ye.jsx(
      RF,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: H
      }
    )
  ] });
}, rh = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => PF(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: eo
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vl = { exports: {} }, ua = {}, ih;
function BF() {
  if (ih) return ua;
  ih = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ua.Fragment = r, ua.jsx = s, ua.jsxs = s, ua;
}
var xo = {}, ah;
function qF() {
  return ah || (ah = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    xo.Fragment = i, xo.jsx = Rn, xo.jsxs = Bn;
  })()), xo;
}
var oh;
function HF() {
  return oh || (oh = 1, process.env.NODE_ENV === "production" ? vl.exports = BF() : vl.exports = qF()), vl.exports;
}
var $e = HF();
function WF({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = un(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return He(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((N) => {
        const j = setTimeout(N, r);
        d([...l, j]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var j_ = /* @__PURE__ */ ((e) => (e.List = "list", e))(j_ || {}), nm = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(nm || {}), tm = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(tm || {});
const KF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, GF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, YF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, JF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, QF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, XF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ZF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, eI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, nI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, tI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, iI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, aI = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": KF,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": GF,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": JF,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": QF,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": YF,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": XF,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ZF,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": eI,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": nI,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": tI,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": rI,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": iI
};
function Hr(e) {
  return aI[e] ?? {};
}
const oI = Hr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), sI = Hr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), lI = Hr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), cI = Hr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), dI = Hr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), uI = Hr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), mI = Hr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), pI = Hr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), fI = Hr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function rm(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function sh(e) {
  return rm(e) && e?.attributes?.event_properties?.$message;
}
function hI(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function lh(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function yI(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function gI(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function vI(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function kI(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function bI(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function _I(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function ch(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function xI(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function SI(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const NI = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function jI(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function wI(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function CI({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = un(), { track: a } = kn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, N] = se(
    null
  ), [j, w] = se([]), {
    data: F,
    error: y,
    loading: H,
    networkStatus: T
  } = i(lI, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    E,
    {
      data: $,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = r(oI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return He(() => {
    if (F && !H && T === Gt.ready) {
      const ie = yI(F);
      s(
        ie.find((J) => J?.attributes?.name === "Received Email")?.id || null
      ), d(
        ie.find((J) => J?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ie.find((J) => J?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ie.find((J) => J?.attributes?.name === "Bounced Email")?.id || null
      ), N(
        ie.find((J) => J?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), N(null);
  }, [F]), He(() => {
    o && l && m && f && v && !Z && Q === Gt.ready ? E({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : w([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), He(() => {
    if (!Z && $) {
      const ie = gI($), J = kI(
        $
      ).map(
        (de) => de?.attributes?.event_properties.$message
      ), M = bI(
        $
      ).map(
        (de) => de?.attributes?.event_properties.$message
      );
      ie.forEach((de) => {
        const le = de.attributes?.event_properties.$message;
        de.opened = J.includes(le), de.clicked = M.includes(le);
      });
      const R = vI($), q = _I($), ee = [
        ...ie,
        ...q,
        ...R
      ].sort((de, le) => {
        const pe = lh(de), W = lh(le);
        return pe == null && W == null ? 0 : pe == null ? 1 : W == null ? -1 : W - pe;
      }).slice(0, n);
      w(ee);
      const ge = ee.map((de) => de.id);
      a("klaviyo:messages:received", {
        emailsReceived: ie.filter(
          (de) => ge.includes(de.id)
        ).length,
        emailsBounced: q.filter(
          (de) => ge.includes(de.id)
        ).length,
        smsReceived: R.filter(
          (de) => ge.includes(de.id)
        ).length,
        total: ge.length
      });
    } else
      w([]);
  }, [Z, $]), qn(
    () => ({
      receivedMessages: j,
      isLoading: H || Z,
      error: y || U
    }),
    [
      j,
      H,
      Z,
      y,
      U
    ]
  );
}
function FI({ profileId: e }) {
  const { useQuery: n } = un(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(dI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  He(() => {
    l && o(l);
  }, [l]), He(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return qn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function II({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = kn(), { useLazyQuery: i } = un(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(cI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, N = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, N);
    }
  }, [f, m]);
  const h = (v, N) => {
    const j = v?.data?.length === 1 && v.data[0]?.id || void 0, w = N?.data?.length === 1 && N.data[0]?.id || void 0, F = j || w, y = !j || !w || j === w;
    if (F && y) {
      o(j || w), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${j}) and phone number ${n} (profile ID ${w}).`
      )
    );
  };
  return qn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const dh = 800, EI = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, TI = 3, $I = 1.5, DI = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = TI,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = se(0), [d, m] = se(n || dh), [u, f] = se(r || EI), [h, v] = se(!1), [N, j] = se(!1), w = a || !!r, F = w ? o(u) : n || dh, [y, H] = se(F);
  hw(
    async () => {
      const U = s + 1, Z = $I ** U;
      l(U), H(
        (w ? o(u) : d) * Z
      ), await e().then(() => {
        j(!0), $();
      });
    },
    h ? y : null
  ), gw(() => $());
  const T = tt(() => {
    l(0), H(F);
  }, [F]), E = tt(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      j(!1), T(), Q && (f(Q), H(o(Q))), Z && (m(Z), H(Z)), v(!0);
    },
    [T]
  ), $ = tt(() => {
    v(!1), T();
  }, [T]);
  return He(() => {
    s >= i && $();
  }, [s, i, $]), qn(
    () => ({ isRunning: h, isSuccessful: N, start: E, stop: $ }),
    [h, N, E, $]
  );
}, RI = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, OI = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function PI({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = un(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? uI : mI,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: N
  } = DI({
    query: u,
    useDelayRange: !0
  }), j = m || h;
  return He(() => {
    if (d)
      if (AS({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const w = RI(d);
          v({
            ...w && {
              delayRange: OI(w)
            }
          });
        }
      } else
        s(d);
  }, [d]), He(() => {
    if (!m && l?.Klaviyo) {
      let w = {}, F = {};
      n === "lists" && (w = l?.Klaviyo?.get_profile_lists), n === "segments" && (F = l?.Klaviyo?.get_profile_segments), (w?.data || F?.data) && (N(), a(
        (n === "lists" ? w?.data : F?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), qn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: j,
      error: o,
      networkStatus: f
    }),
    [i, j, o, f, v]
  );
}
const AI = "_notificationText_1polx_1", Ym = {
  notificationText: AI
}, zs = ({ error: e }) => {
  const { track: n } = kn();
  let r = e;
  if (xb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && hb({ error: i[0] }), o = i.length === 1 && PS({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ $e.jsx(In, { error: e });
  }
  return /* @__PURE__ */ $e.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ $e.jsx(
    Ke.Item,
    {
      contentLeft: /* @__PURE__ */ $e.jsx(ue, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, LI = "_message_1vrar_48", VI = "_messageIsOpen_1vrar_56", zI = "_messageHeader_1vrar_59", UI = "_messageLabel_1vrar_65", MI = "_messageText_1vrar_68", Oi = {
  message: LI,
  messageIsOpen: VI,
  messageHeader: zI,
  messageLabel: UI,
  messageText: MI
}, BI = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && xI(e.flowMessage);
  return /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Oi.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ $e.jsx(A.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ $e.jsx(cn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ $e.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: Oi.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: Oi.messageText, children: i })
        ]
      }
    )
  ] });
}, qI = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ $e.jsx($e.Fragment, { children: /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ $e.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, HI = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = qn(
    () => () => l ? An(l).format(m) : d ? An.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, N = f && e.clicked, j = f && o?.event_properties.Subject, w = h && o?.event_properties["Message Name"], F = f ? "mail" : "sms";
  return /* @__PURE__ */ $e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(Oi.message, {
        [Oi.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ $e.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Oi.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ $e.jsx(ue, { size: 16, name: F }),
                  " ",
                  NI(s),
                  u && /* @__PURE__ */ $e.jsx(Un, { size: "small", variant: "info", children: u })
                ] }),
                j && j,
                w && w
              ] }),
              /* @__PURE__ */ $e.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ $e.jsx(Fm, {}),
          hI(e) && /* @__PURE__ */ $e.jsx(b, { children: /* @__PURE__ */ $e.jsx(Un, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
            /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ $e.jsx(Pn, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  ue,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ $e.jsx(Pn, { children: /* @__PURE__ */ $e.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  ue,
                  {
                    size: 16,
                    color: N ? "green.400" : "red.400",
                    name: N ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ $e.jsx(BI, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ $e.jsx(qI, { event: e })
        ] })
      ]
    }
  );
}, WI = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, KI = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = CI({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = WF({
    query: sI,
    options: WI,
    delayMs: 1e3
  }), [m, u] = se([]);
  He(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => rm(v)).map((v) => sh(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), He(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && rm(h) && !h.flowMessage) {
          const v = sh(h), N = d.find((w) => (w.data && ch(w.data))?.id === v), j = N?.data && ch(N.data);
          if (j)
            return {
              ...SI(h),
              flowMessage: j
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ $e.jsx(
    In,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ $e.jsx(
    zs,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : /* @__PURE__ */ $e.jsx($e.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ $e.jsx(
      HI,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ $e.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Ym.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, GI = "_list_ld0hf_1", YI = "_listItem_ld0hf_4", Aa = {
  list: GI,
  listItem: YI
}, uh = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = PI({ profileId: e, query: n });
  He(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ $e.jsx(zs, { error: o }) : s ? /* @__PURE__ */ $e.jsx(Ke.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ $e.jsx(cn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ $e.jsx(Ke.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ $e.jsx(Pn, { children: Es(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ $e.jsx(Ke.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ $e.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ $e.jsx(ue, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ $e.jsx(Ge, { content: "Refresh lists and segments", children: /* @__PURE__ */ $e.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ $e.jsx(Ke.Text, { variant: "dense", className: Aa.listItem, children: /* @__PURE__ */ $e.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ $e.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, JI = "_tagHover_kzbzk_1", QI = "_channelUnsubscribed_kzbzk_6", mh = {
  tagHover: JI,
  channelUnsubscribed: QI
}, ph = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ $e.jsx(
    Ge,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ $e.jsx(
        Pn,
        {
          className: mh.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ $e.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [mh.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ $e.jsx(cn, { size: 16 }) : /* @__PURE__ */ $e.jsx(ue, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, XI = "_subscriptionError_1qhhx_1", ZI = {
  subscriptionError: XI
}, eE = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = kn(), [v, N] = yw({
    channel: null,
    request: null
  }), j = jI(n), w = wI(n), F = !!e, { useMutation: y } = un(), [H] = y(
    pI
  ), [T] = y(
    fI
  ), E = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), N.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => H({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: nm.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: tm.Subscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: tm.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: j_.List,
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, $ = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), N.setAll({
      channel: Z,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: nm.Profile,
                attributes: {
                  ...Z === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ie,
    isSubscriptionRequest: J
  }) => {
    const M = ie?.networkError, R = M ? M?.statusCode : NaN, q = Q?.errors, ee = !!q && yb({
      errors: q
    });
    R === 202 ? (h(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ee ? (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: M?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return He(() => {
    if (v.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), N.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), N.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ $e.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(
            ph,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: j,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                l(!0), f(void 0), j ? $("EMAIL") : E("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ $e.jsx(
            ph,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: w,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: F,
              handleAction: () => {
                m(!0), f(void 0), w ? $("SMS") : E("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ $e.jsx(b, { className: ZI.subscriptionError, children: u })
      ] })
    }
  );
}, nE = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: d,
    error: m,
    isLoading: u,
    refetchProfile: f
  } = FI({ profileId: e });
  return m ? /* @__PURE__ */ $e.jsx(zs, { error: m }) : u ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : !d && !u ? /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Ym.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ $e.jsxs(Ke, { className: Aa.list, children: [
        i && /* @__PURE__ */ $e.jsx(uh, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ $e.jsx(
          uh,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    d && e && o && /* @__PURE__ */ $e.jsx(
      eE,
      {
        profile: d,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: r
      }
    ),
    /* @__PURE__ */ $e.jsx(
      KI,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, tE = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), d = n?.subscriptionListId, {
    profileId: m,
    getProfileId: u,
    isLoading: f,
    error: h
  } = II({ email: r, phoneNumber: i });
  return US(() => {
    (r || i) && u({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : h ? /* @__PURE__ */ $e.jsx(zs, { error: h }) : m ? /* @__PURE__ */ $e.jsx(
    nE,
    {
      profileId: m,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: d
    }
  ) : /* @__PURE__ */ $e.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Ym.notificationText,
      children: "No profile ID found"
    }
  );
}, rE = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: OS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function iE(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const aE = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, oE = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, sE = {};
function fh(e, n) {
  return (sE.jsx ? oE : aE).test(e);
}
const lE = /[ \t\n\f\r]/g;
function cE(e) {
  return typeof e == "object" ? e.type === "text" ? hh(e.value) : !1 : hh(e);
}
function hh(e) {
  return e.replace(lE, "") === "";
}
class so {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
so.prototype.property = {};
so.prototype.normal = {};
so.prototype.space = null;
function w_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new so(r, i, n);
}
function im(e) {
  return e.toLowerCase();
}
class cr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
cr.prototype.space = null;
cr.prototype.boolean = !1;
cr.prototype.booleanish = !1;
cr.prototype.overloadedBoolean = !1;
cr.prototype.number = !1;
cr.prototype.commaSeparated = !1;
cr.prototype.spaceSeparated = !1;
cr.prototype.commaOrSpaceSeparated = !1;
cr.prototype.mustUseProperty = !1;
cr.prototype.defined = !1;
let dE = 0;
const Cn = ki(), pt = ki(), C_ = ki(), Ve = ki(), Zn = ki(), Pi = ki(), Jt = ki();
function ki() {
  return 2 ** ++dE;
}
const am = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Cn,
  booleanish: pt,
  commaOrSpaceSeparated: Jt,
  commaSeparated: Pi,
  number: Ve,
  overloadedBoolean: C_,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), kl = Object.keys(am);
class Jm extends cr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), yh(this, "space", a), typeof i == "number")
      for (; ++o < kl.length; ) {
        const s = kl[o];
        yh(this, kl[o], (i & am[s]) === am[s]);
      }
  }
}
Jm.prototype.defined = !0;
function yh(e, n, r) {
  r && (e[n] = r);
}
const uE = {}.hasOwnProperty;
function Wi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (uE.call(e.properties, i)) {
      const a = e.properties[i], o = new Jm(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[im(i)] = i, r[im(o.attribute)] = i;
    }
  return new so(n, r, e.space);
}
const F_ = Wi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), I_ = Wi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function E_(e, n) {
  return n in e ? e[n] : n;
}
function T_(e, n) {
  return E_(e, n.toLowerCase());
}
const $_ = Wi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: T_,
  properties: { xmlns: null, xmlnsXLink: null }
}), D_ = Wi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: pt,
    ariaAutoComplete: null,
    ariaBusy: pt,
    ariaChecked: pt,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: pt,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: pt,
    ariaFlowTo: Zn,
    ariaGrabbed: pt,
    ariaHasPopup: null,
    ariaHidden: pt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: pt,
    ariaMultiLine: pt,
    ariaMultiSelectable: pt,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: pt,
    ariaReadOnly: pt,
    ariaRelevant: null,
    ariaRequired: pt,
    ariaRoleDescription: Zn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: pt,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), mE = Wi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: T_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Pi,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: Cn,
    allowPaymentRequest: Cn,
    allowUserMedia: Cn,
    alt: null,
    as: null,
    async: Cn,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: Cn,
    autoPlay: Cn,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: Cn,
    cite: null,
    className: Zn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: pt,
    controls: Cn,
    controlsList: Zn,
    coords: Ve | Pi,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Cn,
    defer: Cn,
    dir: null,
    dirName: null,
    disabled: Cn,
    download: C_,
    draggable: pt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Cn,
    formTarget: null,
    headers: Zn,
    height: Ve,
    hidden: Cn,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Cn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Cn,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: Cn,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Cn,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: Cn,
    muted: Cn,
    name: null,
    nonce: null,
    noModule: Cn,
    noValidate: Cn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Cn,
    optimum: Ve,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: Cn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Cn,
    referrerPolicy: null,
    rel: Zn,
    required: Cn,
    reversed: Cn,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Zn,
    scope: null,
    scoped: Cn,
    seamless: Cn,
    selected: Cn,
    shadowRootClonable: Cn,
    shadowRootDelegatesFocus: Cn,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: pt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Cn,
    useMap: null,
    value: pt,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Cn,
    // Lists. Use CSS to reduce space between items instead
    declare: Cn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: Cn,
    // `<frame>`
    noHref: Cn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Cn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Cn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: pt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Cn,
    disableRemotePlayback: Cn,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), pE = Wi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: E_,
  properties: {
    about: Jt,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: Cn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Pi,
    g2: Pi,
    glyphName: Pi,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: Jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Jt,
    rev: Jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Jt,
    requiredFeatures: Jt,
    requiredFonts: Jt,
    requiredFormats: Jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: Jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Jt,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), fE = /^data[-\w.:]+$/i, gh = /-[a-z]/g, hE = /[A-Z]/g;
function yE(e, n) {
  const r = im(n);
  let i = n, a = cr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && fE.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(gh, vE);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!gh.test(o)) {
        let s = o.replace(hE, gE);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Jm;
  }
  return new a(i, n);
}
function gE(e) {
  return "-" + e.toLowerCase();
}
function vE(e) {
  return e.charAt(1).toUpperCase();
}
const kE = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, bE = w_([I_, F_, $_, D_, mE], "html"), Qm = w_([I_, F_, $_, D_, pE], "svg");
function _E(e) {
  return e.join(" ").trim();
}
var Ni = {}, bl, vh;
function xE() {
  if (vh) return bl;
  vh = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  bl = function(j, w) {
    if (typeof j != "string")
      throw new TypeError("First argument must be a string");
    if (!j) return [];
    w = w || {};
    var F = 1, y = 1;
    function H(R) {
      var q = R.match(n);
      q && (F += q.length);
      var ee = R.lastIndexOf(d);
      y = ~ee ? R.length - ee : y + R.length;
    }
    function T() {
      var R = { line: F, column: y };
      return function(q) {
        return q.position = new E(R), Z(), q;
      };
    }
    function E(R) {
      this.start = R, this.end = { line: F, column: y }, this.source = w.source;
    }
    E.prototype.content = j;
    function $(R) {
      var q = new Error(
        w.source + ":" + F + ":" + y + ": " + R
      );
      if (q.reason = R, q.filename = w.source, q.line = F, q.column = y, q.source = j, !w.silent) throw q;
    }
    function U(R) {
      var q = R.exec(j);
      if (q) {
        var ee = q[0];
        return H(ee), j = j.slice(ee.length), q;
      }
    }
    function Z() {
      U(r);
    }
    function Q(R) {
      var q;
      for (R = R || []; q = ie(); )
        q !== !1 && R.push(q);
      return R;
    }
    function ie() {
      var R = T();
      if (!(m != j.charAt(0) || u != j.charAt(1))) {
        for (var q = 2; f != j.charAt(q) && (u != j.charAt(q) || m != j.charAt(q + 1)); )
          ++q;
        if (q += 2, f === j.charAt(q - 1))
          return $("End of comment missing");
        var ee = j.slice(2, q - 2);
        return y += 2, H(ee), j = j.slice(q), y += 2, R({
          type: h,
          comment: ee
        });
      }
    }
    function J() {
      var R = T(), q = U(i);
      if (q) {
        if (ie(), !U(a)) return $("property missing ':'");
        var ee = U(o), ge = R({
          type: v,
          property: N(q[0].replace(e, f)),
          value: ee ? N(ee[0].replace(e, f)) : f
        });
        return U(s), ge;
      }
    }
    function M() {
      var R = [];
      Q(R);
      for (var q; q = J(); )
        q !== !1 && (R.push(q), Q(R));
      return R;
    }
    return Z(), M();
  };
  function N(j) {
    return j ? j.replace(l, f) : f;
  }
  return bl;
}
var kh;
function SE() {
  if (kh) return Ni;
  kh = 1;
  var e = Ni && Ni.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.default = r;
  var n = e(xE());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ni;
}
var NE = SE();
const bh = /* @__PURE__ */ Tm(NE), jE = bh.default || bh, R_ = O_("end"), Xm = O_("start");
function O_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function wE(e) {
  const n = Xm(e), r = R_(e);
  if (n && r)
    return { start: n, end: r };
}
function Ma(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? _h(e.position) : "start" in e || "end" in e ? _h(e) : "line" in e || "column" in e ? om(e) : "";
}
function om(e) {
  return xh(e && e.line) + ":" + xh(e && e.column);
}
function _h(e) {
  return om(e && e.start) + "-" + om(e && e.end);
}
function xh(e) {
  return e && typeof e == "number" ? e : 1;
}
class Et extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ma(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Et.prototype.file = "";
Et.prototype.name = "";
Et.prototype.reason = "";
Et.prototype.message = "";
Et.prototype.stack = "";
Et.prototype.column = void 0;
Et.prototype.line = void 0;
Et.prototype.ancestors = void 0;
Et.prototype.cause = void 0;
Et.prototype.fatal = void 0;
Et.prototype.place = void 0;
Et.prototype.ruleId = void 0;
Et.prototype.source = void 0;
const Zm = {}.hasOwnProperty, CE = /* @__PURE__ */ new Map(), FE = /[A-Z]/g, IE = /-([a-z])/g, EE = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), TE = /* @__PURE__ */ new Set(["td", "th"]), P_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function $E(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = zE(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = VE(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Qm : bE,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = A_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function A_(e, n, r) {
  if (n.type === "element")
    return DE(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return RE(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return PE(e, n, r);
  if (n.type === "mdxjsEsm")
    return OE(e, n);
  if (n.type === "root")
    return AE(e, n, r);
  if (n.type === "text")
    return LE(e, n);
}
function DE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Qm, e.schema = a), e.ancestors.push(n);
  const o = V_(e, n.tagName, !1), s = UE(e, n);
  let l = np(e, n);
  return EE.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !cE(d) : !0;
  })), L_(e, s, o, n), ep(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function RE(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Xa(e, n.position);
}
function OE(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Xa(e, n.position);
}
function PE(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Qm, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : V_(e, n.name, !0), s = ME(e, n), l = np(e, n);
  return L_(e, s, o, n), ep(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function AE(e, n, r) {
  const i = {};
  return ep(i, np(e, n)), e.create(n, e.Fragment, i, r);
}
function LE(e, n) {
  return n.value;
}
function L_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function ep(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function VE(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function zE(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Xm(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function UE(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Zm.call(n.properties, a)) {
      const o = BE(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && TE.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function ME(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Xa(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Xa(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function np(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : CE;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = A_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function BE(e, n, r) {
  const i = yE(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? iE(r) : _E(r)), i.property === "style") {
      let a = typeof r == "object" ? r : qE(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = HE(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? kE[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function qE(e, n) {
  const r = {};
  try {
    jE(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Et("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = P_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(IE, KE)), r[s] = o;
  }
}
function V_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = fh(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = fh(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Zm.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Xa(e);
}
function Xa(e, n) {
  const r = new Et(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = P_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function HE(e) {
  const n = {};
  let r;
  for (r in e)
    Zm.call(e, r) && (n[WE(r)] = e[r]);
  return n;
}
function WE(e) {
  let n = e.replace(FE, GE);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function KE(e, n) {
  return n.toUpperCase();
}
function GE(e) {
  return "-" + e.toLowerCase();
}
const _l = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, YE = {};
function JE(e, n) {
  const r = YE, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return z_(e, i, a);
}
function z_(e, n, r) {
  if (QE(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Sh(e.children, n, r);
  }
  return Array.isArray(e) ? Sh(e, n, r) : "";
}
function Sh(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = z_(e[a], n, r);
  return i.join("");
}
function QE(e) {
  return !!(e && typeof e == "object");
}
const Nh = document.createElement("i");
function tp(e) {
  const n = "&" + e + ";";
  Nh.innerHTML = n;
  const r = Nh.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Rr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ir(e, n) {
  return e.length > 0 ? (Rr(e, e.length, 0, n), e) : n;
}
const jh = {}.hasOwnProperty;
function XE(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    ZE(n, e[r]);
  return n;
}
function ZE(e, n) {
  let r;
  for (r in n) {
    const a = (jh.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        jh.call(a, s) || (a[s] = []);
        const l = o[s];
        eT(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function eT(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Rr(e, 0, 0, i);
}
function U_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Ai(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Fr = ei(/[A-Za-z]/), nr = ei(/[\dA-Za-z]/), nT = ei(/[#-'*+\--9=?A-Z^-~]/);
function sm(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const lm = ei(/\d/), tT = ei(/[\dA-Fa-f]/), rT = ei(/[!-/:-@[-`{-~]/);
function gn(e) {
  return e !== null && e < -2;
}
function Kt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const iT = ei(new RegExp("\\p{P}|\\p{S}", "u")), aT = ei(/\s/);
function ei(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Ki(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && nr(e.charCodeAt(r + 1)) && nr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const oT = {
  tokenize: sT
};
function sT(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return gn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const lT = {
  tokenize: cT
}, wh = {
  tokenize: dT
};
function cT(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(H) {
    if (i < r.length) {
      const T = r[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, d, m)(H);
    }
    return m(H);
  }
  function d(H) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const T = n.events.length;
      let E = T, $;
      for (; E--; )
        if (n.events[E][0] === "exit" && n.events[E][1].type === "chunkFlow") {
          $ = n.events[E][1].end;
          break;
        }
      F(i);
      let U = T;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...$
        }, U++;
      return Rr(n.events, E + 1, 0, n.events.slice(T)), n.events.length = U, m(H);
    }
    return l(H);
  }
  function m(H) {
    if (i === r.length) {
      if (!a)
        return h(H);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return N(H);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(wh, u, f)(H);
  }
  function u(H) {
    return a && y(), F(i), h(H);
  }
  function f(H) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, N(H);
  }
  function h(H) {
    return n.containerState = {}, e.attempt(wh, v, N)(H);
  }
  function v(H) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(H);
  }
  function N(H) {
    if (H === null) {
      a && y(), F(0), e.consume(H);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), j(H);
  }
  function j(H) {
    if (H === null) {
      w(e.exit("chunkFlow"), !0), F(0), e.consume(H);
      return;
    }
    return gn(H) ? (e.consume(H), w(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(H), j);
  }
  function w(H, T) {
    const E = n.sliceStream(H);
    if (T && E.push(null), H.previous = o, o && (o.next = H), o = H, a.defineSkip(H.start), a.write(E), n.parser.lazy[H.start.line]) {
      let $ = a.events.length;
      for (; $--; )
        if (
          // The token starts before the line ending…
          a.events[$][1].start.offset < s && // …and either is not ended yet…
          (!a.events[$][1].end || // …or ends after it.
          a.events[$][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ie;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ie = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (F(i), $ = U; $ < n.events.length; )
        n.events[$][1].end = {
          ...ie
        }, $++;
      Rr(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = $;
    }
  }
  function F(H) {
    let T = r.length;
    for (; T-- > H; ) {
      const E = r[T];
      n.containerState = E[1], E[0].exit.call(n, e);
    }
    r.length = H;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function dT(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Ch(e) {
  if (e === null || Kt(e) || aT(e))
    return 1;
  if (iT(e))
    return 2;
}
function rp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const cm = {
  name: "attention",
  resolveAll: uT,
  tokenize: mT
};
function uT(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Fh(f, -d), Fh(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ir(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ir(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ir(m, rp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = ir(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = ir(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Rr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function mT(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Ch(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Ch(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Fh(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const pT = {
  name: "autolink",
  tokenize: fT
};
function fT(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Fr(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || nr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || nr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || sm(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : nT(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return nr(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || nr(v)) && i++ < 63) {
      const N = v === 45 ? h : f;
      return e.consume(v), N;
    }
    return r(v);
  }
}
const Us = {
  partial: !0,
  tokenize: hT
};
function hT(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || gn(o) ? n(o) : r(o);
  }
}
const M_ = {
  continuation: {
    tokenize: gT
  },
  exit: vT,
  name: "blockQuote",
  tokenize: yT
};
function yT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function gT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(M_, n, r)(s);
  }
}
function vT(e) {
  e.exit("blockQuote");
}
const B_ = {
  name: "characterEscape",
  tokenize: kT
};
function kT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return rT(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const q_ = {
  name: "characterReference",
  tokenize: bT
};
function bT(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = nr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = tT, u) : (e.enter("characterReferenceValue"), o = 7, s = lm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === nr && !tp(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Ih = {
  partial: !0,
  tokenize: xT
}, Eh = {
  concrete: !0,
  name: "codeFenced",
  tokenize: _T
};
function _T(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: E
  };
  let o = 0, s = 0, l;
  return d;
  function d($) {
    return m($);
  }
  function m($) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = $, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u($);
  }
  function u($) {
    return $ === l ? (s++, e.consume($), u) : s < 3 ? r($) : (e.exit("codeFencedFenceSequence"), zn($) ? et(e, f, "whitespace")($) : f($));
  }
  function f($) {
    return $ === null || gn($) ? (e.exit("codeFencedFence"), i.interrupt ? n($) : e.check(Ih, j, T)($)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h($));
  }
  function h($) {
    return $ === null || gn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f($)) : zn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, v, "whitespace")($)) : $ === 96 && $ === l ? r($) : (e.consume($), h);
  }
  function v($) {
    return $ === null || gn($) ? f($) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), N($));
  }
  function N($) {
    return $ === null || gn($) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f($)) : $ === 96 && $ === l ? r($) : (e.consume($), N);
  }
  function j($) {
    return e.attempt(a, T, w)($);
  }
  function w($) {
    return e.enter("lineEnding"), e.consume($), e.exit("lineEnding"), F;
  }
  function F($) {
    return o > 0 && zn($) ? et(e, y, "linePrefix", o + 1)($) : y($);
  }
  function y($) {
    return $ === null || gn($) ? e.check(Ih, j, T)($) : (e.enter("codeFlowValue"), H($));
  }
  function H($) {
    return $ === null || gn($) ? (e.exit("codeFlowValue"), y($)) : (e.consume($), H);
  }
  function T($) {
    return e.exit("codeFenced"), n($);
  }
  function E($, U, Z) {
    let Q = 0;
    return ie;
    function ie(ee) {
      return $.enter("lineEnding"), $.consume(ee), $.exit("lineEnding"), J;
    }
    function J(ee) {
      return $.enter("codeFencedFence"), zn(ee) ? et($, M, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : M(ee);
    }
    function M(ee) {
      return ee === l ? ($.enter("codeFencedFenceSequence"), R(ee)) : Z(ee);
    }
    function R(ee) {
      return ee === l ? (Q++, $.consume(ee), R) : Q >= s ? ($.exit("codeFencedFenceSequence"), zn(ee) ? et($, q, "whitespace")(ee) : q(ee)) : Z(ee);
    }
    function q(ee) {
      return ee === null || gn(ee) ? ($.exit("codeFencedFence"), U(ee)) : Z(ee);
    }
  }
}
function xT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const xl = {
  name: "codeIndented",
  tokenize: NT
}, ST = {
  partial: !0,
  tokenize: jT
};
function NT(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : gn(m) ? e.attempt(ST, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || gn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function jT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : gn(s) ? a(s) : r(s);
  }
}
const wT = {
  name: "codeText",
  previous: FT,
  resolve: CT,
  tokenize: IT
};
function CT(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function FT(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function IT(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : gn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || gn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class ET {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && ma(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), ma(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), ma(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        ma(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        ma(this.left, r.reverse());
      }
  }
}
function ma(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function H_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new ET(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, TT(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Rr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function TT(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, N = 0, j = 0;
  const w = [j];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (j = h + 1, w.push(j), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : w.pop(), h = w.length; h--; ) {
    const F = l.slice(w[h], w[h + 1]), y = o.pop();
    d.push([y, y + F.length - 1]), e.splice(y, 2, F);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[N + d[h][0]] = N + d[h][1], N += d[h][1] - d[h][0] - 1;
  return m;
}
const $T = {
  resolve: RT,
  tokenize: OT
}, DT = {
  partial: !0,
  tokenize: PT
};
function RT(e) {
  return H_(e), e;
}
function OT(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : gn(l) ? e.check(DT, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function PT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || gn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function W_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(F) {
    return F === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(F), e.exit(o), h) : F === null || F === 32 || F === 41 || sm(F) ? r(F) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), j(F));
  }
  function h(F) {
    return F === 62 ? (e.enter(o), e.consume(F), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(F));
  }
  function v(F) {
    return F === 62 ? (e.exit("chunkString"), e.exit(l), h(F)) : F === null || F === 60 || gn(F) ? r(F) : (e.consume(F), F === 92 ? N : v);
  }
  function N(F) {
    return F === 60 || F === 62 || F === 92 ? (e.consume(F), v) : v(F);
  }
  function j(F) {
    return !u && (F === null || F === 41 || Kt(F)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(F)) : u < m && F === 40 ? (e.consume(F), u++, j) : F === 41 ? (e.consume(F), u--, j) : F === null || F === 32 || F === 40 || sm(F) ? r(F) : (e.consume(F), F === 92 ? w : j);
  }
  function w(F) {
    return F === 40 || F === 41 || F === 92 ? (e.consume(F), j) : j(F);
  }
}
function K_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : gn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || gn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function G_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : gn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || gn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Ba(e, n) {
  let r;
  return i;
  function i(a) {
    return gn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const AT = {
  name: "definition",
  tokenize: VT
}, LT = {
  partial: !0,
  tokenize: zT
};
function VT(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return K_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Ai(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Kt(v) ? Ba(e, m)(v) : m(v);
  }
  function m(v) {
    return W_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(LT, f, f)(v);
  }
  function f(v) {
    return zn(v) ? et(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || gn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function zT(e, n, r) {
  return i;
  function i(l) {
    return Kt(l) ? Ba(e, a)(l) : r(l);
  }
  function a(l) {
    return G_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || gn(l) ? n(l) : r(l);
  }
}
const UT = {
  name: "hardBreakEscape",
  tokenize: MT
};
function MT(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return gn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const BT = {
  name: "headingAtx",
  resolve: qT,
  tokenize: HT
};
function qT(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Rr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function HT(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Kt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || gn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Kt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const WT = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Th = ["pre", "script", "style", "textarea"], KT = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: JT,
  tokenize: QT
}, GT = {
  partial: !0,
  tokenize: ZT
}, YT = {
  partial: !0,
  tokenize: XT
};
function JT(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function QT(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, j) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Fr(K) ? (e.consume(K), s = String.fromCharCode(K), w) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, v) : K === 91 ? (e.consume(K), a = 5, l = 0, N) : Fr(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : r(K);
  }
  function v(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : r(K);
  }
  function N(K) {
    const qe = "CDATA[";
    return K === qe.charCodeAt(l++) ? (e.consume(K), l === qe.length ? i.interrupt ? n : M : N) : r(K);
  }
  function j(K) {
    return Fr(K) ? (e.consume(K), s = String.fromCharCode(K), w) : r(K);
  }
  function w(K) {
    if (K === null || K === 47 || K === 62 || Kt(K)) {
      const qe = K === 47, Be = s.toLowerCase();
      return !qe && !o && Th.includes(Be) ? (a = 1, i.interrupt ? n(K) : M(K)) : WT.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(K), F) : i.interrupt ? n(K) : M(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? y(K) : H(K));
    }
    return K === 45 || nr(K) ? (e.consume(K), s += String.fromCharCode(K), w) : r(K);
  }
  function F(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : M) : r(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ie(K);
  }
  function H(K) {
    return K === 47 ? (e.consume(K), ie) : K === 58 || K === 95 || Fr(K) ? (e.consume(K), T) : zn(K) ? (e.consume(K), H) : ie(K);
  }
  function T(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || nr(K) ? (e.consume(K), T) : E(K);
  }
  function E(K) {
    return K === 61 ? (e.consume(K), $) : zn(K) ? (e.consume(K), E) : H(K);
  }
  function $(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, U) : zn(K) ? (e.consume(K), $) : Z(K);
  }
  function U(K) {
    return K === d ? (e.consume(K), d = null, Q) : K === null || gn(K) ? r(K) : (e.consume(K), U);
  }
  function Z(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Kt(K) ? E(K) : (e.consume(K), Z);
  }
  function Q(K) {
    return K === 47 || K === 62 || zn(K) ? H(K) : r(K);
  }
  function ie(K) {
    return K === 62 ? (e.consume(K), J) : r(K);
  }
  function J(K) {
    return K === null || gn(K) ? M(K) : zn(K) ? (e.consume(K), J) : r(K);
  }
  function M(K) {
    return K === 45 && a === 2 ? (e.consume(K), ge) : K === 60 && a === 1 ? (e.consume(K), de) : K === 62 && a === 4 ? (e.consume(K), ke) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), pe) : gn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(GT, Ce, R)(K)) : K === null || gn(K) ? (e.exit("htmlFlowData"), R(K)) : (e.consume(K), M);
  }
  function R(K) {
    return e.check(YT, q, Ce)(K);
  }
  function q(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ee;
  }
  function ee(K) {
    return K === null || gn(K) ? R(K) : (e.enter("htmlFlowData"), M(K));
  }
  function ge(K) {
    return K === 45 ? (e.consume(K), W) : M(K);
  }
  function de(K) {
    return K === 47 ? (e.consume(K), s = "", le) : M(K);
  }
  function le(K) {
    if (K === 62) {
      const qe = s.toLowerCase();
      return Th.includes(qe) ? (e.consume(K), ke) : M(K);
    }
    return Fr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), le) : M(K);
  }
  function pe(K) {
    return K === 93 ? (e.consume(K), W) : M(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), ke) : K === 45 && a === 2 ? (e.consume(K), W) : M(K);
  }
  function ke(K) {
    return K === null || gn(K) ? (e.exit("htmlFlowData"), Ce(K)) : (e.consume(K), ke);
  }
  function Ce(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function XT(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return gn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function ZT(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Us, n, r);
  }
}
const e$ = {
  name: "htmlText",
  tokenize: n$
};
function n$(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), E) : W === 63 ? (e.consume(W), H) : Fr(W) ? (e.consume(W), Z) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, N) : Fr(W) ? (e.consume(W), y) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), v) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : gn(W) ? (s = f, de(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), v) : f(W);
  }
  function v(W) {
    return W === 62 ? ge(W) : W === 45 ? h(W) : f(W);
  }
  function N(W) {
    const ke = "CDATA[";
    return W === ke.charCodeAt(o++) ? (e.consume(W), o === ke.length ? j : N) : r(W);
  }
  function j(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), w) : gn(W) ? (s = j, de(W)) : (e.consume(W), j);
  }
  function w(W) {
    return W === 93 ? (e.consume(W), F) : j(W);
  }
  function F(W) {
    return W === 62 ? ge(W) : W === 93 ? (e.consume(W), F) : j(W);
  }
  function y(W) {
    return W === null || W === 62 ? ge(W) : gn(W) ? (s = y, de(W)) : (e.consume(W), y);
  }
  function H(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), T) : gn(W) ? (s = H, de(W)) : (e.consume(W), H);
  }
  function T(W) {
    return W === 62 ? ge(W) : H(W);
  }
  function E(W) {
    return Fr(W) ? (e.consume(W), $) : r(W);
  }
  function $(W) {
    return W === 45 || nr(W) ? (e.consume(W), $) : U(W);
  }
  function U(W) {
    return gn(W) ? (s = U, de(W)) : zn(W) ? (e.consume(W), U) : ge(W);
  }
  function Z(W) {
    return W === 45 || nr(W) ? (e.consume(W), Z) : W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function Q(W) {
    return W === 47 ? (e.consume(W), ge) : W === 58 || W === 95 || Fr(W) ? (e.consume(W), ie) : gn(W) ? (s = Q, de(W)) : zn(W) ? (e.consume(W), Q) : ge(W);
  }
  function ie(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || nr(W) ? (e.consume(W), ie) : J(W);
  }
  function J(W) {
    return W === 61 ? (e.consume(W), M) : gn(W) ? (s = J, de(W)) : zn(W) ? (e.consume(W), J) : Q(W);
  }
  function M(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, R) : gn(W) ? (s = M, de(W)) : zn(W) ? (e.consume(W), M) : (e.consume(W), q);
  }
  function R(W) {
    return W === a ? (e.consume(W), a = void 0, ee) : W === null ? r(W) : gn(W) ? (s = R, de(W)) : (e.consume(W), R);
  }
  function q(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Kt(W) ? Q(W) : (e.consume(W), q);
  }
  function ee(W) {
    return W === 47 || W === 62 || Kt(W) ? Q(W) : r(W);
  }
  function ge(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function de(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), le;
  }
  function le(W) {
    return zn(W) ? et(e, pe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : pe(W);
  }
  function pe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const ip = {
  name: "labelEnd",
  resolveAll: a$,
  resolveTo: o$,
  tokenize: s$
}, t$ = {
  tokenize: l$
}, r$ = {
  tokenize: c$
}, i$ = {
  tokenize: d$
};
function a$(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Rr(e, 0, e.length, r), e;
}
function o$(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ir(l, e.slice(o + 1, o + i + 3)), l = ir(l, [["enter", u, n]]), l = ir(l, rp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ir(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ir(l, e.slice(s + 1)), l = ir(l, [["exit", d, n]]), Rr(e, o, e.length, l), e;
}
function s$(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Ai(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(t$, u, s ? u : f)(h) : h === 91 ? e.attempt(r$, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(i$, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function l$(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Kt(f) ? Ba(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : W_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Kt(f) ? Ba(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? G_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Kt(f) ? Ba(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function c$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return K_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Ai(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function d$(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const u$ = {
  name: "labelStartImage",
  resolveAll: ip.resolveAll,
  tokenize: m$
};
function m$(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const p$ = {
  name: "labelStartLink",
  resolveAll: ip.resolveAll,
  tokenize: f$
};
function f$(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const Sl = {
  name: "lineEnding",
  tokenize: h$
};
function h$(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const Xo = {
  name: "thematicBreak",
  tokenize: y$
};
function y$(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || gn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Bt = {
  continuation: {
    tokenize: b$
  },
  exit: x$,
  name: "list",
  tokenize: k$
}, g$ = {
  partial: !0,
  tokenize: S$
}, v$ = {
  partial: !0,
  tokenize: _$
};
function k$(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const N = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (N === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : lm(v)) {
      if (i.containerState.type || (i.containerState.type = N, e.enter(N, {
        _container: !0
      })), N === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(Xo, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return lm(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Us,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(g$, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function b$(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Us, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(v$, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Bt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function _$(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function x$(e) {
  e.exit(this.containerState.type);
}
function S$(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const $h = {
  name: "setextUnderline",
  resolveTo: N$,
  tokenize: j$
};
function N$(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function j$(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || gn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const w$ = {
  tokenize: C$
};
function C$(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Us,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt($T, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const F$ = {
  resolveAll: J_()
}, I$ = Y_("string"), E$ = Y_("text");
function Y_(e) {
  return {
    resolveAll: J_(e === "text" ? T$ : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function J_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function T$(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const $$ = {
  42: Bt,
  43: Bt,
  45: Bt,
  48: Bt,
  49: Bt,
  50: Bt,
  51: Bt,
  52: Bt,
  53: Bt,
  54: Bt,
  55: Bt,
  56: Bt,
  57: Bt,
  62: M_
}, D$ = {
  91: AT
}, R$ = {
  [-2]: xl,
  [-1]: xl,
  32: xl
}, O$ = {
  35: BT,
  42: Xo,
  45: [$h, Xo],
  60: KT,
  61: $h,
  95: Xo,
  96: Eh,
  126: Eh
}, P$ = {
  38: q_,
  92: B_
}, A$ = {
  [-5]: Sl,
  [-4]: Sl,
  [-3]: Sl,
  33: u$,
  38: q_,
  42: cm,
  60: [pT, e$],
  91: p$,
  92: [UT, B_],
  93: ip,
  95: cm,
  96: wT
}, L$ = {
  null: [cm, F$]
}, V$ = {
  null: [42, 95]
}, z$ = {
  null: []
}, U$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: V$,
  contentInitial: D$,
  disable: z$,
  document: $$,
  flow: O$,
  flowInitial: R$,
  insideSpan: L$,
  string: P$,
  text: A$
}, Symbol.toStringTag, { value: "Module" }));
function M$(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(E),
    check: U($),
    consume: y,
    enter: H,
    exit: T,
    interrupt: U($, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: j,
    events: [],
    now: N,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(J) {
    return s = ir(s, J), w(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = rp(o, m.events, m), m.events);
  }
  function h(J, M) {
    return q$(v(J), M);
  }
  function v(J) {
    return B$(s, J);
  }
  function N() {
    const {
      _bufferIndex: J,
      _index: M,
      line: R,
      column: q,
      offset: ee
    } = i;
    return {
      _bufferIndex: J,
      _index: M,
      line: R,
      column: q,
      offset: ee
    };
  }
  function j(J) {
    a[J.line] = J.column, ie();
  }
  function w() {
    let J;
    for (; i._index < s.length; ) {
      const M = s[i._index];
      if (typeof M == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < M.length; )
          F(M.charCodeAt(i._bufferIndex));
      else
        F(M);
    }
  }
  function F(J) {
    u = u(J);
  }
  function y(J) {
    gn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ie()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function H(J, M) {
    const R = M || {};
    return R.type = J, R.start = N(), m.events.push(["enter", R, m]), l.push(R), R;
  }
  function T(J) {
    const M = l.pop();
    return M.end = N(), m.events.push(["exit", M, m]), M;
  }
  function E(J, M) {
    Z(J, M.from);
  }
  function $(J, M) {
    M.restore();
  }
  function U(J, M) {
    return R;
    function R(q, ee, ge) {
      let de, le, pe, W;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Ce(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          q
        ])
      ) : ke(q);
      function ke(Pe) {
        return Ue;
        function Ue(je) {
          const Le = je !== null && Pe[je], Te = je !== null && Pe.null, an = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(Te) ? Te : Te ? [Te] : []
          ];
          return Ce(an)(je);
        }
      }
      function Ce(Pe) {
        return de = Pe, le = 0, Pe.length === 0 ? ge : K(Pe[le]);
      }
      function K(Pe) {
        return Ue;
        function Ue(je) {
          return W = Q(), pe = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Be() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            M ? Object.assign(Object.create(m), M) : m,
            d,
            qe,
            Be
          )(je);
        }
      }
      function qe(Pe) {
        return J(pe, W), ee;
      }
      function Be(Pe) {
        return W.restore(), ++le < de.length ? K(de[le]) : ge;
      }
    }
  }
  function Z(J, M) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && Rr(m.events, M, m.events.length - M, J.resolve(m.events.slice(M), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function Q() {
    const J = N(), M = m.previous, R = m.currentConstruct, q = m.events.length, ee = Array.from(l);
    return {
      from: q,
      restore: ge
    };
    function ge() {
      i = J, m.previous = M, m.currentConstruct = R, m.events.length = q, l = ee, ie();
    }
  }
  function ie() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function B$(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function q$(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function H$(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      XE([U$, ...(e || {}).extensions || []])
    ),
    content: a(oT),
    defined: [],
    document: a(lT),
    flow: a(w$),
    lazy: {},
    string: a(I$),
    text: a(E$)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return M$(i, o, l);
    }
  }
}
function W$(e) {
  for (; !H_(e); )
    ;
  return e;
}
const Dh = /[\0\t\n\r]/g;
function K$() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Dh.lastIndex = f, m = Dh.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const G$ = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Y$(e) {
  return e.replace(G$, J$);
}
function J$(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return U_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return tp(r) || e;
}
const Q_ = {}.hasOwnProperty;
function Q$(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), X$(r)(W$(H$(r).document().write(K$()(e, n, !0))));
}
function X$(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(me),
      blockQuote: o(Te),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(an),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(an, s),
      codeText: o(we, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Xe),
      hardBreakEscape: o(he),
      hardBreakTrailing: o(he),
      htmlFlow: o(Ie, s),
      htmlFlowData: Q,
      htmlText: o(Ie, s),
      htmlTextData: Q,
      image: o(Ae),
      label: s,
      link: o(Re),
      listItem: o(C),
      listItemValue: h,
      listOrdered: o(ze, f),
      listUnordered: o(ze),
      paragraph: o(_),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(me),
      strong: o(D),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: E,
      autolink: d(),
      autolinkEmail: Le,
      autolinkProtocol: je,
      blockQuote: d(),
      characterEscapeValue: ie,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Pe,
      characterReference: Ue,
      codeFenced: d(w),
      codeFencedFence: j,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: N,
      codeFlowValue: ie,
      codeIndented: d(F),
      codeText: d(ee),
      codeTextData: ie,
      data: ie,
      definition: d(),
      definitionDestinationString: T,
      definitionLabelString: y,
      definitionTitleString: H,
      emphasis: d(),
      hardBreakEscape: d(M),
      hardBreakTrailing: d(M),
      htmlFlow: d(R),
      htmlFlowData: ie,
      htmlText: d(q),
      htmlTextData: ie,
      image: d(de),
      label: pe,
      labelText: le,
      lineEnding: J,
      link: d(ge),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: qe,
      resourceDestinationString: W,
      resourceTitleString: ke,
      resource: Ce,
      setextHeading: d(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: $,
      strong: d(),
      thematicBreak: d()
    }
  };
  X_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(O) {
    let z = {
      type: "root",
      children: []
    };
    const re = {
      stack: [z],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, fe = [];
    let be = -1;
    for (; ++be < O.length; )
      if (O[be][1].type === "listOrdered" || O[be][1].type === "listUnordered")
        if (O[be][0] === "enter")
          fe.push(be);
        else {
          const en = fe.pop();
          be = a(O, en, be);
        }
    for (be = -1; ++be < O.length; ) {
      const en = n[O[be][0]];
      Q_.call(en, O[be][1].type) && en[O[be][1].type].call(Object.assign({
        sliceSerialize: O[be][2].sliceSerialize
      }, re), O[be][1]);
    }
    if (re.tokenStack.length > 0) {
      const en = re.tokenStack[re.tokenStack.length - 1];
      (en[1] || Rh).call(re, void 0, en[0]);
    }
    for (z.position = {
      start: Kr(O.length > 0 ? O[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Kr(O.length > 0 ? O[O.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, be = -1; ++be < n.transforms.length; )
      z = n.transforms[be](z) || z;
    return z;
  }
  function a(O, z, re) {
    let fe = z - 1, be = -1, en = !1, pn, rn, dn, mn;
    for (; ++fe <= re; ) {
      const ln = O[fe];
      switch (ln[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          ln[0] === "enter" ? be++ : be--, mn = void 0;
          break;
        }
        case "lineEndingBlank": {
          ln[0] === "enter" && (pn && !mn && !be && !dn && (dn = fe), mn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          mn = void 0;
      }
      if (!be && ln[0] === "enter" && ln[1].type === "listItemPrefix" || be === -1 && ln[0] === "exit" && (ln[1].type === "listUnordered" || ln[1].type === "listOrdered")) {
        if (pn) {
          let vn = fe;
          for (rn = void 0; vn--; ) {
            const Ze = O[vn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              rn && (O[rn][1].type = "lineEndingBlank", en = !0), Ze[1].type = "lineEnding", rn = vn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          dn && (!rn || dn < rn) && (pn._spread = !0), pn.end = Object.assign({}, rn ? O[rn][1].start : ln[1].end), O.splice(rn || fe, 0, ["exit", pn, ln[2]]), fe++, re++;
        }
        if (ln[1].type === "listItemPrefix") {
          const vn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, ln[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          pn = vn, O.splice(fe, 0, ["enter", vn, ln[2]]), fe++, re++, dn = void 0, mn = !0;
        }
      }
    }
    return O[z][1]._spread = en, re;
  }
  function o(O, z) {
    return re;
    function re(fe) {
      l.call(this, O(fe), fe), z && z.call(this, fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(O, z, re) {
    this.stack[this.stack.length - 1].children.push(O), this.stack.push(O), this.tokenStack.push([z, re || void 0]), O.position = {
      start: Kr(z.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(O) {
    return z;
    function z(re) {
      O && O.call(this, re), m.call(this, re);
    }
  }
  function m(O, z) {
    const re = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== O.type && (z ? z.call(this, O, fe[0]) : (fe[1] || Rh).call(this, O, fe[0]));
    else throw new Error("Cannot close `" + O.type + "` (" + Ma({
      start: O.start,
      end: O.end
    }) + "): it’s not open");
    re.position.end = Kr(O.end);
  }
  function u() {
    return JE(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(O) {
    if (this.data.expectingFirstListItemValue) {
      const z = this.stack[this.stack.length - 2];
      z.start = Number.parseInt(this.sliceSerialize(O), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.lang = O;
  }
  function N() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.meta = O;
  }
  function j() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function w() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function F() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O.replace(/(\r?\n|\r)$/g, "");
  }
  function y(O) {
    const z = this.resume(), re = this.stack[this.stack.length - 1];
    re.label = z, re.identifier = Ai(this.sliceSerialize(O)).toLowerCase();
  }
  function H() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = O;
  }
  function T() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = O;
  }
  function E(O) {
    const z = this.stack[this.stack.length - 1];
    if (!z.depth) {
      const re = this.sliceSerialize(O).length;
      z.depth = re;
    }
  }
  function $() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(O) {
    const z = this.stack[this.stack.length - 1];
    z.depth = this.sliceSerialize(O).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(O) {
    const re = this.stack[this.stack.length - 1].children;
    let fe = re[re.length - 1];
    (!fe || fe.type !== "text") && (fe = G(), fe.position = {
      start: Kr(O.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, re.push(fe)), this.stack.push(fe);
  }
  function ie(O) {
    const z = this.stack.pop();
    z.value += this.sliceSerialize(O), z.position.end = Kr(O.end);
  }
  function J(O) {
    const z = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const re = z.children[z.children.length - 1];
      re.position.end = Kr(O.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(z.type) && (Q.call(this, O), ie.call(this, O));
  }
  function M() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O;
  }
  function q() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O;
  }
  function ee() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.value = O;
  }
  function ge() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = z, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function de() {
    const O = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const z = this.data.referenceType || "shortcut";
      O.type += "Reference", O.referenceType = z, delete O.url, delete O.title;
    } else
      delete O.identifier, delete O.label;
    this.data.referenceType = void 0;
  }
  function le(O) {
    const z = this.sliceSerialize(O), re = this.stack[this.stack.length - 2];
    re.label = Y$(z), re.identifier = Ai(z).toLowerCase();
  }
  function pe() {
    const O = this.stack[this.stack.length - 1], z = this.resume(), re = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, re.type === "link") {
      const fe = O.children;
      re.children = fe;
    } else
      re.alt = z;
  }
  function W() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.url = O;
  }
  function ke() {
    const O = this.resume(), z = this.stack[this.stack.length - 1];
    z.title = O;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function qe(O) {
    const z = this.resume(), re = this.stack[this.stack.length - 1];
    re.label = z, re.identifier = Ai(this.sliceSerialize(O)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(O) {
    this.data.characterReferenceType = O.type;
  }
  function Pe(O) {
    const z = this.sliceSerialize(O), re = this.data.characterReferenceType;
    let fe;
    re ? (fe = U_(z, re === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = tp(z);
    const be = this.stack[this.stack.length - 1];
    be.value += fe;
  }
  function Ue(O) {
    const z = this.stack.pop();
    z.position.end = Kr(O.end);
  }
  function je(O) {
    ie.call(this, O);
    const z = this.stack[this.stack.length - 1];
    z.url = this.sliceSerialize(O);
  }
  function Le(O) {
    ie.call(this, O);
    const z = this.stack[this.stack.length - 1];
    z.url = "mailto:" + this.sliceSerialize(O);
  }
  function Te() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function an() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function we() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Xe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function me() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function he() {
    return {
      type: "break"
    };
  }
  function Ie() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ae() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ze(O) {
    return {
      type: "list",
      ordered: O.type === "listOrdered",
      start: null,
      spread: O._spread,
      children: []
    };
  }
  function C(O) {
    return {
      type: "listItem",
      spread: O._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function G() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function Kr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function X_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? X_(e, i) : Z$(e, i);
  }
}
function Z$(e, n) {
  let r;
  for (r in n)
    if (Q_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Rh(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ma({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ma({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ma({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function eD(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return Q$(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function nD(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function tD(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function rD(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function iD(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function aD(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function oD(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ki(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function sD(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function lD(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function Z_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function cD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Z_(e, n);
  const a = { src: Ki(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function dD(e, n) {
  const r = { src: Ki(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function uD(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function mD(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return Z_(e, n);
  const a = { href: Ki(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function pD(e, n) {
  const r = { href: Ki(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function fD(e, n, r) {
  const i = e.all(n), a = r ? hD(r) : ex(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function hD(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = ex(r[i]);
  }
  return n;
}
function ex(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function yD(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function gD(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function vD(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function kD(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function bD(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Xm(n.children[1]), d = R_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function _D(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let N = { type: "element", tagName: o, properties: h, children: [] };
    f && (N.children = e.all(f), e.patch(f, N), N = e.applyData(f, N)), m.push(N);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function xD(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Oh = 9, Ph = 32;
function SD(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Ah(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Ah(n.slice(a), a > 0, !1)), o.join("");
}
function Ah(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Oh || o === Ph; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Oh || o === Ph; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function ND(e, n) {
  const r = { type: "text", value: SD(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function jD(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const wD = {
  blockquote: nD,
  break: tD,
  code: rD,
  delete: iD,
  emphasis: aD,
  footnoteReference: oD,
  heading: sD,
  html: lD,
  imageReference: cD,
  image: dD,
  inlineCode: uD,
  linkReference: mD,
  link: pD,
  listItem: fD,
  list: yD,
  paragraph: gD,
  // @ts-expect-error: root is different, but hard to type.
  root: vD,
  strong: kD,
  table: bD,
  tableCell: xD,
  tableRow: _D,
  text: ND,
  thematicBreak: jD,
  toml: So,
  yaml: So,
  definition: So,
  footnoteDefinition: So
};
function So() {
}
const nx = -1, Ms = 0, gs = 1, vs = 2, ap = 3, op = 4, sp = 5, lp = 6, tx = 7, rx = 8, Lh = typeof self == "object" ? self : globalThis, CD = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Ms:
      case nx:
        return r(s, a);
      case gs: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case vs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case ap:
        return r(new Date(s), a);
      case op: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case sp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case lp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case tx: {
        const { name: l, message: d } = s;
        return r(new Lh[l](d), a);
      }
      case rx:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Lh[o](s), a);
  };
  return i;
}, Vh = (e) => CD(/* @__PURE__ */ new Map(), e)(0), ji = "", { toString: FD } = {}, { keys: ID } = Object, pa = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ms, n];
  const r = FD.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [gs, ji];
    case "Object":
      return [vs, ji];
    case "Date":
      return [ap, ji];
    case "RegExp":
      return [op, ji];
    case "Map":
      return [sp, ji];
    case "Set":
      return [lp, ji];
  }
  return r.includes("Array") ? [gs, r] : r.includes("Error") ? [tx, r] : [vs, r];
}, No = ([e, n]) => e === Ms && (n === "function" || n === "symbol"), ED = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = pa(s);
    switch (l) {
      case Ms: {
        let u = s;
        switch (d) {
          case "bigint":
            l = rx, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([nx], s);
        }
        return a([l, u], s);
      }
      case gs: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case vs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of ID(s))
          (e || !No(pa(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case ap:
        return a([l, s.toISOString()], s);
      case op: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case sp: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(No(pa(h)) || No(pa(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case lp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !No(pa(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, zh = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return ED(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, ks = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Vh(zh(e, n)) : structuredClone(e)
) : (e, n) => Vh(zh(e, n));
function TD(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function $D(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function DD(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || TD, i = e.options.footnoteBackLabel || $D, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Ki(f.toLowerCase());
    let v = 0;
    const N = [], j = e.footnoteCounts.get(f);
    for (; j !== void 0 && ++v <= j; ) {
      N.length > 0 && N.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, v);
      typeof y == "string" && (y = { type: "text", value: y }), N.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const w = u[u.length - 1];
    if (w && w.type === "element" && w.tagName === "p") {
      const y = w.children[w.children.length - 1];
      y && y.type === "text" ? y.value += " " : w.children.push({ type: "text", value: " " }), w.children.push(...N);
    } else
      u.push(...N);
    const F = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, F), l.push(F);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...ks(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const ix = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return AD;
    if (typeof e == "function")
      return Bs(e);
    if (typeof e == "object")
      return Array.isArray(e) ? RD(e) : OD(e);
    if (typeof e == "string")
      return PD(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function RD(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = ix(e[r]);
  return Bs(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function OD(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Bs(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function PD(e) {
  return Bs(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Bs(e) {
  return n;
  function n(r, i, a) {
    return !!(LD(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function AD() {
  return !0;
}
function LD(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const ax = [], VD = !0, Uh = !1, zD = "skip";
function UD(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = ix(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = ax, N, j, w;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = MD(r(d, u)), v[0] === Uh))
        return v;
      if ("children" in d && d.children) {
        const F = (
          /** @type {UnistParent} */
          d
        );
        if (F.children && v[0] !== zD)
          for (j = (i ? F.children.length : -1) + s, w = u.concat(F); j > -1 && j < F.children.length; ) {
            const y = F.children[j];
            if (N = l(y, j, w)(), N[0] === Uh)
              return N;
            j = typeof N[1] == "number" ? N[1] : j + s;
          }
      }
      return v;
    }
  }
}
function MD(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [VD, e] : e == null ? ax : [e];
}
function ox(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), UD(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const dm = {}.hasOwnProperty, BD = {};
function qD(e, n) {
  const r = n || BD, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...wD, ...r.handlers }, l = {
    all: m,
    applyData: WD,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: HD,
    wrap: GD
  };
  return ox(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (dm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: j, ...w } = u, F = ks(w);
        return F.children = l.all(u), F;
      }
      return ks(u);
    }
    return (l.options.unknownHandler || KD)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const N = l.one(h[v], u);
        if (N) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(N) && N.type === "text" && (N.value = Mh(N.value)), !Array.isArray(N) && N.type === "element")) {
            const j = N.children[0];
            j && j.type === "text" && (j.value = Mh(j.value));
          }
          Array.isArray(N) ? f.push(...N) : f.push(N);
        }
      }
    }
    return f;
  }
}
function HD(e, n) {
  e.position && (n.position = wE(e));
}
function WD(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, ks(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function KD(e, n) {
  const r = n.data || {}, i = "value" in n && !(dm.call(r, "hProperties") || dm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function GD(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Mh(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Bh(e, n) {
  const r = qD(e, n), i = r.one(e, void 0), a = DD(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function YD(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Bh(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Bh(r, { file: i, ...e || n })
    );
  };
}
function qh(e) {
  if (e)
    throw e;
}
var Nl, Hh;
function JD() {
  if (Hh) return Nl;
  Hh = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return Nl = function d() {
    var m, u, f, h, v, N, j = arguments[0], w = 1, F = arguments.length, y = !1;
    for (typeof j == "boolean" && (y = j, j = arguments[1] || {}, w = 2), (j == null || typeof j != "object" && typeof j != "function") && (j = {}); w < F; ++w)
      if (m = arguments[w], m != null)
        for (u in m)
          f = l(j, u), h = l(m, u), j !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, N = f && a(f) ? f : []) : N = f && o(f) ? f : {}, s(j, { name: u, newValue: d(y, N, h) })) : typeof h < "u" && s(j, { name: u, newValue: h }));
    return j;
  }, Nl;
}
var QD = JD();
const jl = /* @__PURE__ */ Tm(QD);
function um(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function XD() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? ZD(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function ZD(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const wr = { basename: eR, dirname: nR, extname: tR, join: rR, sep: "/" };
function eR(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  lo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function nR(e) {
  if (lo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function tR(e) {
  lo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function rR(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    lo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : iR(r);
}
function iR(e) {
  lo(e);
  const n = e.codePointAt(0) === 47;
  let r = aR(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function aR(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function lo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const oR = { cwd: sR };
function sR() {
  return "/";
}
function mm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function lR(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!mm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return cR(e);
}
function cR(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const wl = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class sx {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? mm(n) ? r = { path: n } : typeof n == "string" || dR(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : oR.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < wl.length; ) {
      const o = wl[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      wl.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? wr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Fl(n, "basename"), Cl(n, "basename"), this.path = wr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? wr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Wh(this.basename, "dirname"), this.path = wr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? wr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Cl(n, "extname"), Wh(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = wr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    mm(n) && (n = lR(n)), Fl(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? wr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Fl(n, "stem"), Cl(n, "stem"), this.path = wr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Et(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Cl(e, n) {
  if (e && e.includes(wr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + wr.sep + "`"
    );
}
function Fl(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Wh(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function dR(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const uR = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), mR = {}.hasOwnProperty;
class cp extends uR {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = XD();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new cp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(jl(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Tl("data", this.frozen), this.namespace[n] = r, this) : mR.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Tl("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = jo(n), i = this.parser || this.Parser;
    return Il("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Il("process", this.parser || this.Parser), El("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = jo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), N = i.stringify(v, h);
        hR(N) ? h.value = N : h.result = N, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Il("processSync", this.parser || this.Parser), El("processSync", this.compiler || this.Compiler), this.process(n, a), Gh("processSync", "process", r), i;
    function a(o, s) {
      r = !0, qh(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Kh(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = jo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Gh("runSync", "run", i), a;
    function o(s, l) {
      qh(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = jo(r), a = this.compiler || this.Compiler;
    return El("stringify", a), Kh(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Tl("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = jl(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...N] = u;
        const j = i[h][1];
        um(j) && um(v) && (v = jl(!0, j, v)), i[h] = [m, v, ...N];
      }
    }
  }
}
const pR = new cp().freeze();
function Il(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function El(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Tl(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Kh(e) {
  if (!um(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Gh(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function jo(e) {
  return fR(e) ? e : new sx(e);
}
function fR(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function hR(e) {
  return typeof e == "string" || yR(e);
}
function yR(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const gR = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Yh = [], Jh = { allowDangerousHtml: !0 }, vR = /^(https?|ircs?|mailto|xmpp)$/i, kR = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function bR(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Yh, d = e.remarkPlugins || Yh, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Jh } : Jh, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || _R, v = pR().use(eD).use(d).use(YD, m).use(l), N = new sx();
  typeof i == "string" && (N.value = i);
  for (const y of kR)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + gR + y.id, void 0);
  const j = v.parse(N);
  let w = v.runSync(j, N);
  return a && (w = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      w.type === "root" ? w.children : [w]
    )
  }), ox(w, F), $E(w, {
    Fragment: Me.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Me.jsx,
    jsxs: Me.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function F(y, H, T) {
    if (y.type === "raw" && T && typeof H == "number")
      return u ? T.children.splice(H, 1) : T.children[H] = { type: "text", value: y.value }, H;
    if (y.type === "element") {
      let E;
      for (E in _l)
        if (Object.hasOwn(_l, E) && Object.hasOwn(y.properties, E)) {
          const $ = y.properties[E], U = _l[E];
          (U === null || U.includes(y.tagName)) && (y.properties[E] = h(String($ || ""), E, y));
        }
    }
    if (y.type === "element") {
      let E = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!E && r && typeof H == "number" && (E = !r(y, H, T)), E && T && typeof H == "number")
        return f && y.children ? T.children.splice(H, 1, ...y.children) : T.children.splice(H, 1), H;
    }
  }
}
function _R(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    vR.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var $l = { exports: {} }, fa = {}, Qh;
function xR() {
  if (Qh) return fa;
  Qh = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return fa.Fragment = r, fa.jsx = s, fa.jsxs = s, fa;
}
var wo = {}, Xh;
function SR() {
  return Xh || (Xh = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    wo.Fragment = i, wo.jsx = Rn, wo.jsxs = Bn;
  })()), wo;
}
var Zh;
function NR() {
  return Zh || (Zh = 1, process.env.NODE_ENV === "production" ? $l.exports = xR() : $l.exports = SR()), $l.exports;
}
var oe = NR();
const jR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, wR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, CR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, FR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, IR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, ER = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": jR,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": wR,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": CR,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": FR,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": IR
};
function co(e) {
  return ER[e] ?? {};
}
const TR = co(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), $R = co(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Co = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), DR = "_issueAvatar_kc0sw_1", RR = "_issueField_kc0sw_9", OR = "_issueDescription_kc0sw_12", Fo = {
  issueAvatar: DR,
  issueField: RR,
  issueDescription: OR
}, lx = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(Co, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Fo.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          Im,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(Co, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Fo.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(Co, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Fo.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(Co, { title: "Description", children: /* @__PURE__ */ oe.jsx(bR, { className: Fo.issueDescription, children: e.description }) })
] }), PR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), AR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), LR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), VR = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), zR = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), cx = {
  0: PR,
  1: zR,
  2: VR,
  3: LR,
  4: AR
}, UR = (e) => e in cx, bs = ({ priority: e }) => UR(e) ? cx[e] : /* @__PURE__ */ oe.jsx(Pn, { "data-testid": "defaultPriorityTag", children: e }), MR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), BR = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), qR = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), HR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), WR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), KR = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), pm = {
  backlog: (e, n) => MR(e, n),
  unstarted: (e, n) => BR(e, n),
  started: (e, n) => qR(e, n),
  done: (e, n) => HR(e, n),
  canceled: (e, n) => WR(e, n),
  completed: (e, n) => KR(e, n)
}, GR = (e) => e in pm, _s = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => GR(e) ? pm[e](n, r) : pm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), YR = "_wrapper_e0qj3_1", JR = "_resultTitle_e0qj3_21", QR = "_resultTooltipTitle_e0qj3_28", XR = "_resultLinkIcon_e0qj3_31", ha = {
  wrapper: YR,
  resultTitle: JR,
  resultTooltipTitle: QR,
  resultLinkIcon: XR
}, ZR = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Cm(KS()), o = tt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ge,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: ha.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              _s,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(bs, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Pn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ha.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(lx, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        ot.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ha.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    _s,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(bs, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "4", className: ha.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ue,
                  {
                    className: ha.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, eO = "_loader_13xpk_1", nO = "_dropdown_13xpk_8", tO = "_loadMore_13xpk_13", Dl = {
  loader: eO,
  dropdown: nO,
  loadMore: tO
}, rO = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = un(), [f, { data: h, loading: v, networkStatus: N }] = u(
    TR,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  gi(
    () => {
      !v && s !== "" && N === Gt.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), He(() => {
    v || o([]);
  }, [s]), He(() => {
    if (h && Object.keys(h).length > 0) {
      const w = h.Linear.searchIssues.edges.map(
        ({ node: T }) => T
      ), F = a.filter(
        (T) => !n.find((E) => E.id === T.id)
      ), y = F.filter(
        (T) => !w.find(
          (E) => E.id === T.id
        )
      ), H = w.filter(
        (T) => !n.find((E) => E.id === T.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...H] : H
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...F, ...w] : w
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const j = () => {
    !v && s !== "" && N === Gt.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    Yr,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (w) => w?.title,
      onChange: (w) => e(w.selectedValues[0]),
      dropdownProps: { className: Dl.dropdown },
      filter: {
        value: s,
        onChange: (w) => {
          const F = w.target.value;
          l(F);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((w) => /* @__PURE__ */ oe.jsx(ZR, { issue: w }, w.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => j(),
            className: Dl.loadMore,
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Dl.loader, children: /* @__PURE__ */ oe.jsx(cn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, iO = "_collapse_su0f9_1", aO = "_collapseHeader_su0f9_8", oO = "_collapseContent_su0f9_31", sO = "_url_su0f9_35", lO = "_externalLink_su0f9_51", cO = "_emptyState_su0f9_55", Gr = {
  collapse: iO,
  collapseHeader: aO,
  collapseContent: oO,
  url: sO,
  externalLink: lO,
  emptyState: cO
}, dO = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = kn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: Gr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          St,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            ar,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: Gr.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(ar.Header, { className: Gr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ge, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        _s,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        A.ExternalLink,
                        {
                          className: Gr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(ue, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ge, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(bs, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Pn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(ar.Content, { className: Gr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Pn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(lx, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    St,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
                      variant: "tertiary",
                      className: Gr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ue, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          St,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ue, { name: "external-link" }),
            variant: "tertiary",
            className: Gr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, uO = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, dx = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => dx(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, mO = "_modalBody_iv3ua_1", pO = "_error_iv3ua_5", fO = "_dropdown_iv3ua_16", wi = {
  modalBody: mO,
  error: pO,
  dropdown: fO
}, hO = co(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), yO = co(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), gO = co(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), vO = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = un(), { control: m, handleSubmit: u, reset: f } = lr(), [h, v] = se([]), [N, j] = se(), [w, F] = se([]), [y, H] = se(), [T, E] = se([]), [$, U] = se(), [Z, Q] = se([]), [ie, J] = se(), [M, R] = se([]), [q, ee] = se(), [ge, de] = se(!1), { useMutation: le } = un(), { track: pe } = kn(), [W, { loading: ke }] = le(
    hO,
    {
      onError: () => {
        de(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (we) => {
        const We = {
          identifier: we.Linear?.issueCreate?.issue?.identifier,
          url: we.Linear?.issueCreate?.issue?.url
        };
        we.Linear && we.Linear?.issueCreate?.issue?.id && (a(we.Linear?.issueCreate?.issue?.id), Le(We), de(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${we.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), pe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: K, loading: qe, error: Be }
  ] = l(yO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (we) => {
      const We = we.Linear.teams.edges.map(
        ({ node: Xe }) => Xe
      );
      v(We), Q(we.Linear.issuePriorityValues), s(`${CO}${we.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Ue, loading: je }] = l(gO, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (we) => {
      const We = we?.Linear?.team?.projects?.edges?.map(
        ({ node: he }) => he
      );
      F(We);
      const Xe = we?.Linear?.team?.states?.edges?.map(
        ({ node: he }) => he
      );
      E(Xe);
      const me = we?.Linear?.team?.templates?.edges?.map(
        ({ node: he }) => he
      );
      R(
        me.filter(
          (he) => he.type === "issue"
        )
      );
    }
  }), Le = (we) => {
    r(!1), H(void 0), j(void 0), U(void 0), J(void 0), ee(void 0), we && (e(we), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Te = (we) => {
    K && !qe && (W({
      variables: {
        issueTitle: we.title,
        issueDescription: we?.description,
        teamId: we.team.id,
        projectId: we?.project?.id,
        statusId: we?.status?.id,
        priority: we?.priority?.priority
      }
    }), de(!0));
  };
  He(() => {
    n && Ce();
  }, [n]);
  const an = () => {
    pe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    Nt,
    {
      isOpen: n,
      onClose: () => {
        an(), Le();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          jt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              an(), Le();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            className: wi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ oe.jsx(In, { error: Be }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(Te), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(Ut, { children: [
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: we, onChange: We },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ oe.jsx(
                    Ln,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Xe?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        Yr,
                        {
                          dropdownProps: { className: wi.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [wi.error]: Xe }),
                          getItemTitleByValue: (me) => me?.name,
                          onChange: (me) => {
                            H(void 0), U(void 0), J(void 0), ee(void 0), j(me.selectedValues[0]), Pe({
                              variables: { teamId: me.selectedValues[0].id }
                            }), We(me.selectedValues[0]);
                          },
                          value: N ? [we] : void 0,
                          children: h?.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: we, onChange: We } }) => {
                    const Xe = je ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Linear project" : "Select a Team first",
                        onChange: (me) => {
                          H(me.selectedValues[0]), We(me.selectedValues[0]);
                        },
                        value: y ? [we] : Xe,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          Ue && !je && w.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 6, children: /* @__PURE__ */ oe.jsx(Ln, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                Yr,
                {
                  clearable: !0,
                  dropdownProps: { className: wi.dropdown },
                  disabled: !N || je,
                  placeholder: N ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (we) => we?.name,
                  onChange: (we) => {
                    if (we.selectedValues.length > 0) {
                      ee(we.selectedValues[0]);
                      const We = JSON.parse(
                        we.selectedValues[0].templateData
                      ), Xe = Z.filter(
                        (Ae) => Ae.priority === We.priority
                      );
                      J(
                        Xe ? Xe[0] : void 0
                      );
                      const me = T.filter(
                        (Ae) => Ae.id === We.stateId
                      );
                      U(
                        me ? me[0] : void 0
                      );
                      const he = w.filter(
                        (Ae) => Ae.id === We.projectId
                      );
                      H(
                        he ? he[0] : void 0
                      );
                      const Ie = We.description;
                      f({
                        title: We?.title,
                        priority: Xe[0],
                        status: me[0],
                        project: he[0],
                        description: Ie ? dx(Ie, uO) : "",
                        team: N
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: N
                      }), H(void 0), J(void 0), U(void 0), ee(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: M?.map((we) => /* @__PURE__ */ oe.jsx(
                    ot.Item,
                    {
                      value: we,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx(A.Paragraph, { children: we.name })
                    },
                    we.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: we, value: We },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ oe.jsx(
                    or,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: we
                      },
                      meta: {
                        error: Xe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: we, onChange: We } }) => {
                    const Xe = je ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.name,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue status" : "Select a Team first",
                        onChange: (me) => {
                          U(me.selectedValues[0]), We(me.selectedValues[0]);
                        },
                        value: $ ? [we] : Xe,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          Ue && !je && T.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      _s,
                                      {
                                        type: me.type,
                                        color: me.color,
                                        name: me.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.name })
                                  ]
                                }
                              )
                            },
                            me.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: we, onChange: We } }) => {
                    const Xe = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(Ln, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      Yr,
                      {
                        clearable: !0,
                        getItemTitleByValue: (me) => me?.label,
                        disabled: N === void 0,
                        placeholder: N ? "Select Issue priority" : "Select a Team first",
                        onChange: (me) => {
                          J(me.selectedValues[0]), We(me.selectedValues[0]);
                        },
                        value: ie ? [we] : Xe,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          je && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(cn, { size: 24 })
                            }
                          ),
                          K && !qe && Z.map((me) => /* @__PURE__ */ oe.jsx(
                            ot.Item,
                            {
                              value: me,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      bs,
                                      {
                                        priority: me.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx(A.Paragraph, { children: me.label })
                                  ]
                                }
                              )
                            },
                            me.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(tn, { children: /* @__PURE__ */ oe.jsx(
                Lt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: we, value: We },
                    fieldState: { error: Xe }
                  }) => /* @__PURE__ */ oe.jsx(
                    HS,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: we
                      },
                      meta: {
                        error: Xe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          It,
          {
            confirmOnClick: u(Te),
            confirmProps: {
              disabled: ke || !K,
              isLoading: ge || qe || je,
              loadingIndicator: /* @__PURE__ */ oe.jsx(cn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              an(), Le();
            }
          }
        )
      ]
    }
  );
}, kO = "_modalWrapper_4kh9u_1", bO = "_copyButton_4kh9u_6", _O = "_copyWrapper_4kh9u_15", xO = "_copyField_4kh9u_24", SO = "_externalLink_4kh9u_47", NO = "_externalLinkIcon_4kh9u_52", jO = "_textWrapper_4kh9u_56", ti = {
  modalWrapper: kO,
  copyButton: bO,
  copyWrapper: _O,
  copyField: xO,
  externalLink: SO,
  externalLinkIcon: NO,
  textWrapper: jO
}, wO = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  Nt,
  {
    isOpen: !!n && e,
    className: ti.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        jt,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(wt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs(A.Paragraph, { className: ti.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ti.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ue, { name: "external-link", className: ti.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(Ln, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ti.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    kr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ti.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    WS,
                    {
                      className: ti.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        It,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), CO = "https://linear.app/", FO = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: N } = un(), [j, w] = se(""), F = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: H } = kn(), {
    loading: T,
    data: E,
    error: $,
    store: U
  } = wm(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ie,
      networkStatus: J,
      error: M
    }
  ] = N($R, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    !T && !$ && E && E?.linear?.issues?.length > 0 ? (o(E.linear.issues), Z({
      variables: {
        linkedIssues: E.linear.issues
      }
    })) : !T && !$ && (i([]), o([]));
  }, [E, T, $]), He(() => {
    Q && Q?.Linear && !ie && J === Gt.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: de }) => de));
  }, [Q, ie, J]);
  const R = (de) => {
    de && de?.team?.organization?.urlKey && H("linear:link:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: de.id
    });
    const le = (pe) => pe.id === de?.id;
    r.some((pe) => pe && le(pe)) || (E && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, de.id]
      }
    }));
  }, q = (de) => {
    const le = E?.linear.issues.filter((pe) => pe !== de) || [];
    H("linear:unlink:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: de
    }), i(r.filter(({ id: pe }) => pe !== de)), o(le), U({
      linear: {
        issues: le
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ge = T || ie || !E && !$ || (E?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !T && !ie && (M || $) ? /* @__PURE__ */ oe.jsx(In, { error: M || $ }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      Nt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            jt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(wt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            It,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      vO,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (de) => m(de),
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        addToLinkedIssueIds: (de) => {
          U({
            linear: {
              issues: [...a, de]
            }
          });
        },
        setCreatedIssue: (de) => v(de),
        organizationUrl: j,
        setOrganizationUrl: (de) => w(de)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      wO,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          F && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  H("linear:create:new:issue:clicked", {
                    linearInstanceUrl: j
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(rO, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      dO,
      {
        linkedIssues: r,
        isLoading: ge,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (de) => l(de),
        showUnlinkAllButton: y,
        organizationUrl: j
      }
    )
  ] });
}, IO = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: eo
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Rl = { exports: {} }, ya = {}, ey;
function EO() {
  if (ey) return ya;
  ey = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ya.Fragment = r, ya.jsx = s, ya.jsxs = s, ya;
}
var Io = {}, ny;
function TO() {
  return ny || (ny = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Io.Fragment = i, Io.jsx = Rn, Io.jsxs = Bn;
  })()), Io;
}
var ty;
function $O() {
  return ty || (ty = 1, process.env.NODE_ENV === "production" ? Rl.exports = EO() : Rl.exports = TO()), Rl.exports;
}
var De = $O();
const DO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, RO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, OO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, PO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, AO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, LO = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": DO,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": RO,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": OO,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": PO,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": AO
};
function qs(e) {
  return LO[e] ?? {};
}
const VO = qs(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), zO = qs(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), UO = qs(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), MO = qs(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Ol(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BO = "_wrapper_27vny_1", qO = "_copyIcon_27vny_12", ga = {
  wrapper: BO,
  copyIcon: qO
}, HO = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Ol(), { isCopied: i, copy: a } = Ol(), { isCopied: o, copy: s } = Ol();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: N,
    referral_url: j
  } = e, w = f ? An(f).isSame(Date.now(), "day") : !1, { name: F, first_name: y, last_name: H } = m ?? {}, T = F ?? (`${y} ${H}`.trim() || "A customer has no name"), E = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ De.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ De.jsxs(b, { className: ga.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ga.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-2", children: T }),
          w && /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", color: "secondary", children: An(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ De.jsx(b, { gap: "200", children: /* @__PURE__ */ De.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      An(N).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "mail" }),
        /* @__PURE__ */ De.jsx(A.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: ga.copyIcon
        }
      ) })
    ] }),
    E && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "link" }),
        /* @__PURE__ */ De.jsx(Ge, { content: "Shopify shop", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: E,
            target: "_blank",
            rel: "noreferrer",
            children: E.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(E),
          className: ga.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ De.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ De.jsx(ue, { size: l, name: "external-link" }),
        /* @__PURE__ */ De.jsx(Ge, { content: "Referral link", children: /* @__PURE__ */ De.jsx(
          A.ExternalLink,
          {
            href: j,
            target: "_blank",
            rel: "noreferrer",
            children: j.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ De.jsx(Ge, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: ga.copyIcon
        }
      ) })
    ] })
  ] }) });
}, WO = "_list_1q5b5_5", KO = "_listItem_1q5b5_8", GO = "_listItemEdit_1q5b5_15", YO = "_notificationText_1q5b5_19", Ui = {
  list: WO,
  listItem: KO,
  listItemEdit: GO,
  notificationText: YO
}, JO = "_modalBody_1clhs_1", QO = {
  modalBody: JO
}, XO = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [N, { loading: j }] = o(
    UO,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [w, { loading: F }] = o(MO), y = j || F, H = !!h, T = n === d ? "Change the value to update the points" : "", E = isNaN(d), $ = E ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && N({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((M) => {
      const R = M?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && w({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((M) => {
      M.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in M && (l("loyaltylion:remove:points:failed"), v(
        M.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ie = () => {
    E && m(n), f(""), i();
  }, J = () => {
    a(), ie();
  };
  return /* @__PURE__ */ De.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: ie,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ De.jsx(jt, { title: "Change points", onClose: ie }),
        /* @__PURE__ */ De.jsxs(wt, { className: QO.modalBody, children: [
          /* @__PURE__ */ De.jsxs(Ut, { children: [
            /* @__PURE__ */ De.jsx(tn, { span: 6, children: /* @__PURE__ */ De.jsx(
              or,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || $,
                  warning: T
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (M) => m(M?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ De.jsx(tn, { span: 6, children: /* @__PURE__ */ De.jsx(
              or,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (M) => f(M?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && H && /* @__PURE__ */ De.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ De.jsx(Ke, { children: h?.map((M, R) => /* @__PURE__ */ De.jsx(
            Ke.Item,
            {
              variant: "dense",
              title: M,
              contentLeft: /* @__PURE__ */ De.jsx(
                ue,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ De.jsx(
          It,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: y,
              disabled: E || U || n === d,
              loadingIndicator: /* @__PURE__ */ De.jsx(cn, { size: 16 })
            },
            cancelOnClick: ie
          }
        )
      ]
    }
  );
}, ZO = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ De.jsx(Ke.Text, { variant: "dense", className: Ui.listItem, children: /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ De.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ De.jsx(Ge, { content: "Edit points", children: /* @__PURE__ */ De.jsx(
        ue,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ui.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ De.jsx(Un, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, eP = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ De.jsx(Ke, { className: Ui.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ De.jsx(
      ZO,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ De.jsx(
      XO,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, nP = "_reward_1wxia_1", tP = {
  reward: nP
}, rP = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ De.jsx(b, { gap: "100", flexDirection: "column", className: tP.reward, children: /* @__PURE__ */ De.jsx(Ge, { content: a ?? "No description", children: /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ De.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ De.jsx(ue, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ De.jsxs(Un, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ De.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: 14, name: "external-link" }),
      /* @__PURE__ */ De.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, iP = ({ customer: e }) => {
  const { useQuery: n } = un(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(zO, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (He(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return no({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ui.notificationText,
        children: "No rewards found"
      }
    ) : yb({ errors: d }) ? /* @__PURE__ */ De.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Ui.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ De.jsx(In, { error: s });
  }
  return /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ De.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : /* @__PURE__ */ De.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ De.jsx(rP, { reward: d }, d.id)) })
  ] });
}, aP = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ De.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(
        ue,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ De.jsx(b, { alignItems: "start", children: /* @__PURE__ */ De.jsx(Ge, { content: "Insights segment", children: /* @__PURE__ */ De.jsx(Pn, { children: /* @__PURE__ */ De.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ De.jsx(ue, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, oP = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), { track: i } = kn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: N,
    refetch: j
  } = r(VO, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return He(() => {
    if (N && !h) {
      const w = (N?.LoyaltyLion?.getCustomers).customers;
      w && w.length > 0 && (o(w[0]), i("loyaltylion:customer:received"));
    }
  }, [N, h]), s?.email ? v ? no({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ De.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ui.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ De.jsx(In, { error: v }) : h ? /* @__PURE__ */ De.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ De.jsx(cn, {}) }) : f ? /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ De.jsxs(De.Fragment, { children: [
        l && /* @__PURE__ */ De.jsx(HO, { customer: a }),
        d && /* @__PURE__ */ De.jsx(aP, { customer: a }),
        m && /* @__PURE__ */ De.jsx(
          eP,
          {
            customer: a,
            refetchCustomerData: j
          }
        ),
        u && /* @__PURE__ */ De.jsx(iP, { customer: a })
      ] }) : /* @__PURE__ */ De.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ De.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, sP = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Pl = { exports: {} }, va = {}, ry;
function lP() {
  if (ry) return va;
  ry = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return va.Fragment = r, va.jsx = s, va.jsxs = s, va;
}
var Eo = {}, iy;
function cP() {
  return iy || (iy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Eo.Fragment = i, Eo.jsx = Rn, Eo.jsxs = Bn;
  })()), Eo;
}
var ay;
function dP() {
  return ay || (ay = 1, process.env.NODE_ENV === "production" ? Pl.exports = lP() : Pl.exports = cP()), Pl.exports;
}
var wn = dP();
const uP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, mP = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": uP
};
function pP(e) {
  return mP[e] ?? {};
}
const {
  entries: ux,
  setPrototypeOf: oy,
  isFrozen: fP,
  getPrototypeOf: hP,
  getOwnPropertyDescriptor: yP
} = Object;
let {
  freeze: Vt,
  seal: sr,
  create: La
} = Object, {
  apply: fm,
  construct: hm
} = typeof Reflect < "u" && Reflect;
Vt || (Vt = function(e) {
  return e;
});
sr || (sr = function(e) {
  return e;
});
fm || (fm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
hm || (hm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const ka = zt(Array.prototype.forEach), gP = zt(Array.prototype.lastIndexOf), sy = zt(Array.prototype.pop), ba = zt(Array.prototype.push), vP = zt(Array.prototype.splice), Zo = zt(String.prototype.toLowerCase), Al = zt(String.prototype.toString), Ll = zt(String.prototype.match), Ci = zt(String.prototype.replace), kP = zt(String.prototype.indexOf), bP = zt(String.prototype.trim), mr = zt(Object.prototype.hasOwnProperty), Tt = zt(RegExp.prototype.test), _a = _P(TypeError);
function zt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return fm(e, n, i);
  };
}
function _P(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return hm(e, r);
  };
}
function Tn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Zo;
  oy && oy(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (fP(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function xP(e) {
  for (let n = 0; n < e.length; n++)
    mr(e, n) || (e[n] = null);
  return e;
}
function jr(e) {
  const n = La(null);
  for (const [r, i] of ux(e))
    mr(e, r) && (Array.isArray(i) ? n[r] = xP(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = jr(i) : n[r] = i);
  return n;
}
function xa(e, n) {
  for (; e !== null; ) {
    const i = yP(e, n);
    if (i) {
      if (i.get)
        return zt(i.get);
      if (typeof i.value == "function")
        return zt(i.value);
    }
    e = hP(e);
  }
  function r() {
    return null;
  }
  return r;
}
const ly = Vt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Vl = Vt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), zl = Vt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), SP = Vt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ul = Vt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), NP = Vt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), cy = Vt(["#text"]), dy = Vt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ml = Vt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), uy = Vt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), To = Vt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), jP = sr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), wP = sr(/<%[\w\W]*|[\w\W]*%>/gm), CP = sr(/\$\{[\w\W]*/gm), FP = sr(/^data-[\-\w.\u00B7-\uFFFF]+$/), IP = sr(/^aria-[\-\w]+$/), mx = sr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), EP = sr(/^(?:\w+script|data):/i), TP = sr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), px = sr(/^html$/i), $P = sr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var my = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: IP,
  ATTR_WHITESPACE: TP,
  CUSTOM_ELEMENT: $P,
  DATA_ATTR: FP,
  DOCTYPE_NAME: px,
  ERB_EXPR: wP,
  IS_ALLOWED_URI: mx,
  IS_SCRIPT_OR_DATA: EP,
  MUSTACHE_EXPR: jP,
  TMPLIT_EXPR: CP
});
const Sa = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, DP = function() {
  return typeof window > "u" ? null : window;
}, RP = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, py = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function fx() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DP();
  const n = (x) => fx(x);
  if (n.version = "3.4.0", n.removed = [], !e || !e.document || e.document.nodeType !== Sa.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, N = d.prototype, j = xa(N, "cloneNode"), w = xa(N, "remove"), F = xa(N, "nextSibling"), y = xa(N, "childNodes"), H = xa(N, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let T, E = "";
  const {
    implementation: $,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = r, {
    importNode: ie
  } = i;
  let J = py();
  n.isSupported = typeof ux == "function" && typeof H == "function" && $ && $.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: M,
    ERB_EXPR: R,
    TMPLIT_EXPR: q,
    DATA_ATTR: ee,
    ARIA_ATTR: ge,
    IS_SCRIPT_OR_DATA: de,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: pe
  } = my;
  let {
    IS_ALLOWED_URI: W
  } = my, ke = null;
  const Ce = Tn({}, [...ly, ...Vl, ...zl, ...Ul, ...cy]);
  let K = null;
  const qe = Tn({}, [...dy, ...Ml, ...uy, ...To]);
  let Be = Object.seal(La(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Ue = null;
  const je = Object.seal(La(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Le = !0, Te = !0, an = !1, we = !0, We = !1, Xe = !0, me = !1, he = !1, Ie = !1, Ae = !1, Re = !1, ze = !1, C = !0, _ = !1;
  const D = "user-content-";
  let G = !0, Y = !1, O = {}, z = null;
  const re = Tn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let fe = null;
  const be = Tn({}, ["audio", "video", "img", "source", "image", "track"]);
  let en = null;
  const pn = Tn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", dn = "http://www.w3.org/2000/svg", mn = "http://www.w3.org/1999/xhtml";
  let ln = mn, vn = !1, Ze = null;
  const xn = Tn({}, [rn, dn, mn], Al);
  let Oe = Tn({}, ["mi", "mo", "mn", "ms", "mtext"]), on = Tn({}, ["annotation-xml"]);
  const sn = Tn({}, ["title", "style", "font", "a", "script"]);
  let hn = null;
  const Hn = ["application/xhtml+xml", "text/html"], Sn = "text/html";
  let yn = null, fn = null;
  const Nn = r.createElement("form"), Mn = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Vn = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(fn && fn === x)) {
      if ((!x || typeof x != "object") && (x = {}), x = jr(x), hn = // eslint-disable-next-line unicorn/prefer-includes
      Hn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? Sn : x.PARSER_MEDIA_TYPE, yn = hn === "application/xhtml+xml" ? Al : Zo, ke = mr(x, "ALLOWED_TAGS") ? Tn({}, x.ALLOWED_TAGS, yn) : Ce, K = mr(x, "ALLOWED_ATTR") ? Tn({}, x.ALLOWED_ATTR, yn) : qe, Ze = mr(x, "ALLOWED_NAMESPACES") ? Tn({}, x.ALLOWED_NAMESPACES, Al) : xn, en = mr(x, "ADD_URI_SAFE_ATTR") ? Tn(jr(pn), x.ADD_URI_SAFE_ATTR, yn) : pn, fe = mr(x, "ADD_DATA_URI_TAGS") ? Tn(jr(be), x.ADD_DATA_URI_TAGS, yn) : be, z = mr(x, "FORBID_CONTENTS") ? Tn({}, x.FORBID_CONTENTS, yn) : re, Pe = mr(x, "FORBID_TAGS") ? Tn({}, x.FORBID_TAGS, yn) : jr({}), Ue = mr(x, "FORBID_ATTR") ? Tn({}, x.FORBID_ATTR, yn) : jr({}), O = mr(x, "USE_PROFILES") ? x.USE_PROFILES : !1, Le = x.ALLOW_ARIA_ATTR !== !1, Te = x.ALLOW_DATA_ATTR !== !1, an = x.ALLOW_UNKNOWN_PROTOCOLS || !1, we = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, We = x.SAFE_FOR_TEMPLATES || !1, Xe = x.SAFE_FOR_XML !== !1, me = x.WHOLE_DOCUMENT || !1, Ae = x.RETURN_DOM || !1, Re = x.RETURN_DOM_FRAGMENT || !1, ze = x.RETURN_TRUSTED_TYPE || !1, Ie = x.FORCE_BODY || !1, C = x.SANITIZE_DOM !== !1, _ = x.SANITIZE_NAMED_PROPS || !1, G = x.KEEP_CONTENT !== !1, Y = x.IN_PLACE || !1, W = x.ALLOWED_URI_REGEXP || mx, ln = x.NAMESPACE || mn, Oe = x.MATHML_TEXT_INTEGRATION_POINTS || Oe, on = x.HTML_INTEGRATION_POINTS || on, Be = x.CUSTOM_ELEMENT_HANDLING || La(null), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Be.tagNameCheck = x.CUSTOM_ELEMENT_HANDLING.tagNameCheck), x.CUSTOM_ELEMENT_HANDLING && Mn(x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Be.attributeNameCheck = x.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = x.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), We && (Te = !1), Re && (Ae = !0), O && (ke = Tn({}, cy), K = La(null), O.html === !0 && (Tn(ke, ly), Tn(K, dy)), O.svg === !0 && (Tn(ke, Vl), Tn(K, Ml), Tn(K, To)), O.svgFilters === !0 && (Tn(ke, zl), Tn(K, Ml), Tn(K, To)), O.mathMl === !0 && (Tn(ke, Ul), Tn(K, uy), Tn(K, To))), je.tagCheck = null, je.attributeCheck = null, x.ADD_TAGS && (typeof x.ADD_TAGS == "function" ? je.tagCheck = x.ADD_TAGS : (ke === Ce && (ke = jr(ke)), Tn(ke, x.ADD_TAGS, yn))), x.ADD_ATTR && (typeof x.ADD_ATTR == "function" ? je.attributeCheck = x.ADD_ATTR : (K === qe && (K = jr(K)), Tn(K, x.ADD_ATTR, yn))), x.ADD_URI_SAFE_ATTR && Tn(en, x.ADD_URI_SAFE_ATTR, yn), x.FORBID_CONTENTS && (z === re && (z = jr(z)), Tn(z, x.FORBID_CONTENTS, yn)), x.ADD_FORBID_CONTENTS && (z === re && (z = jr(z)), Tn(z, x.ADD_FORBID_CONTENTS, yn)), G && (ke["#text"] = !0), me && Tn(ke, ["html", "head", "body"]), ke.table && (Tn(ke, ["tbody"]), delete Pe.tbody), x.TRUSTED_TYPES_POLICY) {
        if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw _a('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw _a('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        T = x.TRUSTED_TYPES_POLICY, E = T.createHTML("");
      } else
        T === void 0 && (T = RP(v, a)), T !== null && typeof E == "string" && (E = T.createHTML(""));
      Vt && Vt(x), fn = x;
    }
  }, bn = Tn({}, [...Vl, ...zl, ...SP]), _n = Tn({}, [...Ul, ...NP]), Wn = function(x) {
    let V = H(x);
    (!V || !V.tagName) && (V = {
      namespaceURI: ln,
      tagName: "template"
    });
    const X = Zo(x.tagName), Ne = Zo(V.tagName);
    return Ze[x.namespaceURI] ? x.namespaceURI === dn ? V.namespaceURI === mn ? X === "svg" : V.namespaceURI === rn ? X === "svg" && (Ne === "annotation-xml" || Oe[Ne]) : !!bn[X] : x.namespaceURI === rn ? V.namespaceURI === mn ? X === "math" : V.namespaceURI === dn ? X === "math" && on[Ne] : !!_n[X] : x.namespaceURI === mn ? V.namespaceURI === dn && !on[Ne] || V.namespaceURI === rn && !Oe[Ne] ? !1 : !_n[X] && (sn[X] || !bn[X]) : !!(hn === "application/xhtml+xml" && Ze[x.namespaceURI]) : !1;
  }, Dn = function(x) {
    ba(n.removed, {
      element: x
    });
    try {
      H(x).removeChild(x);
    } catch {
      w(x);
    }
  }, Rn = function(x, V) {
    try {
      ba(n.removed, {
        attribute: V.getAttributeNode(x),
        from: V
      });
    } catch {
      ba(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(x), x === "is")
      if (Ae || Re)
        try {
          Dn(V);
        } catch {
        }
      else
        try {
          V.setAttribute(x, "");
        } catch {
        }
  }, Bn = function(x) {
    let V = null, X = null;
    if (Ie)
      x = "<remove></remove>" + x;
    else {
      const ne = Ll(x, /^[\r\n\t ]+/);
      X = ne && ne[0];
    }
    hn === "application/xhtml+xml" && ln === mn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const Ne = T ? T.createHTML(x) : x;
    if (ln === mn)
      try {
        V = new h().parseFromString(Ne, hn);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = $.createDocument(ln, "template", null);
      try {
        V.documentElement.innerHTML = vn ? E : Ne;
      } catch {
      }
    }
    const xe = V.body || V.documentElement;
    return x && X && xe.insertBefore(r.createTextNode(X), xe.childNodes[0] || null), ln === mn ? Q.call(V, me ? "html" : "body")[0] : me ? V.documentElement : xe;
  }, t = function(x) {
    return U.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof u) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, p = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function g(x, V, X) {
    ka(x, (Ne) => {
      Ne.call(n, V, X, fn);
    });
  }
  const P = function(x) {
    let V = null;
    if (g(J.beforeSanitizeElements, x, null), c(x))
      return Dn(x), !0;
    const X = yn(x.nodeName);
    if (g(J.uponSanitizeElement, x, {
      tagName: X,
      allowedTags: ke
    }), Xe && x.hasChildNodes() && !p(x.firstElementChild) && Tt(/<[/\w!]/g, x.innerHTML) && Tt(/<[/\w!]/g, x.textContent) || Xe && x.namespaceURI === mn && X === "style" && p(x.firstElementChild) || x.nodeType === Sa.progressingInstruction || Xe && x.nodeType === Sa.comment && Tt(/<[/\w]/g, x.data))
      return Dn(x), !0;
    if (Pe[X] || !(je.tagCheck instanceof Function && je.tagCheck(X)) && !ke[X]) {
      if (!Pe[X] && I(X) && (Be.tagNameCheck instanceof RegExp && Tt(Be.tagNameCheck, X) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(X)))
        return !1;
      if (G && !z[X]) {
        const Ne = H(x) || x.parentNode, xe = y(x) || x.childNodes;
        if (xe && Ne) {
          const ne = xe.length;
          for (let nn = ne - 1; nn >= 0; --nn) {
            const En = j(xe[nn], !0);
            En.__removalCount = (x.__removalCount || 0) + 1, Ne.insertBefore(En, F(x));
          }
        }
      }
      return Dn(x), !0;
    }
    return x instanceof d && !Wn(x) || (X === "noscript" || X === "noembed" || X === "noframes") && Tt(/<\/no(script|embed|frames)/i, x.innerHTML) ? (Dn(x), !0) : (We && x.nodeType === Sa.text && (V = x.textContent, ka([M, R, q], (Ne) => {
      V = Ci(V, Ne, " ");
    }), x.textContent !== V && (ba(n.removed, {
      element: x.cloneNode()
    }), x.textContent = V)), g(J.afterSanitizeElements, x, null), !1);
  }, L = function(x, V, X) {
    if (Ue[V] || C && (V === "id" || V === "name") && (X in r || X in Nn))
      return !1;
    if (!(Te && !Ue[V] && Tt(ee, V)) && !(Le && Tt(ge, V)) && !(je.attributeCheck instanceof Function && je.attributeCheck(V, x))) {
      if (!K[V] || Ue[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(I(x) && (Be.tagNameCheck instanceof RegExp && Tt(Be.tagNameCheck, x) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(x)) && (Be.attributeNameCheck instanceof RegExp && Tt(Be.attributeNameCheck, V) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(V, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && Tt(Be.tagNameCheck, X) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(X)))
        ) return !1;
      } else if (!en[V] && !Tt(W, Ci(X, le, "")) && !((V === "src" || V === "xlink:href" || V === "href") && x !== "script" && kP(X, "data:") === 0 && fe[x]) && !(an && !Tt(de, Ci(X, le, ""))) && X)
        return !1;
    }
    return !0;
  }, I = function(x) {
    return x !== "annotation-xml" && Ll(x, pe);
  }, S = function(x) {
    g(J.beforeSanitizeAttributes, x, null);
    const {
      attributes: V
    } = x;
    if (!V || c(x))
      return;
    const X = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let Ne = V.length;
    for (; Ne--; ) {
      const xe = V[Ne], {
        name: ne,
        namespaceURI: nn,
        value: En
      } = xe, jn = yn(ne), Qi = En;
      let gt = ne === "value" ? Qi : bP(Qi);
      if (X.attrName = jn, X.attrValue = gt, X.keepAttr = !0, X.forceKeepAttr = void 0, g(J.uponSanitizeAttribute, x, X), gt = X.attrValue, _ && (jn === "id" || jn === "name") && (Rn(ne, x), gt = D + gt), Xe && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, gt)) {
        Rn(ne, x);
        continue;
      }
      if (jn === "attributename" && Ll(gt, "href")) {
        Rn(ne, x);
        continue;
      }
      if (X.forceKeepAttr)
        continue;
      if (!X.keepAttr) {
        Rn(ne, x);
        continue;
      }
      if (!we && Tt(/\/>/i, gt)) {
        Rn(ne, x);
        continue;
      }
      We && ka([M, R, q], (wS) => {
        gt = Ci(gt, wS, " ");
      });
      const Bp = yn(x.nodeName);
      if (!L(Bp, jn, gt)) {
        Rn(ne, x);
        continue;
      }
      if (T && typeof v == "object" && typeof v.getAttributeType == "function" && !nn)
        switch (v.getAttributeType(Bp, jn)) {
          case "TrustedHTML": {
            gt = T.createHTML(gt);
            break;
          }
          case "TrustedScriptURL": {
            gt = T.createScriptURL(gt);
            break;
          }
        }
      if (gt !== Qi)
        try {
          nn ? x.setAttributeNS(nn, ne, gt) : x.setAttribute(ne, gt), c(x) ? Dn(x) : sy(n.removed);
        } catch {
          Rn(ne, x);
        }
    }
    g(J.afterSanitizeAttributes, x, null);
  }, te = function(x) {
    let V = null;
    const X = t(x);
    for (g(J.beforeSanitizeShadowDOM, x, null); V = X.nextNode(); )
      g(J.uponSanitizeShadowNode, V, null), P(V), S(V), V.content instanceof o && te(V.content);
    g(J.afterSanitizeShadowDOM, x, null);
  };
  return n.sanitize = function(x) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = null, Ne = null, xe = null, ne = null;
    if (vn = !x, vn && (x = "<!-->"), typeof x != "string" && !p(x))
      if (typeof x.toString == "function") {
        if (x = x.toString(), typeof x != "string")
          throw _a("dirty is not a string, aborting");
      } else
        throw _a("toString is not a function");
    if (!n.isSupported)
      return x;
    if (he || Vn(V), n.removed = [], typeof x == "string" && (Y = !1), Y) {
      if (x.nodeName) {
        const jn = yn(x.nodeName);
        if (!ke[jn] || Pe[jn])
          throw _a("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      X = Bn("<!---->"), Ne = X.ownerDocument.importNode(x, !0), Ne.nodeType === Sa.element && Ne.nodeName === "BODY" || Ne.nodeName === "HTML" ? X = Ne : X.appendChild(Ne);
    else {
      if (!Ae && !We && !me && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return T && ze ? T.createHTML(x) : x;
      if (X = Bn(x), !X)
        return Ae ? null : ze ? E : "";
    }
    X && Ie && Dn(X.firstChild);
    const nn = t(Y ? x : X);
    for (; xe = nn.nextNode(); )
      P(xe), S(xe), xe.content instanceof o && te(xe.content);
    if (Y)
      return x;
    if (Ae) {
      if (We) {
        X.normalize();
        let jn = X.innerHTML;
        ka([M, R, q], (Qi) => {
          jn = Ci(jn, Qi, " ");
        }), X.innerHTML = jn;
      }
      if (Re)
        for (ne = Z.call(X.ownerDocument); X.firstChild; )
          ne.appendChild(X.firstChild);
      else
        ne = X;
      return (K.shadowroot || K.shadowrootmode) && (ne = ie.call(i, ne, !0)), ne;
    }
    let En = me ? X.outerHTML : X.innerHTML;
    return me && ke["!doctype"] && X.ownerDocument && X.ownerDocument.doctype && X.ownerDocument.doctype.name && Tt(px, X.ownerDocument.doctype.name) && (En = "<!DOCTYPE " + X.ownerDocument.doctype.name + `>
` + En), We && ka([M, R, q], (jn) => {
      En = Ci(En, jn, " ");
    }), T && ze ? T.createHTML(En) : En;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(x), he = !0;
  }, n.clearConfig = function() {
    fn = null, he = !1;
  }, n.isValidAttribute = function(x, V, X) {
    fn || Vn({});
    const Ne = yn(x), xe = yn(V);
    return L(Ne, xe, X);
  }, n.addHook = function(x, V) {
    typeof V == "function" && ba(J[x], V);
  }, n.removeHook = function(x, V) {
    if (V !== void 0) {
      const X = gP(J[x], V);
      return X === -1 ? void 0 : vP(J[x], X, 1)[0];
    }
    return sy(J[x]);
  }, n.removeHooks = function(x) {
    J[x] = [];
  }, n.removeAllHooks = function() {
    J = py();
  }, n;
}
var OP = fx();
const PP = "_messageContainer_1rxr4_1", AP = "_chip_1rxr4_7", LP = "_chipLabel_1rxr4_10", VP = "_chipValue_1rxr4_13", $o = {
  messageContainer: PP,
  chip: AP,
  chipLabel: LP,
  chipValue: VP
}, fy = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, zP = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  He(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ wn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ wn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ wn.jsx(Ge, { content: "Conversation Attributes", children: /* @__PURE__ */ wn.jsx(
        Im,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ wn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ wn.jsx(Pn, { className: $o.chip, children: /* @__PURE__ */ wn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ wn.jsxs(Qn, { className: $o.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ wn.jsx(Qn, { className: $o.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ wn.jsx(
      b,
      {
        className: $o.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? fy[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? fy[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ wn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ wn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ wn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ wn.jsx(GS, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ wn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: OP.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ wn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ wn.jsx(
      YS,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ wn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, UP = "_conversation_1draa_1", MP = "_conversationSubLine_1draa_9", BP = "_modal_1draa_14", Bl = {
  conversation: UP,
  conversationSubLine: MP,
  modal: BP
}, qP = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), HP = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), WP = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ wn.jsxs(b, { className: Bl.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ wn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ wn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ wn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ wn.jsx(Un, { size: "small", variant: "info", children: An(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ wn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Bl.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ wn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ wn.jsx(Pn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ wn.jsx(Ge, { content: "Show conversation preview", children: /* @__PURE__ */ wn.jsx(
        Yt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ wn.jsxs(
      Nt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Bl.modal,
        children: [
          /* @__PURE__ */ wn.jsx(
            jt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ wn.jsx(wt, { children: /* @__PURE__ */ wn.jsx(
            zP,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: qP(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: HP(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, KP = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = qn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ wn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ wn.jsx(
      WP,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ wn.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, GP = pP(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), YP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = un(), { data: l, loading: d, error: m } = s(GP, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return He(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ wn.jsx(In, { error: m }) : d ? /* @__PURE__ */ wn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ wn.jsx(cn, {}) }) : r?.length === 0 ? /* @__PURE__ */ wn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ wn.jsx(
    KP,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, JP = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: eo
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ql = { exports: {} }, Na = {}, hy;
function QP() {
  if (hy) return Na;
  hy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Na.Fragment = r, Na.jsx = s, Na.jsxs = s, Na;
}
var Do = {}, yy;
function XP() {
  return yy || (yy = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Do.Fragment = i, Do.jsx = Rn, Do.jsxs = Bn;
  })()), Do;
}
var gy;
function ZP() {
  return gy || (gy = 1, process.env.NODE_ENV === "production" ? ql.exports = QP() : ql.exports = XP()), ql.exports;
}
var Fe = ZP();
const eA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, nA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, tA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, rA = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": eA,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": nA,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": tA
};
function dp(e) {
  return rA[e] ?? {};
}
const iA = dp(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), aA = dp(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), oA = dp(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function ym(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const sA = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, hx = "DD MMM YYYY @ HH:mm", lA = "_list_2c4dq_1", cA = "_listItem_2c4dq_4", dA = "_copyIcon_2c4dq_12", pi = {
  list: lA,
  listItem: cA,
  copyIcon: dA
}, gm = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = ym(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: N
  } = e ?? {}, j = `${d} ${m}`.trim() || void 0, w = `${h} ${v}`.trim() || void 0, F = [j, u, f, w, N].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(cn, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: F.map((y, H) => /* @__PURE__ */ Fe.jsx(Qn, { children: y }, H)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Ge, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: "exclamation",
          className: pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(F.join(", ")),
          className: pi.copyIcon
        }
      ) })
    ] })
  ] });
}, uA = "_wrapper_1nher_1", mA = {
  wrapper: uA
}, pA = ({
  customer: e,
  store: n
}) => {
  const { track: r } = kn(), { isCopied: i, copy: a } = ym(), { isCopied: o, copy: s } = ym(), { useQuery: l } = un(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(aA, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, N = (h?.addresses?.length ?? 0) > 1;
  if (He(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Fe.jsx(In, { error: u });
  if (!e)
    return null;
  const {
    id: j,
    phone: w,
    email: F,
    first_name: y,
    last_name: H,
    created_at: T,
    has_valid_payment_method: E
  } = e, $ = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${j}` : null, Z = `${y || ""} ${H || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: mA.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: Z }),
    T && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: An(T).format(hx) })
    ] }),
    F && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: $, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${F}`, children: F })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: $,
          name: i ? "done" : "copy",
          onClick: () => a(F),
          className: pi.copyIcon
        }
      ) })
    ] }),
    w && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: $, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: w })
      ] }),
      /* @__PURE__ */ Fe.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: $,
          name: o ? "done" : "copy",
          onClick: () => s(w),
          className: pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      gm,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: N
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ue, { size: $, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        ue,
        {
          size: $,
          name: E ? "check-circle" : "close-circle-filled",
          color: E ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(ue, { size: $, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, fA = "_order_1dlaa_1", hA = "_orderIsOpen_1dlaa_9", yA = "_orderHeader_1dlaa_12", gA = "_note_1dlaa_16", Ro = {
  order: fA,
  orderIsOpen: hA,
  orderHeader: yA,
  note: gA
}, vA = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = kn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: N,
    is_prepaid: j
  } = e, w = 14, F = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: ut(Ro.order, {
        [Ro.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ro.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: An(f).format(hx) }) }),
                /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Fe.jsx(Ge, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Ro.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: sA(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: j ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(ue, { size: w, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", children: [
                N,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            gm,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            gm,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          F && /* @__PURE__ */ Fe.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(F, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, kA = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = kn(), { useQuery: i } = un(), {
    loading: a,
    error: o,
    data: s
  } = i(oA, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Fe.jsx(In, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Fe.jsx(Un, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(cn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Fe.jsx(
        vA,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Fe.jsx(
        St,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(ue, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, bA = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(Ke, { className: pi.list, children: [
      /* @__PURE__ */ Fe.jsx(Ke.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(Ke.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, _A = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(iA, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return Nm({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : jm({ errors: v }) ? /* @__PURE__ */ Fe.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Fe.jsx(In, { error: m });
  }
  return d ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(cn, {}) }) : f ? l ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Fe.jsx(pA, { customer: f, store: h }),
        o && /* @__PURE__ */ Fe.jsx(bA, { customer: f }),
        s && /* @__PURE__ */ Fe.jsx(kA, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, xA = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var Oo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Hl = { exports: {} }, ja = {}, vy;
function SA() {
  if (vy) return ja;
  vy = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ja.Fragment = r, ja.jsx = s, ja.jsxs = s, ja;
}
var Po = {}, ky;
function NA() {
  return ky || (ky = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Po.Fragment = i, Po.jsx = Rn, Po.jsxs = Bn;
  })()), Po;
}
var by;
function jA() {
  return by || (by = 1, process.env.NODE_ENV === "production" ? Hl.exports = SA() : Hl.exports = NA()), Hl.exports;
}
var fi = jA();
function wA(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Wl, _y;
function ni() {
  if (_y) return Wl;
  _y = 1;
  var e = Array.isArray;
  return Wl = e, Wl;
}
var Kl, xy;
function gx() {
  if (xy) return Kl;
  xy = 1;
  var e = typeof Oo == "object" && Oo && Oo.Object === Object && Oo;
  return Kl = e, Kl;
}
var Gl, Sy;
function Pr() {
  if (Sy) return Gl;
  Sy = 1;
  var e = gx(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Gl = r, Gl;
}
var Yl, Ny;
function uo() {
  if (Ny) return Yl;
  Ny = 1;
  var e = Pr(), n = e.Symbol;
  return Yl = n, Yl;
}
var Jl, jy;
function CA() {
  if (jy) return Jl;
  jy = 1;
  var e = uo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Jl = o, Jl;
}
var Ql, wy;
function FA() {
  if (wy) return Ql;
  wy = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Ql = r, Ql;
}
var Xl, Cy;
function Gi() {
  if (Cy) return Xl;
  Cy = 1;
  var e = uo(), n = CA(), r = FA(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Xl = s, Xl;
}
var Zl, Fy;
function bi() {
  if (Fy) return Zl;
  Fy = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Zl = e, Zl;
}
var ec, Iy;
function up() {
  if (Iy) return ec;
  Iy = 1;
  var e = Gi(), n = bi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return ec = i, ec;
}
var nc, Ey;
function IA() {
  if (Ey) return nc;
  Ey = 1;
  var e = ni(), n = up(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return nc = a, nc;
}
var tc, Ty;
function Yi() {
  if (Ty) return tc;
  Ty = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return tc = e, tc;
}
var rc, $y;
function vx() {
  if ($y) return rc;
  $y = 1;
  var e = Gi(), n = Yi(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return rc = s, rc;
}
var ic, Dy;
function EA() {
  if (Dy) return ic;
  Dy = 1;
  var e = Pr(), n = e["__core-js_shared__"];
  return ic = n, ic;
}
var ac, Ry;
function TA() {
  if (Ry) return ac;
  Ry = 1;
  var e = EA(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return ac = r, ac;
}
var oc, Oy;
function kx() {
  if (Oy) return oc;
  Oy = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return oc = r, oc;
}
var sc, Py;
function $A() {
  if (Py) return sc;
  Py = 1;
  var e = vx(), n = TA(), r = Yi(), i = kx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return sc = f, sc;
}
var lc, Ay;
function DA() {
  if (Ay) return lc;
  Ay = 1;
  function e(n, r) {
    return n?.[r];
  }
  return lc = e, lc;
}
var cc, Ly;
function _i() {
  if (Ly) return cc;
  Ly = 1;
  var e = $A(), n = DA();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return cc = r, cc;
}
var dc, Vy;
function Hs() {
  if (Vy) return dc;
  Vy = 1;
  var e = _i(), n = e(Object, "create");
  return dc = n, dc;
}
var uc, zy;
function RA() {
  if (zy) return uc;
  zy = 1;
  var e = Hs();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return uc = n, uc;
}
var mc, Uy;
function OA() {
  if (Uy) return mc;
  Uy = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return mc = e, mc;
}
var pc, My;
function PA() {
  if (My) return pc;
  My = 1;
  var e = Hs(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return pc = a, pc;
}
var fc, By;
function AA() {
  if (By) return fc;
  By = 1;
  var e = Hs(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return fc = i, fc;
}
var hc, qy;
function LA() {
  if (qy) return hc;
  qy = 1;
  var e = Hs(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return hc = r, hc;
}
var yc, Hy;
function VA() {
  if (Hy) return yc;
  Hy = 1;
  var e = RA(), n = OA(), r = PA(), i = AA(), a = LA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, yc = o, yc;
}
var gc, Wy;
function zA() {
  if (Wy) return gc;
  Wy = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return gc = e, gc;
}
var vc, Ky;
function bx() {
  if (Ky) return vc;
  Ky = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return vc = e, vc;
}
var kc, Gy;
function Ws() {
  if (Gy) return kc;
  Gy = 1;
  var e = bx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return kc = n, kc;
}
var bc, Yy;
function UA() {
  if (Yy) return bc;
  Yy = 1;
  var e = Ws(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return bc = i, bc;
}
var _c, Jy;
function MA() {
  if (Jy) return _c;
  Jy = 1;
  var e = Ws();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return _c = n, _c;
}
var xc, Qy;
function BA() {
  if (Qy) return xc;
  Qy = 1;
  var e = Ws();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return xc = n, xc;
}
var Sc, Xy;
function qA() {
  if (Xy) return Sc;
  Xy = 1;
  var e = Ws();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Sc = n, Sc;
}
var Nc, Zy;
function Ks() {
  if (Zy) return Nc;
  Zy = 1;
  var e = zA(), n = UA(), r = MA(), i = BA(), a = qA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Nc = o, Nc;
}
var jc, eg;
function mp() {
  if (eg) return jc;
  eg = 1;
  var e = _i(), n = Pr(), r = e(n, "Map");
  return jc = r, jc;
}
var wc, ng;
function HA() {
  if (ng) return wc;
  ng = 1;
  var e = VA(), n = Ks(), r = mp();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return wc = i, wc;
}
var Cc, tg;
function WA() {
  if (tg) return Cc;
  tg = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Cc = e, Cc;
}
var Fc, rg;
function Gs() {
  if (rg) return Fc;
  rg = 1;
  var e = WA();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Fc = n, Fc;
}
var Ic, ig;
function KA() {
  if (ig) return Ic;
  ig = 1;
  var e = Gs();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Ic = n, Ic;
}
var Ec, ag;
function GA() {
  if (ag) return Ec;
  ag = 1;
  var e = Gs();
  function n(r) {
    return e(this, r).get(r);
  }
  return Ec = n, Ec;
}
var Tc, og;
function YA() {
  if (og) return Tc;
  og = 1;
  var e = Gs();
  function n(r) {
    return e(this, r).has(r);
  }
  return Tc = n, Tc;
}
var $c, sg;
function JA() {
  if (sg) return $c;
  sg = 1;
  var e = Gs();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return $c = n, $c;
}
var Dc, lg;
function _x() {
  if (lg) return Dc;
  lg = 1;
  var e = HA(), n = KA(), r = GA(), i = YA(), a = JA();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Dc = o, Dc;
}
var Rc, cg;
function QA() {
  if (cg) return Rc;
  cg = 1;
  var e = _x(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Rc = r, Rc;
}
var Oc, dg;
function XA() {
  if (dg) return Oc;
  dg = 1;
  var e = QA(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Oc = r, Oc;
}
var Pc, ug;
function ZA() {
  if (ug) return Pc;
  ug = 1;
  var e = XA(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Pc = i, Pc;
}
var Ac, mg;
function xx() {
  if (mg) return Ac;
  mg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Ac = e, Ac;
}
var Lc, pg;
function e2() {
  if (pg) return Lc;
  pg = 1;
  var e = uo(), n = xx(), r = ni(), i = up(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Lc = s, Lc;
}
var Vc, fg;
function n2() {
  if (fg) return Vc;
  fg = 1;
  var e = e2();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Vc = n, Vc;
}
var zc, hg;
function Ji() {
  if (hg) return zc;
  hg = 1;
  var e = ni(), n = IA(), r = ZA(), i = n2();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return zc = a, zc;
}
var Uc, yg;
function Ys() {
  if (yg) return Uc;
  yg = 1;
  var e = up();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Uc = n, Uc;
}
var Mc, gg;
function Sx() {
  if (gg) return Mc;
  gg = 1;
  var e = Ji(), n = Ys();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Mc = r, Mc;
}
var Bc, vg;
function Nx() {
  if (vg) return Bc;
  vg = 1;
  var e = _i(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Bc = n, Bc;
}
var qc, kg;
function jx() {
  if (kg) return qc;
  kg = 1;
  var e = Nx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return qc = n, qc;
}
var Hc, bg;
function pp() {
  if (bg) return Hc;
  bg = 1;
  var e = jx(), n = bx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Hc = a, Hc;
}
var Wc, _g;
function fp() {
  if (_g) return Wc;
  _g = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Wc = r, Wc;
}
var Kc, xg;
function t2() {
  if (xg) return Kc;
  xg = 1;
  var e = pp(), n = Ji(), r = fp(), i = Yi(), a = Ys();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var N = a(l[u]), j = d;
      if (N === "__proto__" || N === "constructor" || N === "prototype")
        return s;
      if (u != h) {
        var w = v[N];
        j = m ? m(w, N, v) : void 0, j === void 0 && (j = i(w) ? w : r(l[u + 1]) ? [] : {});
      }
      e(v, N, j), v = v[N];
    }
    return s;
  }
  return Kc = o, Kc;
}
var Gc, Sg;
function r2() {
  if (Sg) return Gc;
  Sg = 1;
  var e = Sx(), n = t2(), r = Ji();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Gc = i, Gc;
}
var Yc, Ng;
function i2() {
  if (Ng) return Yc;
  Ng = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Yc = e, Yc;
}
var Jc, jg;
function a2() {
  if (jg) return Jc;
  jg = 1;
  var e = Gi(), n = bi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jc = i, Jc;
}
var Qc, wg;
function hp() {
  if (wg) return Qc;
  wg = 1;
  var e = a2(), n = bi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Qc = o, Qc;
}
var Xc, Cg;
function yp() {
  if (Cg) return Xc;
  Cg = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Xc = n, Xc;
}
var Zc, Fg;
function o2() {
  if (Fg) return Zc;
  Fg = 1;
  var e = Ji(), n = hp(), r = ni(), i = fp(), a = yp(), o = Ys();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return Zc = s, Zc;
}
var ed, Ig;
function s2() {
  if (Ig) return ed;
  Ig = 1;
  var e = i2(), n = o2();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return ed = r, ed;
}
var nd, Eg;
function l2() {
  if (Eg) return nd;
  Eg = 1;
  var e = r2(), n = s2();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return nd = r, nd;
}
var td, Tg;
function gp() {
  if (Tg) return td;
  Tg = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return td = e, td;
}
var rd, $g;
function c2() {
  if ($g) return rd;
  $g = 1;
  var e = uo(), n = hp(), r = ni(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return rd = a, rd;
}
var id, Dg;
function d2() {
  if (Dg) return id;
  Dg = 1;
  var e = gp(), n = c2();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return id = r, id;
}
var ad, Rg;
function u2() {
  if (Rg) return ad;
  Rg = 1;
  var e = d2();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return ad = n, ad;
}
var od, Og;
function m2() {
  if (Og) return od;
  Og = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return od = e, od;
}
var sd, Pg;
function p2() {
  if (Pg) return sd;
  Pg = 1;
  var e = m2(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return sd = r, sd;
}
var ld, Ag;
function f2() {
  if (Ag) return ld;
  Ag = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return ld = e, ld;
}
var cd, Lg;
function wx() {
  if (Lg) return cd;
  Lg = 1;
  function e(n) {
    return n;
  }
  return cd = e, cd;
}
var dd, Vg;
function h2() {
  if (Vg) return dd;
  Vg = 1;
  var e = f2(), n = Nx(), r = wx(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return dd = i, dd;
}
var ud, zg;
function y2() {
  if (zg) return ud;
  zg = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ud = i, ud;
}
var md, Ug;
function g2() {
  if (Ug) return md;
  Ug = 1;
  var e = h2(), n = y2(), r = n(e);
  return md = r, md;
}
var pd, Mg;
function Cx() {
  if (Mg) return pd;
  Mg = 1;
  var e = u2(), n = p2(), r = g2();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return pd = i, pd;
}
var fd, Bg;
function v2() {
  if (Bg) return fd;
  Bg = 1;
  var e = l2(), n = Cx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return fd = r, fd;
}
var k2 = v2();
const Fx = /* @__PURE__ */ yx(k2), b2 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function Ix(e) {
  const n = Fx(e, b2);
  return {
    controller: qm(n),
    controllerProps: n
  };
}
const _2 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function Ex(e) {
  const { controller: n, controllerProps: r } = Ix(e), i = {
    ...Fx(e, _2),
    required: wA(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var hd, qg;
function x2() {
  if (qg) return hd;
  qg = 1;
  var e = Ks();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return hd = n, hd;
}
var yd, Hg;
function S2() {
  if (Hg) return yd;
  Hg = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return yd = e, yd;
}
var gd, Wg;
function N2() {
  if (Wg) return gd;
  Wg = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return gd = e, gd;
}
var vd, Kg;
function j2() {
  if (Kg) return vd;
  Kg = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return vd = e, vd;
}
var kd, Gg;
function w2() {
  if (Gg) return kd;
  Gg = 1;
  var e = Ks(), n = mp(), r = _x(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return kd = a, kd;
}
var bd, Yg;
function C2() {
  if (Yg) return bd;
  Yg = 1;
  var e = Ks(), n = x2(), r = S2(), i = N2(), a = j2(), o = w2();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, bd = s, bd;
}
var _d, Jg;
function F2() {
  if (Jg) return _d;
  Jg = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return _d = e, _d;
}
var xd, Qg;
function mo() {
  if (Qg) return xd;
  Qg = 1;
  var e = pp(), n = jx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return xd = r, xd;
}
var Sd, Xg;
function I2() {
  if (Xg) return Sd;
  Xg = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Sd = e, Sd;
}
var es = { exports: {} }, Nd, Zg;
function E2() {
  if (Zg) return Nd;
  Zg = 1;
  function e() {
    return !1;
  }
  return Nd = e, Nd;
}
es.exports;
var ev;
function Tx() {
  return ev || (ev = 1, (function(e, n) {
    var r = Pr(), i = E2(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(es, es.exports)), es.exports;
}
var jd, nv;
function T2() {
  if (nv) return jd;
  nv = 1;
  var e = Gi(), n = yp(), r = bi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", N = "[object String]", j = "[object WeakMap]", w = "[object ArrayBuffer]", F = "[object DataView]", y = "[object Float32Array]", H = "[object Float64Array]", T = "[object Int8Array]", E = "[object Int16Array]", $ = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ie = "[object Uint32Array]", J = {};
  J[y] = J[H] = J[T] = J[E] = J[$] = J[U] = J[Z] = J[Q] = J[ie] = !0, J[i] = J[a] = J[w] = J[o] = J[F] = J[s] = J[l] = J[d] = J[m] = J[u] = J[f] = J[h] = J[v] = J[N] = J[j] = !1;
  function M(R) {
    return r(R) && n(R.length) && !!J[e(R)];
  }
  return jd = M, jd;
}
var wd, tv;
function vp() {
  if (tv) return wd;
  tv = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return wd = e, wd;
}
var ns = { exports: {} };
ns.exports;
var rv;
function kp() {
  return rv || (rv = 1, (function(e, n) {
    var r = gx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(ns, ns.exports)), ns.exports;
}
var Cd, iv;
function $2() {
  if (iv) return Cd;
  iv = 1;
  var e = T2(), n = vp(), r = kp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Cd = a, Cd;
}
var Fd, av;
function $x() {
  if (av) return Fd;
  av = 1;
  var e = I2(), n = hp(), r = ni(), i = Tx(), a = fp(), o = $2(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), N = !f && !h && !v && o(m), j = f || h || v || N, w = j ? e(m.length, String) : [], F = w.length;
    for (var y in m)
      (u || l.call(m, y)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      N && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, F))) && w.push(y);
    return w;
  }
  return Fd = d, Fd;
}
var Id, ov;
function bp() {
  if (ov) return Id;
  ov = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Id = n, Id;
}
var Ed, sv;
function Dx() {
  if (sv) return Ed;
  sv = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Ed = e, Ed;
}
var Td, lv;
function D2() {
  if (lv) return Td;
  lv = 1;
  var e = Dx(), n = e(Object.keys, Object);
  return Td = n, Td;
}
var $d, cv;
function R2() {
  if (cv) return $d;
  cv = 1;
  var e = bp(), n = D2(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return $d = a, $d;
}
var Dd, dv;
function Rx() {
  if (dv) return Dd;
  dv = 1;
  var e = vx(), n = yp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Dd = r, Dd;
}
var Rd, uv;
function _p() {
  if (uv) return Rd;
  uv = 1;
  var e = $x(), n = R2(), r = Rx();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Rd = i, Rd;
}
var Od, mv;
function O2() {
  if (mv) return Od;
  mv = 1;
  var e = mo(), n = _p();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Od = r, Od;
}
var Pd, pv;
function P2() {
  if (pv) return Pd;
  pv = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Pd = e, Pd;
}
var Ad, fv;
function A2() {
  if (fv) return Ad;
  fv = 1;
  var e = Yi(), n = bp(), r = P2(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Ad = o, Ad;
}
var Ld, hv;
function xp() {
  if (hv) return Ld;
  hv = 1;
  var e = $x(), n = A2(), r = Rx();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Ld = i, Ld;
}
var Vd, yv;
function L2() {
  if (yv) return Vd;
  yv = 1;
  var e = mo(), n = xp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Vd = r, Vd;
}
var ts = { exports: {} };
ts.exports;
var gv;
function V2() {
  return gv || (gv = 1, (function(e, n) {
    var r = Pr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(ts, ts.exports)), ts.exports;
}
var zd, vv;
function z2() {
  if (vv) return zd;
  vv = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return zd = e, zd;
}
var Ud, kv;
function U2() {
  if (kv) return Ud;
  kv = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Ud = e, Ud;
}
var Md, bv;
function Ox() {
  if (bv) return Md;
  bv = 1;
  function e() {
    return [];
  }
  return Md = e, Md;
}
var Bd, _v;
function Sp() {
  if (_v) return Bd;
  _v = 1;
  var e = U2(), n = Ox(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Bd = o, Bd;
}
var qd, xv;
function M2() {
  if (xv) return qd;
  xv = 1;
  var e = mo(), n = Sp();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return qd = r, qd;
}
var Hd, Sv;
function Np() {
  if (Sv) return Hd;
  Sv = 1;
  var e = Dx(), n = e(Object.getPrototypeOf, Object);
  return Hd = n, Hd;
}
var Wd, Nv;
function Px() {
  if (Nv) return Wd;
  Nv = 1;
  var e = gp(), n = Np(), r = Sp(), i = Ox(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Wd = o, Wd;
}
var Kd, jv;
function B2() {
  if (jv) return Kd;
  jv = 1;
  var e = mo(), n = Px();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Kd = r, Kd;
}
var Gd, wv;
function Ax() {
  if (wv) return Gd;
  wv = 1;
  var e = gp(), n = ni();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Gd = r, Gd;
}
var Yd, Cv;
function q2() {
  if (Cv) return Yd;
  Cv = 1;
  var e = Ax(), n = Sp(), r = _p();
  function i(a) {
    return e(a, r, n);
  }
  return Yd = i, Yd;
}
var Jd, Fv;
function Lx() {
  if (Fv) return Jd;
  Fv = 1;
  var e = Ax(), n = Px(), r = xp();
  function i(a) {
    return e(a, r, n);
  }
  return Jd = i, Jd;
}
var Qd, Iv;
function H2() {
  if (Iv) return Qd;
  Iv = 1;
  var e = _i(), n = Pr(), r = e(n, "DataView");
  return Qd = r, Qd;
}
var Xd, Ev;
function W2() {
  if (Ev) return Xd;
  Ev = 1;
  var e = _i(), n = Pr(), r = e(n, "Promise");
  return Xd = r, Xd;
}
var Zd, Tv;
function K2() {
  if (Tv) return Zd;
  Tv = 1;
  var e = _i(), n = Pr(), r = e(n, "Set");
  return Zd = r, Zd;
}
var eu, $v;
function G2() {
  if ($v) return eu;
  $v = 1;
  var e = _i(), n = Pr(), r = e(n, "WeakMap");
  return eu = r, eu;
}
var nu, Dv;
function jp() {
  if (Dv) return nu;
  Dv = 1;
  var e = H2(), n = mp(), r = W2(), i = K2(), a = G2(), o = Gi(), s = kx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), N = s(n), j = s(r), w = s(i), F = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(H) {
    var T = o(H), E = T == d ? H.constructor : void 0, $ = E ? s(E) : "";
    if ($)
      switch ($) {
        case v:
          return h;
        case N:
          return l;
        case j:
          return m;
        case w:
          return u;
        case F:
          return f;
      }
    return T;
  }), nu = y, nu;
}
var tu, Rv;
function Y2() {
  if (Rv) return tu;
  Rv = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return tu = r, tu;
}
var ru, Ov;
function J2() {
  if (Ov) return ru;
  Ov = 1;
  var e = Pr(), n = e.Uint8Array;
  return ru = n, ru;
}
var iu, Pv;
function wp() {
  if (Pv) return iu;
  Pv = 1;
  var e = J2();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return iu = n, iu;
}
var au, Av;
function Q2() {
  if (Av) return au;
  Av = 1;
  var e = wp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return au = n, au;
}
var ou, Lv;
function X2() {
  if (Lv) return ou;
  Lv = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return ou = n, ou;
}
var su, Vv;
function Z2() {
  if (Vv) return su;
  Vv = 1;
  var e = uo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return su = i, su;
}
var lu, zv;
function eL() {
  if (zv) return lu;
  zv = 1;
  var e = wp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return lu = n, lu;
}
var cu, Uv;
function nL() {
  if (Uv) return cu;
  Uv = 1;
  var e = wp(), n = Q2(), r = X2(), i = Z2(), a = eL(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", N = "[object DataView]", j = "[object Float32Array]", w = "[object Float64Array]", F = "[object Int8Array]", y = "[object Int16Array]", H = "[object Int32Array]", T = "[object Uint8Array]", E = "[object Uint8ClampedArray]", $ = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ie, J) {
    var M = Q.constructor;
    switch (ie) {
      case v:
        return e(Q);
      case o:
      case s:
        return new M(+Q);
      case N:
        return n(Q, J);
      case j:
      case w:
      case F:
      case y:
      case H:
      case T:
      case E:
      case $:
      case U:
        return a(Q, J);
      case l:
        return new M();
      case d:
      case f:
        return new M(Q);
      case m:
        return r(Q);
      case u:
        return new M();
      case h:
        return i(Q);
    }
  }
  return cu = Z, cu;
}
var du, Mv;
function tL() {
  if (Mv) return du;
  Mv = 1;
  var e = Yi(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return du = r, du;
}
var uu, Bv;
function rL() {
  if (Bv) return uu;
  Bv = 1;
  var e = tL(), n = Np(), r = bp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return uu = i, uu;
}
var mu, qv;
function iL() {
  if (qv) return mu;
  qv = 1;
  var e = jp(), n = bi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return mu = i, mu;
}
var pu, Hv;
function aL() {
  if (Hv) return pu;
  Hv = 1;
  var e = iL(), n = vp(), r = kp(), i = r && r.isMap, a = i ? n(i) : e;
  return pu = a, pu;
}
var fu, Wv;
function oL() {
  if (Wv) return fu;
  Wv = 1;
  var e = jp(), n = bi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return fu = i, fu;
}
var hu, Kv;
function sL() {
  if (Kv) return hu;
  Kv = 1;
  var e = oL(), n = vp(), r = kp(), i = r && r.isSet, a = i ? n(i) : e;
  return hu = a, hu;
}
var yu, Gv;
function lL() {
  if (Gv) return yu;
  Gv = 1;
  var e = C2(), n = F2(), r = pp(), i = O2(), a = L2(), o = V2(), s = z2(), l = M2(), d = B2(), m = q2(), u = Lx(), f = jp(), h = Y2(), v = nL(), N = rL(), j = ni(), w = Tx(), F = aL(), y = Yi(), H = sL(), T = _p(), E = xp(), $ = 1, U = 2, Z = 4, Q = "[object Arguments]", ie = "[object Array]", J = "[object Boolean]", M = "[object Date]", R = "[object Error]", q = "[object Function]", ee = "[object GeneratorFunction]", ge = "[object Map]", de = "[object Number]", le = "[object Object]", pe = "[object RegExp]", W = "[object Set]", ke = "[object String]", Ce = "[object Symbol]", K = "[object WeakMap]", qe = "[object ArrayBuffer]", Be = "[object DataView]", Pe = "[object Float32Array]", Ue = "[object Float64Array]", je = "[object Int8Array]", Le = "[object Int16Array]", Te = "[object Int32Array]", an = "[object Uint8Array]", we = "[object Uint8ClampedArray]", We = "[object Uint16Array]", Xe = "[object Uint32Array]", me = {};
  me[Q] = me[ie] = me[qe] = me[Be] = me[J] = me[M] = me[Pe] = me[Ue] = me[je] = me[Le] = me[Te] = me[ge] = me[de] = me[le] = me[pe] = me[W] = me[ke] = me[Ce] = me[an] = me[we] = me[We] = me[Xe] = !0, me[R] = me[q] = me[K] = !1;
  function he(Ie, Ae, Re, ze, C, _) {
    var D, G = Ae & $, Y = Ae & U, O = Ae & Z;
    if (Re && (D = C ? Re(Ie, ze, C, _) : Re(Ie)), D !== void 0)
      return D;
    if (!y(Ie))
      return Ie;
    var z = j(Ie);
    if (z) {
      if (D = h(Ie), !G)
        return s(Ie, D);
    } else {
      var re = f(Ie), fe = re == q || re == ee;
      if (w(Ie))
        return o(Ie, G);
      if (re == le || re == Q || fe && !C) {
        if (D = Y || fe ? {} : N(Ie), !G)
          return Y ? d(Ie, a(D, Ie)) : l(Ie, i(D, Ie));
      } else {
        if (!me[re])
          return C ? Ie : {};
        D = v(Ie, re, G);
      }
    }
    _ || (_ = new e());
    var be = _.get(Ie);
    if (be)
      return be;
    _.set(Ie, D), H(Ie) ? Ie.forEach(function(rn) {
      D.add(he(rn, Ae, Re, rn, Ie, _));
    }) : F(Ie) && Ie.forEach(function(rn, dn) {
      D.set(dn, he(rn, Ae, Re, dn, Ie, _));
    });
    var en = O ? Y ? u : m : Y ? E : T, pn = z ? void 0 : en(Ie);
    return n(pn || Ie, function(rn, dn) {
      pn && (dn = rn, rn = Ie[dn]), r(D, dn, he(rn, Ae, Re, dn, Ie, _));
    }), D;
  }
  return yu = he, yu;
}
var gu, Yv;
function cL() {
  if (Yv) return gu;
  Yv = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return gu = e, gu;
}
var vu, Jv;
function dL() {
  if (Jv) return vu;
  Jv = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return vu = e, vu;
}
var ku, Qv;
function uL() {
  if (Qv) return ku;
  Qv = 1;
  var e = Sx(), n = dL();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return ku = r, ku;
}
var bu, Xv;
function mL() {
  if (Xv) return bu;
  Xv = 1;
  var e = Ji(), n = cL(), r = uL(), i = Ys(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return bu = s, bu;
}
var _u, Zv;
function pL() {
  if (Zv) return _u;
  Zv = 1;
  var e = Gi(), n = Np(), r = bi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return _u = m, _u;
}
var xu, ek;
function fL() {
  if (ek) return xu;
  ek = 1;
  var e = pL();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return xu = n, xu;
}
var Su, nk;
function hL() {
  if (nk) return Su;
  nk = 1;
  var e = xx(), n = lL(), r = mL(), i = Ji(), a = mo(), o = fL(), s = Cx(), l = Lx(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var N = {};
    if (h == null)
      return N;
    var j = !1;
    v = e(v, function(F) {
      return F = i(F, h), j || (j = F.length > 1), F;
    }), a(h, l(h), N), j && (N = n(N, d | m | u, o));
    for (var w = v.length; w--; )
      r(N, v[w]);
    return N;
  });
  return Su = f, Su;
}
hL();
const br = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = Ex(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ fi.jsx(Ln, { ...a, children: /* @__PURE__ */ fi.jsx(
    Yr,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Ln.getStatus(a.meta),
      children: e
    }
  ) });
};
var yL = wx();
const gL = /* @__PURE__ */ yx(yL), Nu = ({
  transformValue: e = gL,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = Ix(a);
  return /* @__PURE__ */ fi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ fi.jsx(
      qu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ fi.jsx(JS, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, qt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = Ex(e);
  return /* @__PURE__ */ fi.jsx(Ln, { ...i, children: /* @__PURE__ */ fi.jsx(
    kr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: Ln.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ju = { exports: {} }, wa = {}, tk;
function vL() {
  if (tk) return wa;
  tk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return wa.Fragment = r, wa.jsx = s, wa.jsxs = s, wa;
}
var Ao = {}, rk;
function kL() {
  return rk || (rk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Ao.Fragment = i, Ao.jsx = Rn, Ao.jsxs = Bn;
  })()), Ao;
}
var ik;
function bL() {
  return ik || (ik = 1, process.env.NODE_ENV === "production" ? ju.exports = vL() : ju.exports = kL()), ju.exports;
}
var k = bL();
const ak = "__PairingContext__", _L = () => globalThis[ak] ?? (() => {
  const e = vb({});
  return globalThis[ak] = e, e;
})(), xL = _L(), SL = () => Cm(xL), NL = "_banner_d9pot_1", jL = "_list_d9pot_8", ok = {
  banner: NL,
  list: jL
}, sk = "https://apps.shopify.com/dixa-dashboard", wL = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Vx = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = SL(), [i, a] = se(!1), [o, s] = se(null), l = wL[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? sk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(sk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: ok.banner, children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(ue, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: ok.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Kn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(cn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, CL = (e) => /* @__PURE__ */ k.jsx(Vx, { ...e, bannerVariant: "install" }), FL = (e) => /* @__PURE__ */ k.jsx(Vx, { ...e, bannerVariant: "migration" }), IL = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], EL = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], TL = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: CL
  }
], $L = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], lk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: FL,
    additionalProperties: { renderAboveForm: !0 }
  }
], zx = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], ck = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => pb(e)
  },
  ...zx
];
var Ti = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ti || {}), hi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(hi || {}), Ir = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Ir || {}), Ux = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(Ux || {}), oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(oi || {}), Br = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Br || {}), rs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(rs || {}), Mx = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(Mx || {});
const DL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, RL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, PL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, AL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, VL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, zL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, UL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, ML = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, BL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, qL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, HL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, WL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, KL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, GL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, YL = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": DL,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": RL,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": OL,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": PL,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": AL,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": LL,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": VL,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": zL,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": UL,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": ML,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": BL,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": qL,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": HL,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": WL,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": KL,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": GL
};
function dr(e) {
  return YL[e] ?? {};
}
const JL = dr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), QL = dr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), XL = dr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), ZL = dr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Cp = dr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), eV = dr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), nV = dr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), tV = dr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), rV = dr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), iV = dr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), aV = dr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), oV = dr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), Bx = Zr`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, sV = Zr`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, lV = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(JL, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, cV = () => {
  const { useLazyQuery: e } = un(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(QL);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Za(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const dV = "_list_alvh6_1", uV = "_listItem_alvh6_4", mV = "_fullWidth_alvh6_15", pV = "_boxWrapper_alvh6_19", Ft = {
  list: dV,
  listItem: uV,
  fullWidth: mV,
  boxWrapper: pV
}, fV = "_modal_1vkwz_1", hV = "_disabled_1vkwz_5", wu = {
  modal: fV,
  disabled: hV
}, dk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: hi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: hi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: hi.Unknown
  }
], uk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Ir.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Ir.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Ir.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Ir.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Ir.Unsubscribed
  }
], yV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = kn(), { useMutation: l, showNotification: d } = un(), [m, u] = se(), [f, h] = se(), [v, N] = jf(!0), [j, w] = jf(!0), F = !!m, y = e.customer?.email, H = e.customer?.phone_number, T = e.customer?.given_name, E = e.customer?.family_name, $ = {
    email: y ?? "",
    phone: H ?? "",
    firstName: T ?? "",
    lastName: E ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = lr({
    defaultValues: $
  });
  He(() => {
    f?.forEach((R) => {
      const q = R?.field?.[0];
      q && (U.setError(q, {
        type: "server",
        message: R.message
      }), U.setFocus(q));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ie }] = l(aV, {
    onError: (R) => {
      u(R.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const q = R?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), J = tt(
    (R) => {
      a(!0), u(void 0), Z({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...v && { email: R.email },
            ...j && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Z, a, j, v]
  ), M = () => {
    r(!1), ie(), u(void 0), U.reset($);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: M, className: wu.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Create new customer", onClose: M }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Ut, { children: [
      /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [wu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                qu,
                {
                  disabled: !j,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: j ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [wu.disabled]: !j
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                qu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: j,
                  onChange: () => w()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, q) => R === q,
            getItemTitleByValue: (R) => {
              const q = uk.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: uk.map((R) => /* @__PURE__ */ k.jsx(ot.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, q) => R === q,
            getItemTitleByValue: (R) => {
              const q = dk.find(
                (ee) => ee.value === R
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: dk.map((R) => /* @__PURE__ */ k.jsx(ot.Item, { value: R.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      F && /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(J),
        cancelOnClick: M,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, gV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ft.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      yV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Fp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, vm = "DD MMM YYYY @ HH:mm", vV = "_wrapper_10fld_1", kV = "_copyIcon_10fld_7", Lo = {
  wrapper: vV,
  copyIcon: kV
}, bV = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Za(), { isCopied: l, copy: d } = Za(), { track: m } = kn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: N = [],
    verifiedEmail: j
  } = e, w = h?.emailAddress, F = v?.phoneNumber, y = Fp(u), H = `https://${n}/admin/customers/${y ?? ""}`, T = i && a === Gt.refetch, E = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: Lo.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(cn, { size: E }) : /* @__PURE__ */ k.jsx(Ge, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Lo.copyIcon
          }
        ) })
      ] }),
      w && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: E, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${w}`, children: w }),
          /* @__PURE__ */ k.jsx(
            Ge,
            {
              content: j ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                ue,
                {
                  size: E,
                  color: j ? "green.500" : "red.500",
                  name: j ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: o ? "done" : "copy",
            onClick: () => s(w),
            className: Lo.copyIcon
          }
        ) })
      ] }),
      F && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(ue, { size: E, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${F}`, children: F })
        ] }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: E,
            name: l ? "done" : "copy",
            onClick: () => d(F),
            className: Lo.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(ue, { size: E, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: H,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    N.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: N.map(($) => /* @__PURE__ */ k.jsx(Pn, { children: $ }, `${u}-${$}`)) })
    ] })
  ] });
}, _V = "_creationModal_pbe64_1", xV = "_detailsModal_pbe64_5", SV = "_percentageSuffix_pbe64_9", Cu = {
  creationModal: _V,
  detailsModal: xV,
  percentageSuffix: SV
}, NV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, jV = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: Ux.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, mk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], pk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], fk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], wV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = er(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Ke, { children: [
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            ue,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: An(e?.startsAt).format(dt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(Ln, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      kr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, CV = "shopify-discount-code-form", hk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, FV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = kn(), { useMutation: i, showNotification: a } = un(), [o, s] = se(
    []
  ), [l, d] = se(), m = lr({
    mode: "all",
    defaultValues: hk
  });
  He(() => {
    o?.forEach((E) => {
      const $ = E?.field?.[1];
      $ && m.setError($, {
        type: "server",
        message: E.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = qn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    N,
    {
      loading: j,
      error: w,
      reset: F
    }
  ] = i(oV, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (E) => {
      const $ = E?.Shopify?.discountCodeBasicCreate?.userErrors;
      if ($ && $.length > 0)
        s($);
      else {
        const U = E?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", NV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, H = (E) => {
    N({
      variables: {
        input: jV(E)
      }
    });
  }, T = () => {
    m.reset(hk), s([]), F(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: T,
      className: ut({
        [Cu.creationModal]: !u,
        [Cu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          jt,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          u && /* @__PURE__ */ k.jsx(wV, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: CV, onSubmit: m.handleSubmit(H), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              $s,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(Ut, { children: [
              /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                br,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (E, $) => E === $,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (E) => {
                      const $ = mk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: mk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (E) => {
                      if (E) {
                        if (h === "percentage" && (E < 0 || E > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && E < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Cu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                br,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (E, $) => E === $,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (E) => {
                      const $ = pk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: pk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
                qt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (E) => {
                      if (E && f !== "none" && E < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
                br,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (E, $) => E === $,
                    getItemTitleByValue: (E) => {
                      const $ = fk.find(
                        (U) => U.value === E
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: $?.label }) });
                    }
                  },
                  children: fk.map((E) => /* @__PURE__ */ k.jsx(ot.Item, { value: E.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
                  ] }) }, E.value))
                }
              ) })
            ] })
          ] }),
          w && /* @__PURE__ */ k.jsx(In, { error: w })
        ] }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: j,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? T : m.handleSubmit(H),
            cancelOnClick: u ? void 0 : T
          }
        )
      ]
    }
  );
}, IV = ({ code: e }) => {
  const { isCopied: n, copy: r } = Za();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(ue, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          Yt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, EV = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Ke, { children: i.map((a) => /* @__PURE__ */ k.jsx(Ke.Item, { className: Ft.listItem, children: /* @__PURE__ */ k.jsx(IV, { code: a.code }, a.id) }, a.id)) })
  ] });
}, TV = "_modal_11d6e_1", $V = "_modalBody_11d6e_4", DV = "_codeContainer_11d6e_9", Fu = {
  modal: TV,
  modalBody: $V,
  codeContainer: DV
}, RV = [50, 100, 250], qx = 50, OV = {
  maxNumberOfCodesToDisplay: qx
}, PV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = un(), [i, a] = se(
    qx
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = lr({
    mode: "all",
    defaultValues: OV
  }), { loading: u, error: f } = r(eV, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const N = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      N && N.length > 0 && s(N);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: e, onClose: h, className: Fu.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(wt, { className: Fu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(Ut, { children: /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: RV.map((v) => /* @__PURE__ */ k.jsx(ot.Item, { value: v, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        ss,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ k.jsx("div", { className: Fu.codeContainer, children: /* @__PURE__ */ k.jsx(EV, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ k.jsx(It, { confirmName: "Close", confirmOnClick: h })
  ] });
}, AV = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      PV,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      FV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, LV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Es(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Ti.Invalid:
      case Ti.NotSubscribed:
      case Ir.NotSubscribed:
        return "red.500";
      case Ti.Pending:
      case Ir.Pending:
      case Ti.Unsubscribed:
      case Ir.Unsubscribed:
        return "orange.500";
      case Ti.Subscribed:
      case Ir.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case hi.SingleOptIn:
      case hi.ConfirmedOptIn:
        return "green.500";
      case hi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: An(l).format(vm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(ue, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "info", children: An(u).format(vm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Ge, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Ge, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, VV = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: Mx.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, yk = [
  {
    value: Br.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Br.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Br.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Br.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Br.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Br.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Br.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], gk = [
  {
    value: rs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: rs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: rs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], Hx = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), $i = (e) => zV(UV(e)), zV = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), UV = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ri = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Lt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      or,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), MV = "_modal_1wlra_1", BV = {
  modal: MV
};
function vk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const kk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], bk = "shopify-shiping-address-form", qV = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = un(), { track: f } = kn(), [h, v] = se(!1), [N, j] = se({}), w = !l, [
    F,
    { error: y, reset: H }
  ] = m(nV, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (J) => {
      v(!1);
      const M = J?.Shopify?.orderUpdate?.userErrors;
      if (M != null && M.length > 0) {
        const R = M.reduce(
          (q, ee) => {
            const ge = ee.field;
            if (ge == null || ge.length === 0)
              return q;
            const de = ge[ge.length - 1];
            return de != null && (q[de] = ee.message), q;
          },
          {}
        );
        j(R);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ie();
    }
  }), T = tt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: kk.find(
        (J) => J === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: E, handleSubmit: $, formState: U, reset: Z } = lr({
    mode: "all",
    defaultValues: T()
  }), Q = $((J) => {
    if (w) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: M, ...R } = J, q = {
        ...R,
        countryCode: M
      };
      F({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(J), ie();
  });
  He(() => {
    r && Z(T());
  }, [r, n, Z, T]);
  const ie = () => {
    Z(T()), j({}), H(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: r,
      onClose: ie,
      className: BV.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: e, onClose: () => ie() }),
        /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: bk, onSubmit: Q, children: [
          y && /* @__PURE__ */ k.jsx(In, { error: y }),
          /* @__PURE__ */ k.jsxs(Ut, { children: [
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                control: E,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                control: E,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 3, children: /* @__PURE__ */ k.jsx(
              ri,
              {
                required: !0,
                control: E,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: N
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 6, children: /* @__PURE__ */ k.jsx(
              br,
              {
                name: "countryCodeV2",
                control: E,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (J) => J ? vk(J) : ""
                },
                children: kk.filter((J) => s.includes(J)).map((J) => /* @__PURE__ */ k.jsx(ot.Item, { value: J, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: vk(J) }) }, J))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: bk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ie();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ie();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, HV = "_clickableIcon_33mqm_1", Iu = {
  clickableIcon: HV
}, _k = ({
  formFieldName: e,
  ...n
}) => {
  const r = Or(), { field: i } = qm({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    km,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, km = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: N, copy: j } = Za(), { track: w } = kn(), F = 14, y = o && (!!r || !!l), H = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), E = n?.countryCodeV2 && LS(n.countryCodeV2), $ = tt(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    H,
    n?.province,
    E
  ].filter(Boolean).join(`
`), [n, T, H, E]);
  if (!n)
    return null;
  const U = () => {
    i && r && w("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: F, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: Iu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  ue,
                  {
                    size: F,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            H && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: H }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            E && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(Ge, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: F,
            name: "pen",
            onClick: () => U(),
            className: Iu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: F,
            name: N ? "done" : "copy",
            onClick: () => j($()),
            className: Iu.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      qV,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, Ip = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Or(), i = Jo({ control: r.control, name: "lineItems" }), a = Jo({
    control: r.control,
    name: "billingAddress"
  }), o = Jo({
    control: r.control,
    name: "shippingAddress"
  }), s = qn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = qn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        _k,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        _k,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, WV = "_productTableHeader_6h6pl_1", KV = "_productImage_6h6pl_5", qa = {
  productTableHeader: WV,
  productImage: KV
}, Ep = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, GV = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Or(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Ep(e);
  return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        Mi,
        {
          src: d,
          alt: e.title,
          className: qa.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
      qt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(Yt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, YV = 300, Ca = 2, JV = 25, QV = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = un(), [i, a] = se(""), [o, s] = se([]), l = Or(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Cp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (j) => {
      const w = j?.Shopify?.products?.nodes || [];
      s(
        w.filter((F) => !!F).sort((F, y) => F.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  gi(
    () => {
      i.trim().length >= Ca && !u && f === Gt.ready ? m({
        variables: {
          query: i.trim(),
          productCount: JV,
          mediaCount: 1
        }
      }) : i.trim().length < Ca && s([]);
    },
    YV,
    [i]
  ), He(() => {
    if (!d) return;
    const j = o.find(
      (w) => w.id === d
    );
    j && e(j), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== Gt.ready, v = i.trim().length >= Ca, N = !o.length && !h && v;
  return /* @__PURE__ */ k.jsx(
    br,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Ca} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (j) => {
          const w = o.find(
            (F) => F.id === j
          );
          return w ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: w.title }) : null;
        },
        filter: {
          value: i,
          onChange: (j) => {
            a(j.target.value);
          }
        },
        onToggleDropdown: (j) => {
          !j && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }) }),
        !h && o.map((j) => {
          const w = j.totalInventory <= 0, F = Ep(j);
          return /* @__PURE__ */ k.jsx(
            ot.Item,
            {
              value: j.id,
              isDisabled: w,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  F && /* @__PURE__ */ k.jsx(
                    Mi,
                    {
                      src: F,
                      alt: j.title,
                      className: qa.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    QS,
                    {
                      text: j.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: j.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: w ? "Out of stock" : `${j.totalInventory} in stock` })
              ] })
            },
            j.id
          );
        }),
        N && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          ss,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ k.jsx(ot.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          ss,
          {
            title: "Search for products",
            description: `Type at least ${Ca} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Tp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Or(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (w) => !o.includes(w?.id)
  ) : [], v = h.length > 0 && h.every(
    (w) => a.includes(w?.id)
  ), N = h.some(
    (w) => a.includes(w?.id)
  ) && !v, j = tt(
    (w) => {
      const F = m.getValues("lineItems"), y = F.findIndex(
        (H) => H?.id === w.id
      );
      if (y > -1) {
        const H = m.getValues(`lineItems.${y}.quantity`) || 0, T = [...F];
        T[y] = {
          ...T[y],
          quantity: H + 1
        }, m.setValue("lineItems", T);
      } else
        m.setValue("lineItems", [
          ...F,
          { ...w, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(QV, { onProductSelected: j }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Ft.boxWrapper,
        children: /* @__PURE__ */ k.jsx(cn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ft.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          ss,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Xn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: qa.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Xn.Thead, { className: qa.productTableHeader, children: /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Xn.Th, { children: /* @__PURE__ */ k.jsx(
              qp,
              {
                checked: v,
                indeterminate: N,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Xn.Tbody, { children: u?.map((w, F) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                GV,
                {
                  product: w,
                  index: F,
                  onRemove: () => {
                    const M = u.filter(
                      (R, q) => q !== F
                    );
                    m.setValue("lineItems", M);
                  }
                },
                `${w?.id}-${F}`
              );
            const y = w, H = y.priceRangeV2.minVariantPrice.amount, T = y.priceRangeV2.minVariantPrice.currencyCode, E = `lineItems.${F}.quantity`, $ = m.watch(E) || 0, U = H * $, Z = Ep(y), Q = a.includes(y.id), ie = o.includes(y.id), J = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Xn.Tr,
              {
                style: ie ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    qp,
                    {
                      checked: Q,
                      disabled: ie,
                      onChange: () => l?.(y.id, !Q)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Z && /* @__PURE__ */ k.jsx(
                      Mi,
                      {
                        src: Z,
                        alt: y.title,
                        className: qa.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.title }),
                      ie && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${H} ${T}` }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    qt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ie || J <= 1,
                      name: E,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: J,
                        tabIndex: 0
                      }
                    },
                    `${E}-${m.watch(E)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${U} ${T}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    Yt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const M = u.filter(
                          (R, q) => q !== F
                        );
                        m.setValue("lineItems", M), Q && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${F}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, Wx = ({
  previousOrderStatus: e
} = {}) => {
  const n = Or();
  return /* @__PURE__ */ k.jsx(
    br,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = yk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: yk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(ot.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, Kx = () => {
  const e = Or();
  return /* @__PURE__ */ k.jsx(
    br,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = gk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: gk.map((n) => /* @__PURE__ */ k.jsx(ot.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, XV = "_modal_1mprq_1", ZV = {
  modal: XV
}, Eu = "create-shopify-order-form", ez = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, [N, j] = se([]), w = lr({
    mode: "all",
    defaultValues: v
  }), F = w.watch("lineItems").length > 0, y = () => {
    w.reset(v), j([]), i(!1);
  };
  He(() => {
    N.length > 0 && w.setValue("tags", N, { shouldDirty: !0 });
  }, [N, w]);
  const [H, { error: T }] = o(
    Bx,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [E, { error: $ }] = o(
    sV,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (Q) => {
    const ie = Q.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    m(!0);
    const J = $i(Q?.billingAddress), M = $i(
      Q?.shippingAddress
    );
    H({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: M,
          billingAddress: J
        }
      }
    });
  }, Z = (Q) => {
    const ie = Q.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const J = $i(Q?.billingAddress), M = $i(
      Q?.shippingAddress
    );
    E({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ie,
          shippingAddress: M,
          billingAddress: J
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: y,
      className: ZV.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(Bm, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: Eu, children: /* @__PURE__ */ k.jsxs(Ut, { children: [
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Tp, {}) }),
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
              Lt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ k.jsx(
                  Ln,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ts,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: N,
                            onChange: (ie) => {
                              j(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(Wx, {}),
              /* @__PURE__ */ k.jsx(Kx, {}),
              /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(tn, { span: 2, children: /* @__PURE__ */ k.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ft.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ip, {})
              }
            ) }) })
          ] }) }) }),
          (T || $) && /* @__PURE__ */ k.jsx(In, { error: T || $ })
        ] }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              type: "submit",
              form: Eu,
              disabled: !F || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: w.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                w.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Eu,
                disabled: !F || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, nz = "_modal_al73g_1", tz = {
  modal: nz
}, xk = [
  {
    label: "Customer",
    value: oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: oi.Staff,
    description: "Staff made an error."
  }
], rz = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = kn(), { useMutation: d, showNotification: m } = un(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, N = lr({
    defaultValues: v
  }), [j, { error: w, reset: F }] = d(rV, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const E = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (E.length > 0)
        o(!1), f(E), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const $ = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, $ ? 0 : 4e3), m({
          title: "Success",
          text: `${$ ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = tt(
    (T) => {
      T.reason != null && (o(!0), j({
        variables: {
          orderId: T.orderId,
          reason: T.reason,
          refundMethod: T.refundMethod,
          restock: T.restock,
          notifyCustomer: T.notifyCustomer,
          staffNote: T.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), H = () => {
    i(!1), F(), f([]), N.reset(v);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: H, className: tz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Cancel order ${r}`, onClose: H }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Ut, { children: [
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        br,
        {
          control: N.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, E) => T === E,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const E = xk.find(
                ($) => $.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: E.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: E.description })
              ] });
            }
          },
          children: xk.map((T) => /* @__PURE__ */ k.jsx(ot.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Ln, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Nu,
        {
          control: N.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Ln, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Nu, { control: N.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Ln, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Nu, { control: N.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          name: "staffNote",
          label: "Staff note",
          control: N.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(ue, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          disabled: !(N.formState.isValid && N.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: N.handleSubmit(y),
        cancelOnClick: H,
        confirmName: w ? "Close" : "Cancel order",
        cancelName: w ? void 0 : "Cancel"
      }
    )
  ] });
}, iz = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          ue,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ft.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      rz,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, az = "_modal_1mprq_1", oz = {
  modal: az
}, sz = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = un(), { track: m } = kn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), N = "duplicate-shopify-order-form", j = (M) => ({
    firstName: M?.firstName,
    lastName: M?.lastName,
    company: M?.company,
    address1: M?.address1,
    address2: M?.address2,
    city: M?.city,
    provinceCode: M?.provinceCode,
    zip: M?.zip,
    countryCode: M?.countryCodeV2,
    phone: M?.phone
  }), w = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: j(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: j(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, F = lr({
    mode: "all",
    defaultValues: w
  }), y = F.watch("lineItems").length > 0, H = qn(
    () => (e?.lineItems || []).map((M) => M.product?.id).filter((M) => !!M),
    [e]
  ), T = qn(
    () => Hx(H),
    [H]
  ), {
    data: E,
    loading: $,
    error: U
  } = d(Cp, {
    skip: !T,
    variables: {
      query: T,
      productCount: H.length,
      mediaCount: 1
    }
  });
  He(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), He(() => {
    if (!r || $ || !E || F.getValues("lineItems")?.length)
      return;
    const M = E?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((q) => {
      const ee = M.find(
        (ge) => ge.id === q.product?.id
      );
      ee && R.push({
        ...ee,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), R.length > 0 && F.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, E, $, e, F]), He(() => {
    (h.length > 0 || (F.getValues("tags") || []).length > 0) && F.setValue("tags", h, { shouldDirty: !0 });
  }, [h, F]);
  const [Z, { error: Q }] = s(
    Bx,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), J();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), J();
      }
    }
  ), ie = (M) => {
    const R = M.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), q = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Z({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          shippingLines: q,
          note: M.customNote,
          tags: M.tags,
          financialStatus: M.financialStatus,
          fulfillmentStatus: M.fulfillmentStatus,
          shippingAddress: $i(M?.shippingAddress),
          billingAddress: $i(M?.billingAddress)
        }
      }
    });
  }, J = () => {
    F.reset(w), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: r,
      onClose: J,
      className: oz.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: `Duplicate order ${n}`, onClose: J }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(Bm, { ...F, children: /* @__PURE__ */ k.jsx("form", { id: N, children: /* @__PURE__ */ k.jsxs(Ut, { children: [
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(Tp, { loading: $ }) }),
            /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
              Lt,
              {
                name: "tags",
                render: ({ fieldState: { error: M } }) => /* @__PURE__ */ k.jsx(
                  Ln,
                  {
                    label: "Tags",
                    meta: {
                      error: M?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ts,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              v(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(tn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                Wx,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(Kx, {}),
              /* @__PURE__ */ k.jsx(
                qt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(tn, { span: 2, children: /* @__PURE__ */ k.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ft.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Ip, {})
              }
            ) }) })
          ] }) }) }),
          Q && /* @__PURE__ */ k.jsx(In, { error: Q })
        ] }),
        /* @__PURE__ */ k.jsx(
          It,
          {
            confirmProps: {
              type: "submit",
              form: N,
              disabled: !y || u || $,
              isLoading: u || $,
              loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: F.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, lz = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(r).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(ue, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Pn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Ke, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: d }) => {
      const m = r[a], u = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Ke.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            u && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: d?.url && /* @__PURE__ */ k.jsx(Mi, { src: `${d?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, cz = Zr`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, dz = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, Gx = (e) => {
  const n = {}, r = dz(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, uz = "_modal_21e62_1", mz = {
  modal: uz
}, Sk = "partial-refund-shopify-order-form", pz = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), { useQuery: d } = un(), [m, u] = se(!1), [f, h] = se([]), v = qn(
    () => e?.refunds ? Gx(e) : {},
    [e]
  ), N = qn(
    () => (e?.lineItems || []).filter((M) => (v[M.id] || 0) >= (M.quantity || 0)).map((M) => M.product?.id).filter((M) => !!M),
    [e, v]
  ), j = qn(() => {
    const M = {};
    return (e?.lineItems || []).forEach((R) => {
      if (R.product?.id) {
        const q = v[R.id] || 0, ee = Math.max(
          0,
          (R.quantity || 0) - q
        );
        M[R.product.id] = ee;
      }
    }), M;
  }, [e, v]), w = qn(
    () => (e?.lineItems || []).map((M) => M.product?.id).filter((M) => !!M),
    [e]
  ), F = qn(
    () => Hx(w),
    [w]
  ), {
    data: y,
    loading: H,
    error: T
  } = d(Cp, {
    skip: !F,
    variables: {
      query: F,
      productCount: w.length,
      mediaCount: 1
    }
  });
  He(() => {
    T && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [T, s]);
  const E = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, $ = lr({
    mode: "all",
    defaultValues: E
  }), U = f.length > 0, [Z, { error: Q }] = o(
    cz,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), J();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), J();
      }
    }
  );
  He(() => {
    if (!r || H || !y || $.getValues("lineItems")?.length)
      return;
    const M = y?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((q) => {
      const ee = M.find(
        (ge) => ge.id === q.product?.id
      );
      if (ee) {
        const ge = v[q.id] || 0, de = (q.quantity || 1) - ge;
        R.push({
          ...ee,
          quantity: de > 0 ? de : q.quantity || 1
        });
      }
    }), R.length > 0 && ($.setValue("lineItems", R, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    H,
    e,
    $,
    v
  ]);
  const ie = (M) => {
    u(!0);
    const R = (M.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const ee = e?.lineItems?.find(
        (pe) => pe.product?.id === q.id
      ), ge = v[ee?.id || ""] || 0, de = (ee?.quantity || 0) - ge, le = Math.max(
        0,
        Math.min(de, q.quantity || 0)
      );
      return ee && le > 0 ? { lineItemId: ee.id, quantity: le } : void 0;
    }).filter((q) => !!q);
    Z({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: R,
          note: M.customNote || void 0,
          notify: !0
        }
      }
    });
  }, J = () => {
    $.reset(E), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: r, onClose: J, className: mz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Refund order ${n}`, onClose: J }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Bm, { ...$, children: /* @__PURE__ */ k.jsx("form", { id: Sk, children: /* @__PURE__ */ k.jsxs(Ut, { children: [
        /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
          Tp,
          {
            loading: H,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: N,
            maxQuantities: j,
            onToggleSelect: (M, R) => {
              h((q) => R ? Array.from(/* @__PURE__ */ new Set([...q, M])) : q.filter((ee) => ee !== M));
            },
            onToggleSelectAll: (M) => {
              const R = ($.getValues("lineItems") || []).map((q) => q.id).filter((q) => !N.includes(q));
              h(M ? R : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(tn, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          qt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(tn, { span: 2, children: /* @__PURE__ */ k.jsx(Ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ft.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Ip,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      Q && /* @__PURE__ */ k.jsx(In, { error: Q })
    ] }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          type: "submit",
          form: Sk,
          disabled: !U || m || H,
          isLoading: m || H,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: $.handleSubmit(ie)
      }
    )
  ] });
}, fz = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = un(), { track: l } = kn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), v = !isNaN(h) && h > 0, [N] = a(tV, {
    onError: (F) => {
      setTimeout(() => w(F), 500);
    },
    onCompleted: (F) => {
      const y = F.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? w(
        new i0({
          graphQLErrors: y.map((H) => ({
            message: H.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), j = tt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: F, ...y } = d;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        F,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), N({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    v,
    s,
    N,
    l
  ]), w = tt(
    (F) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(In, { error: F }),
          /* @__PURE__ */ k.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: j,
      disabled: d?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ k.jsx(ue, { size: 14, name: "undo" }),
      className: Ft.fullWidth,
      children: "Full refund"
    }
  ) });
}, hz = "_modal_al73g_1", yz = {
  modal: hz
}, gz = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = kn(), { useMutation: s, showNotification: l } = un(), [d, m] = se(n), [u, f] = se(!1), h = lr({
    defaultValues: {
      tags: n
    }
  });
  He(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: N, reset: j }] = s(iV, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), w = tt(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((H) => {
        const T = H.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: T });
      });
    },
    [e, h, v]
  ), F = () => {
    i(!1), j();
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: r, onClose: F, className: yz.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Manage tags for order", onClose: F }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Ut, { children: /* @__PURE__ */ k.jsx(tn, { children: /* @__PURE__ */ k.jsx(
        Lt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            Ln,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ts,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (H) => m(H)
                }
              )
            }
          )
        }
      ) }) }),
      N && /* @__PURE__ */ k.jsx(In, { error: N })
    ] }),
    /* @__PURE__ */ k.jsx(
      It,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(cn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(w),
        cancelOnClick: F,
        confirmName: N ? "Close" : "Save",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, vz = "_editIcon_1dntr_1", kz = {
  editIcon: vz
}, bz = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(ue, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, d) => /* @__PURE__ */ k.jsx(Un, { size: "small", variant: "primary", children: l }, d))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Ge, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: o,
          name: "pen",
          className: kz.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      gz,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, _z = "_icon_cddi1_1", xz = "_link_cddi1_6", Nk = {
  icon: _z,
  link: xz
}, Sz = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Za(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Ke.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Nk.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        ue,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Nk.icon
        }
      ) })
    }
  );
}, Nz = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(ue, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Ke, { children: e.map((n) => /* @__PURE__ */ k.jsx(Sz, { trackingInfo: n }, n.number)) })
] }), jz = "_order_135ze_1", wz = "_orderIsOpen_135ze_9", Cz = "_orderHeader_135ze_12", Tu = {
  order: jz,
  orderIsOpen: wz,
  orderHeader: Cz
}, Fz = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = kn(), [h, v] = se(!1), [N, j] = se(!1), [w, F] = se(r), {
    id: y,
    name: H,
    createdAt: T,
    status: E,
    currentTotalPriceSet: $,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ie,
    trackingInfos: J,
    tags: M
  } = e, R = !!ie, q = Fp(y), ee = `https://${l}/admin/orders/${q ?? ""}`, ge = $?.shopMoney?.amount ?? 0, de = E.includes("cancelled"), le = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(ge), pe = e?.refunds ? Gx(e) : {}, W = !!Z?.length && Z.every((ke) => (pe[ke.id] || 0) >= (ke.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ut(Tu.order, {
        [Tu.orderIsOpen]: w
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Tu.orderHeader,
            onClick: () => F(!w),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                T && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: An(T).format(vm) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  H
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: w ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        w && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: E })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(ue, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: le })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            bz,
            {
              orderId: y,
              tags: M,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            km,
            {
              openByDefault: !R,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            km,
            {
              openByDefault: R,
              shopifyId: n,
              orderId: y,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ie,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            lz,
            {
              orderId: y,
              lineItems: Z,
              refundedQuantities: pe
            }
          ),
          /* @__PURE__ */ k.jsx(Nz, { trackingInfos: J }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              fz,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: ee
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => j(!0),
                className: Ft.fullWidth,
                disabled: de || W,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: Ft.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              iz,
              {
                orderId: y,
                orderName: H,
                disabled: de,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            St,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ee, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: y
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          sz,
          {
            order: e,
            shopifyId: n,
            orderName: H,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: u
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          pz,
          {
            order: e,
            orderName: H,
            isOpen: N,
            setIsOpen: j,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, Iz = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = kn(), [f, h] = se([]), [v, N] = se(!1), j = Fp(m?.id), w = `https://${n}/admin/orders?customer_id=${j ?? ""}`, {
    getCustomerOrders: F,
    isCustomerOrdersLoading: y,
    customerOrdersError: H,
    customerOrders: T,
    refetchCustomerOrders: E
  } = cV();
  return He(() => {
    !y && j && F({
      variables: {
        query: `customer_id:${j}`
      }
    });
  }, [j]), He(() => {
    const $ = T?.Shopify?.orders?.edges;
    $ && h(VV({ ordersData: $ }));
  }, [T]), m ? H ? /* @__PURE__ */ k.jsx(In, { error: H }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => N(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map(($, U) => /* @__PURE__ */ k.jsx(
        Fz,
        {
          order: $,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: E,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${$.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        St,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(w, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      ez,
      {
        isOpen: v,
        setIsOpen: N,
        shopifyCustomer: m,
        refetchCustomerOrders: E,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, Ez = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Ke, { className: Ft.list, children: [
      /* @__PURE__ */ k.jsx(Ke.Text, { variant: "dense", className: Ft.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ke.Text, { variant: "dense", className: Ft.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, Tz = "_segmentName_1dkhk_1", $z = {
  segmentName: Tz
}, Dz = 100, Vo = 10, Rz = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = un(), [i, a] = se([]), [o, s] = se(Vo), [l, d] = se(!1), m = qn(
    () => i.filter((j) => j.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    XL,
    {
      skip: !e,
      variables: {
        first: Dz
      },
      onCompleted: (j) => {
        const w = j?.Shopify?.segments?.edges;
        if (w && w.length > 0) {
          const F = w.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, H) => y.name.localeCompare(H.name));
          a(F), h({
            variables: {
              customerId: e,
              segmentIds: F.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: N }
  ] = r(ZL, {
    onCompleted: (j) => {
      const w = j?.Shopify?.customerSegmentMembership?.memberships;
      if (w && w.length > 0) {
        const F = i.map((y) => {
          const H = w.find(
            (T) => T.segmentId === y.id
          );
          return {
            ...y,
            ...H?.isMember && { isMember: H.isMember }
          };
        }).sort(
          (y, H) => y.isMember === H.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(F);
      }
    }
  });
  return He(() => {
    s(l ? i.length : Vo);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(Un, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(cn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(In, { error: f }),
    N && /* @__PURE__ */ k.jsx(In, { error: N }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Ke, { className: Ft.list, children: [
      i.slice(0, o).map(({ id: j, name: w, isMember: F }) => /* @__PURE__ */ k.jsx(Ke.Text, { className: Ft.listItem, children: /* @__PURE__ */ k.jsx(
        Ge,
        {
          content: `${F ? "Member of" : "Not a member of"} ${w}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: $z.segmentName, children: w }),
            v && /* @__PURE__ */ k.jsx(cn, { size: 12 }),
            !v && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              ue,
              {
                color: F ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, j)),
      i.length > Vo && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Vo} more`
        }
      ) })
    ] })
  ] }) : null;
}, Oz = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = lV({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, N = n.enableEditShippingAddress ?? !1, j = n.displayEmailMarketingConsent ?? !1, w = n.displayOrdersOverview ?? !1, F = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, H = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, E = n.displayDuplicateOrder ?? !1, $ = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (He(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Z)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(In, { error: i, retry: o });
  if (!r && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              gV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              St,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(ue, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== Gt.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(cn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          bV,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        w && /* @__PURE__ */ k.jsx(
          Ez,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        F && /* @__PURE__ */ k.jsx(Rz, { shopifyId: l?.id }),
        j && /* @__PURE__ */ k.jsx(LV, { customer: l }),
        H && /* @__PURE__ */ k.jsx(
          AV,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          Iz,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: T,
            displayCreateDraftOrder: $,
            enableEditShippingAddress: N,
            customerCountryCodes: m,
            displayDuplicateOrder: E,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, kt = [];
for (let e = 0; e < 256; ++e)
  kt.push((e + 256).toString(16).slice(1));
function Pz(e, n = 0) {
  return (kt[e[n + 0]] + kt[e[n + 1]] + kt[e[n + 2]] + kt[e[n + 3]] + "-" + kt[e[n + 4]] + kt[e[n + 5]] + "-" + kt[e[n + 6]] + kt[e[n + 7]] + "-" + kt[e[n + 8]] + kt[e[n + 9]] + "-" + kt[e[n + 10]] + kt[e[n + 11]] + kt[e[n + 12]] + kt[e[n + 13]] + kt[e[n + 14]] + kt[e[n + 15]]).toLowerCase();
}
let $u;
const Az = new Uint8Array(16);
function Lz() {
  if (!$u) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    $u = crypto.getRandomValues.bind(crypto);
  }
  return $u(Az);
}
const Vz = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), jk = { randomUUID: Vz };
function zz(e, n, r) {
  if (jk.randomUUID && !e)
    return jk.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? Lz();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, Pz(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, Fa = {}, wk;
function Uz() {
  if (wk) return Fa;
  wk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Fa.Fragment = r, Fa.jsx = s, Fa.jsxs = s, Fa;
}
var zo = {}, Ck;
function Mz() {
  return Ck || (Ck = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    zo.Fragment = i, zo.jsx = Rn, zo.jsxs = Bn;
  })()), zo;
}
var Fk;
function Bz() {
  return Fk || (Fk = 1, process.env.NODE_ENV === "production" ? Du.exports = Uz() : Du.exports = Mz()), Du.exports;
}
var B = Bz(), Yx = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(Yx || {}), bm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(bm || {});
const qz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Hz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Wz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, Kz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, Gz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, Yz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, Jz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, Qz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, Xz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, Zz = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": qz,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Hz,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": Wz,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": Kz,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": Gz,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": Yz,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": Jz,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": Qz,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": Xz
};
function Wr(e) {
  return Zz[e] ?? {};
}
const e3 = Wr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), n3 = Wr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), t3 = Wr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), r3 = Wr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), i3 = Wr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), a3 = Wr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), o3 = Wr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), s3 = Wr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), l3 = Wr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), c3 = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = kn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(e3, {
    skip: !e,
    variables: { contactId: e }
  });
  return He(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (N) => N !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), qn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function is(e = !1, n) {
  const [r, i] = se(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const d3 = {
  count: 0,
  items: []
}, u3 = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = kn(), [i, a] = se(d3), {
    loading: o,
    error: s,
    data: l
  } = n(r3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, m3 = {
  count: 0,
  totalCount: 0,
  items: []
}, p3 = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = kn(), [i, a] = se(
    m3
  ), {
    loading: o,
    error: s,
    data: l
  } = n(i3, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, f3 = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(t3, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return He(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, h3 = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = un(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(n3, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return He(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), qn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, y3 = "_pointer_ls8kj_48", g3 = "_list_ls8kj_53", v3 = "_listItem_ls8kj_63", nt = {
  pointer: y3,
  list: g3,
  listItem: v3
};
var po = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Pt = (e) => e == null;
const Jx = (e) => typeof e == "object";
var lt = (e) => !Pt(e) && !Array.isArray(e) && Jx(e) && !ci(e), Qx = (e) => lt(e) && e.target ? po(e.target) ? e.target.checked : e.target.value : e, k3 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Xx = (e, n) => e.has(k3(n)), b3 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, $p = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _t(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!($p && (e instanceof Blob || i)) && (r || lt(e)))
    if (n = r ? [] : {}, !r && !b3(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = _t(e[a]));
  else
    return e;
  return n;
}
var Js = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !lt(e))
    return r;
  const i = Js(n.split(/[,[\].]+?/)).reduce((a, o) => Pt(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? r : e[n] : i;
}, Xt = (e) => typeof e == "boolean", Dp = (e) => /^\w*$/.test(e), Zx = (e) => Js(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Dp(n) ? [n] : Zx(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const xs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, hr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ur = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, _3 = Se.createContext(null), Rp = () => Se.useContext(_3);
var eS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== hr.all && (n._proxyFormState[s] = !i || hr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function x3(e) {
  const n = Rp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => eS(s, r, d.current, !1), [s, r]);
}
var Tr = (e) => typeof e == "string", nS = (e, n, r, i, a) => Tr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function tS(e) {
  const n = Rp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(nS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function S3(e) {
  const n = Rp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Xx(a._names.array, r), l = tS({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = x3({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Xt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((w) => u.current.onChange({
    target: {
      value: Qx(w),
      name: r
    },
    type: xs.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: xs.BLUR
  }), [r, a._formValues]), N = Se.useCallback((w) => {
    const F = Je(a._fields, r);
    F && w && (F._f.ref = {
      focus: () => w.focus(),
      select: () => w.select(),
      setCustomValidity: (y) => w.setCustomValidity(y),
      reportValidity: () => w.reportValidity()
    });
  }, [a._fields, r]), j = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Xt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: N
  }), [r, i, d.disabled, h, v, N, l]);
  return Se.useEffect(() => {
    const w = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Xt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, H) => {
      const T = Je(a._fields, y);
      T && T._f && (T._f.mount = H);
    };
    if (F(r, !0), w) {
      const y = _t(Je(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), it(Je(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? w && !a._state.action : w) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
const Ik = (e) => e.render(S3(e));
var N3 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ha = (e) => Array.isArray(e) ? e : [e], Ek = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, _m = (e) => Pt(e) || !Jx(e);
function Qr(e, n) {
  if (_m(e) || _m(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !Qr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Dt = (e) => lt(e) && !Object.keys(e).length, Op = (e) => e.type === "file", yr = (e) => typeof e == "function", Ss = (e) => {
  if (!$p)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, rS = (e) => e.type === "select-multiple", Pp = (e) => e.type === "radio", j3 = (e) => Pp(e) || po(e), Ru = (e) => Ss(e) && e.isConnected;
function w3(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function C3(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : Dp(n) ? [n] : Zx(n), i = r.length === 1 ? e : w3(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (lt(i) && Dt(i) || Array.isArray(i) && C3(i)) && ht(e, r.slice(0, -1)), e;
}
var iS = (e) => {
  for (const n in e)
    if (yr(e[n]))
      return !0;
  return !1;
};
function Ns(e, n = {}) {
  const r = Array.isArray(e);
  if (lt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !iS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ns(e[i], n[i])) : Pt(e[i]) || (n[i] = !0);
  return n;
}
function aS(e, n, r) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !iS(e[a]) ? it(n) || _m(r[a]) ? r[a] = Array.isArray(e[a]) ? Ns(e[a], []) : { ...Ns(e[a]) } : aS(e[a], Pt(n) ? {} : n[a], r[a]) : r[a] = !Qr(e[a], n[a]);
  return r;
}
var Ia = (e, n) => aS(e, n, Ns(n));
const Tk = {
  value: !1,
  isValid: !1
}, $k = { value: !0, isValid: !0 };
var oS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? $k : { value: e[0].value, isValid: !0 } : $k
    ) : Tk;
  }
  return Tk;
}, sS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : r && Tr(e) ? new Date(e) : i ? i(e) : e;
const Dk = {
  isValid: !1,
  value: null
};
var lS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Dk) : Dk;
function Rk(e) {
  const n = e.ref;
  return Op(n) ? n.files : Pp(n) ? lS(e.refs).value : rS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : po(n) ? oS(e.refs).value : sS(it(n.value) ? e.ref.value : n.value, e);
}
var F3 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, js = (e) => e instanceof RegExp, Ea = (e) => it(e) ? e : js(e) ? e.source : lt(e) ? js(e.value) ? e.value.source : e.value : e, Ok = (e) => ({
  isOnSubmit: !e || e === hr.onSubmit,
  isOnBlur: e === hr.onBlur,
  isOnChange: e === hr.onChange,
  isOnAll: e === hr.all,
  isOnTouch: e === hr.onTouched
});
const Pk = "AsyncFunction";
var I3 = (e) => !!e && !!e.validate && !!(yr(e.validate) && e.validate.constructor.name === Pk || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Pk)), E3 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Ak = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Wa = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Wa(l, n))
          break;
      } else if (lt(l) && Wa(l, n))
        break;
    }
  }
};
function Lk(e, n, r) {
  const i = Je(e, r);
  if (i || Dp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var T3 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Dt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || hr.all));
}, $3 = (e, n, r) => !e || !n || e === n || Ha(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), D3 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, R3 = (e, n) => !Js(Je(e, n)).length && ht(e, n), O3 = (e, n, r) => {
  const i = Ha(Je(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, as = (e) => Tr(e);
function Vk(e, n, r = "validate") {
  if (as(e) || Array.isArray(e) && e.every(as) || Xt(e) && !e)
    return {
      type: r,
      message: as(e) ? e : "",
      ref: n
    };
}
var Fi = (e) => lt(e) && !js(e) ? e : {
  value: e,
  message: ""
}, zk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: N, name: j, valueAsNumber: w, mount: F } = e._f, y = Je(r, j);
  if (!F || n.has(j))
    return {};
  const H = l ? l[0] : s, T = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Xt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, $ = Pp(s), U = po(s), Z = $ || U, Q = (w || Op(s)) && it(s.value) && it(y) || Ss(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = N3.bind(null, j, i, E), J = (M, R, q, ee = Ur.maxLength, ge = Ur.minLength) => {
    const de = M ? R : q;
    E[j] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || Pt(y)) || Xt(y) && !y || U && !oS(l).isValid || $ && !lS(l).isValid)) {
    const { value: M, message: R } = as(d) ? { value: !!d, message: d } : Fi(d);
    if (M && (E[j] = {
      type: Ur.required,
      message: R,
      ref: H,
      ...ie(Ur.required, R)
    }, !i))
      return T(R), E;
  }
  if (!Q && (!Pt(f) || !Pt(h))) {
    let M, R;
    const q = Fi(h), ee = Fi(f);
    if (!Pt(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      Pt(q.value) || (M = ge > q.value), Pt(ee.value) || (R = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      Tr(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), Tr(ee.value) && y && (R = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || R) && (J(!!M, q.message, ee.message, Ur.max, Ur.min), !i))
      return T(E[j].message), E;
  }
  if ((m || u) && !Q && (Tr(y) || o && Array.isArray(y))) {
    const M = Fi(m), R = Fi(u), q = !Pt(M.value) && y.length > +M.value, ee = !Pt(R.value) && y.length < +R.value;
    if ((q || ee) && (J(q, M.message, R.message), !i))
      return T(E[j].message), E;
  }
  if (v && !Q && Tr(y)) {
    const { value: M, message: R } = Fi(v);
    if (js(M) && !y.match(M) && (E[j] = {
      type: Ur.pattern,
      message: R,
      ref: s,
      ...ie(Ur.pattern, R)
    }, !i))
      return T(R), E;
  }
  if (N) {
    if (yr(N)) {
      const M = await N(y, r), R = Vk(M, H);
      if (R && (E[j] = {
        ...R,
        ...ie(Ur.validate, R.message)
      }, !i))
        return T(R.message), E;
    } else if (lt(N)) {
      let M = {};
      for (const R in N) {
        if (!Dt(M) && !i)
          break;
        const q = Vk(await N[R](y, r), H, R);
        q && (M = {
          ...q,
          ...ie(R, q.message)
        }, T(q.message), i && (E[j] = M));
      }
      if (!Dt(M) && (E[j] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const P3 = {
  mode: hr.onSubmit,
  reValidateMode: hr.onChange,
  shouldFocusError: !0
};
function A3(e = {}) {
  let n = {
    ...P3,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: yr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? _t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : _t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ek(),
    state: Ek()
  }, v = Ok(n.mode), N = Ok(n.reValidateMode), j = n.criteriaMode === hr.all, w = (C) => (_) => {
    clearTimeout(m), m = setTimeout(C, _);
  }, F = async (C) => {
    if (!n.disabled && (u.isValid || f.isValid || C)) {
      const _ = n.resolver ? Dt((await Q()).errors) : await J(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (C, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((C || Array.from(l.mount)).forEach((D) => {
      D && (_ ? Yn(r.validatingFields, D, _) : ht(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Dt(r.validatingFields)
    }));
  }, H = (C, _ = [], D, G, Y = !0, O = !0) => {
    if (G && D && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Je(i, C))) {
        const z = D(Je(i, C), G.argA, G.argB);
        Y && Yn(i, C, z);
      }
      if (O && Array.isArray(Je(r.errors, C))) {
        const z = D(Je(r.errors, C), G.argA, G.argB);
        Y && Yn(r.errors, C, z), R3(r.errors, C);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Je(r.touchedFields, C))) {
        const z = D(Je(r.touchedFields, C), G.argA, G.argB);
        Y && Yn(r.touchedFields, C, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ia(a, o)), h.state.next({
        name: C,
        isDirty: R(C, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, C, _);
  }, T = (C, _) => {
    Yn(r.errors, C, _), h.state.next({
      errors: r.errors
    });
  }, E = (C) => {
    r.errors = C, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (C, _, D, G) => {
    const Y = Je(i, C);
    if (Y) {
      const O = Je(o, C, it(D) ? Je(a, C) : D);
      it(O) || G && G.defaultChecked || _ ? Yn(o, C, _ ? O : Rk(Y._f)) : ge(C, O), s.mount && F();
    }
  }, U = (C, _, D, G, Y) => {
    let O = !1, z = !1;
    const re = {
      name: C
    };
    if (!n.disabled) {
      if (!D || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = re.isDirty = R(), O = z !== re.isDirty);
        const fe = Qr(Je(a, C), _);
        z = !!Je(r.dirtyFields, C), fe ? ht(r.dirtyFields, C) : Yn(r.dirtyFields, C, !0), re.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && z !== !fe;
      }
      if (D) {
        const fe = Je(r.touchedFields, C);
        fe || (Yn(r.touchedFields, C, D), re.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== D);
      }
      O && Y && h.state.next(re);
    }
    return O ? re : {};
  }, Z = (C, _, D, G) => {
    const Y = Je(r.errors, C), O = (u.isValid || f.isValid) && Xt(_) && r.isValid !== _;
    if (n.delayError && D ? (d = w(() => T(C, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Yn(r.errors, C, D) : ht(r.errors, C)), (D ? !Qr(Y, D) : Y) || !Dt(G) || O) {
      const z = {
        ...G,
        ...O && Xt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: C
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, Q = async (C) => {
    y(C, !0);
    const _ = await n.resolver(o, n.context, F3(C || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(C), _;
  }, ie = async (C) => {
    const { errors: _ } = await Q(C);
    if (C)
      for (const D of C) {
        const G = Je(_, D);
        G ? Yn(r.errors, D, G) : ht(r.errors, D);
      }
    else
      r.errors = _;
    return _;
  }, J = async (C, _, D = {
    valid: !0
  }) => {
    for (const G in C) {
      const Y = C[G];
      if (Y) {
        const { _f: O, ...z } = Y;
        if (O) {
          const re = l.array.has(O.name), fe = Y._f && I3(Y._f);
          fe && u.validatingFields && y([G], !0);
          const be = await zk(Y, l.disabled, o, j, n.shouldUseNativeValidation && !_, re);
          if (fe && u.validatingFields && y([G]), be[O.name] && (D.valid = !1, _))
            break;
          !_ && (Je(be, O.name) ? re ? O3(r.errors, be, O.name) : Yn(r.errors, O.name, be[O.name]) : ht(r.errors, O.name));
        }
        !Dt(z) && await J(z, _, D);
      }
    }
    return D.valid;
  }, M = () => {
    for (const C of l.unMount) {
      const _ = Je(i, C);
      _ && (_._f.refs ? _._f.refs.every((D) => !Ru(D)) : !Ru(_._f.ref)) && Le(C);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (C, _) => !n.disabled && (C && _ && Yn(o, C, _), !Qr(Ce(), a)), q = (C, _, D) => nS(C, l, {
    ...s.mount ? o : it(_) ? a : Tr(C) ? { [C]: _ } : _
  }, D, _), ee = (C) => Js(Je(s.mount ? o : a, C, n.shouldUnregister ? Je(a, C, []) : [])), ge = (C, _, D = {}) => {
    const G = Je(i, C);
    let Y = _;
    if (G) {
      const O = G._f;
      O && (!O.disabled && Yn(o, C, sS(_, O)), Y = Ss(O.ref) && Pt(_) ? "" : _, rS(O.ref) ? [...O.ref.options].forEach((z) => z.selected = Y.includes(z.value)) : O.refs ? po(O.ref) ? O.refs.length > 1 ? O.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(Y) ? !!Y.find((re) => re === z.value) : Y === z.value)) : O.refs[0] && (O.refs[0].checked = !!Y) : O.refs.forEach((z) => z.checked = z.value === Y) : Op(O.ref) ? O.ref.value = "" : (O.ref.value = Y, O.ref.type || h.state.next({
        name: C,
        values: _t(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(C, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && ke(C);
  }, de = (C, _, D) => {
    for (const G in _) {
      const Y = _[G], O = `${C}.${G}`, z = Je(i, O);
      (l.array.has(C) || lt(Y) || z && !z._f) && !ci(Y) ? de(O, Y, D) : ge(O, Y, D);
    }
  }, le = (C, _, D = {}) => {
    const G = Je(i, C), Y = l.array.has(C), O = _t(_);
    Yn(o, C, O), Y ? (h.array.next({
      name: C,
      values: _t(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: C,
      dirtyFields: Ia(a, o),
      isDirty: R(C, O)
    })) : G && !G._f && !Pt(O) ? de(C, O, D) : ge(C, O, D), Ak(C, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? C : void 0,
      values: _t(o)
    });
  }, pe = async (C) => {
    s.mount = !0;
    const _ = C.target;
    let D = _.name, G = !0;
    const Y = Je(i, D), O = (z) => {
      G = Number.isNaN(z) || ci(z) && isNaN(z.getTime()) || Qr(z, Je(o, D, z));
    };
    if (Y) {
      let z, re;
      const fe = _.type ? Rk(Y._f) : Qx(C), be = C.type === xs.BLUR || C.type === xs.FOCUS_OUT, en = !E3(Y._f) && !n.resolver && !Je(r.errors, D) && !Y._f.deps || D3(be, Je(r.touchedFields, D), r.isSubmitted, N, v), pn = Ak(D, l, be);
      Yn(o, D, fe), be ? (Y._f.onBlur && Y._f.onBlur(C), d && d(0)) : Y._f.onChange && Y._f.onChange(C);
      const rn = U(D, fe, be), dn = !Dt(rn) || pn;
      if (!be && h.state.next({
        name: D,
        type: C.type,
        values: _t(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? be && F() : be || F()), dn && h.state.next({ name: D, ...pn ? {} : rn });
      if (!be && pn && h.state.next({ ...r }), n.resolver) {
        const { errors: mn } = await Q([D]);
        if (O(fe), G) {
          const ln = Lk(r.errors, i, D), vn = Lk(mn, i, ln.name || D);
          z = vn.error, D = vn.name, re = Dt(mn);
        }
      } else
        y([D], !0), z = (await zk(Y, l.disabled, o, j, n.shouldUseNativeValidation))[D], y([D]), O(fe), G && (z ? re = !1 : (u.isValid || f.isValid) && (re = await J(i, !0)));
      G && (Y._f.deps && ke(Y._f.deps), Z(D, re, z, rn));
    }
  }, W = (C, _) => {
    if (Je(r.errors, _) && C.focus)
      return C.focus(), 1;
  }, ke = async (C, _ = {}) => {
    let D, G;
    const Y = Ha(C);
    if (n.resolver) {
      const O = await ie(it(C) ? C : Y);
      D = Dt(O), G = C ? !Y.some((z) => Je(O, z)) : D;
    } else C ? (G = (await Promise.all(Y.map(async (O) => {
      const z = Je(i, O);
      return await J(z && z._f ? { [O]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = D = await J(i);
    return h.state.next({
      ...!Tr(C) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: C },
      ...n.resolver || !C ? { isValid: D } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Wa(i, W, C ? Y : l.mount), G;
  }, Ce = (C) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(C) ? _ : Tr(C) ? Je(_, C) : C.map((D) => Je(_, D));
  }, K = (C, _) => ({
    invalid: !!Je((_ || r).errors, C),
    isDirty: !!Je((_ || r).dirtyFields, C),
    error: Je((_ || r).errors, C),
    isValidating: !!Je(r.validatingFields, C),
    isTouched: !!Je((_ || r).touchedFields, C)
  }), qe = (C) => {
    C && Ha(C).forEach((_) => ht(r.errors, _)), h.state.next({
      errors: C ? r.errors : {}
    });
  }, Be = (C, _, D) => {
    const G = (Je(i, C, { _f: {} })._f || {}).ref, Y = Je(r.errors, C) || {}, { ref: O, message: z, type: re, ...fe } = Y;
    Yn(r.errors, C, {
      ...fe,
      ..._,
      ref: G
    }), h.state.next({
      name: C,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && G && G.focus && G.focus();
  }, Pe = (C, _) => yr(C) ? h.state.subscribe({
    next: (D) => C(q(void 0, _), D)
  }) : q(C, _, !0), Ue = (C) => h.state.subscribe({
    next: (_) => {
      $3(C.name, _.name, C.exact) && T3(_, C.formState || u, Re, C.reRenderRoot) && C.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, je = (C) => (s.mount = !0, f = {
    ...f,
    ...C.formState
  }, Ue({
    ...C,
    formState: f
  })), Le = (C, _ = {}) => {
    for (const D of C ? Ha(C) : l.mount)
      l.mount.delete(D), l.array.delete(D), _.keepValue || (ht(i, D), ht(o, D)), !_.keepError && ht(r.errors, D), !_.keepDirty && ht(r.dirtyFields, D), !_.keepTouched && ht(r.touchedFields, D), !_.keepIsValidating && ht(r.validatingFields, D), !n.shouldUnregister && !_.keepDefaultValue && ht(a, D);
    h.state.next({
      values: _t(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && F();
  }, Te = ({ disabled: C, name: _ }) => {
    (Xt(C) && s.mount || C || l.disabled.has(_)) && (C ? l.disabled.add(_) : l.disabled.delete(_));
  }, an = (C, _ = {}) => {
    let D = Je(i, C);
    const G = Xt(_.disabled) || Xt(n.disabled);
    return Yn(i, C, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: C } },
        name: C,
        mount: !0,
        ..._
      }
    }), l.mount.add(C), D ? Te({
      disabled: Xt(_.disabled) ? _.disabled : n.disabled,
      name: C
    }) : $(C, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ea(_.min),
        max: Ea(_.max),
        minLength: Ea(_.minLength),
        maxLength: Ea(_.maxLength),
        pattern: Ea(_.pattern)
      } : {},
      name: C,
      onChange: pe,
      onBlur: pe,
      ref: (Y) => {
        if (Y) {
          an(C, _), D = Je(i, C);
          const O = it(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, z = j3(O), re = D._f.refs || [];
          if (z ? re.find((fe) => fe === O) : O === D._f.ref)
            return;
          Yn(i, C, {
            _f: {
              ...D._f,
              ...z ? {
                refs: [
                  ...re.filter(Ru),
                  O,
                  ...Array.isArray(Je(a, C)) ? [{}] : []
                ],
                ref: { type: O.type, name: C }
              } : { ref: O }
            }
          }), $(C, !1, void 0, O);
        } else
          D = Je(i, C, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(Xx(l.array, C) && s.action) && l.unMount.add(C);
      }
    };
  }, we = () => n.shouldFocusError && Wa(i, W, l.mount), We = (C) => {
    Xt(C) && (h.state.next({ disabled: C }), Wa(i, (_, D) => {
      const G = Je(i, D);
      G && (_.disabled = G._f.disabled || C, Array.isArray(G._f.refs) && G._f.refs.forEach((Y) => {
        Y.disabled = G._f.disabled || C;
      }));
    }, 0, !1));
  }, Xe = (C, _) => async (D) => {
    let G;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = _t(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: z } = await Q();
      r.errors = O, Y = z;
    } else
      await J(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Yn(Y, O, void 0);
    if (ht(r.errors, "root"), Dt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await C(Y, D);
      } catch (O) {
        G = O;
      }
    } else
      _ && await _({ ...r.errors }, D), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Dt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (C, _ = {}) => {
    Je(i, C) && (it(_.defaultValue) ? le(C, _t(Je(a, C))) : (le(C, _.defaultValue), Yn(a, C, _t(_.defaultValue))), _.keepTouched || ht(r.touchedFields, C), _.keepDirty || (ht(r.dirtyFields, C), r.isDirty = _.defaultValue ? R(C, _t(Je(a, C))) : R()), _.keepError || (ht(r.errors, C), u.isValid && F()), h.state.next({ ...r }));
  }, he = (C, _ = {}) => {
    const D = C ? _t(C) : a, G = _t(D), Y = Dt(C), O = Y ? a : G;
    if (_.keepDefaultValues || (a = D), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ia(a, o))
        ]);
        for (const re of Array.from(z))
          Je(r.dirtyFields, re) ? Yn(O, re, Je(o, re)) : le(re, Je(O, re));
      } else {
        if ($p && it(C))
          for (const z of l.mount) {
            const re = Je(i, z);
            if (re && re._f) {
              const fe = Array.isArray(re._f.refs) ? re._f.refs[0] : re._f.ref;
              if (Ss(fe)) {
                const be = fe.closest("form");
                if (be) {
                  be.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Je(O, z));
      }
      o = _t(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Qr(C, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Ia(a, o) : r.dirtyFields : _.keepDefaultValues && C ? Ia(a, C) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (C, _) => he(yr(C) ? C(o) : C, _), Ae = (C, _ = {}) => {
    const D = Je(i, C), G = D && D._f;
    if (G) {
      const Y = G.refs ? G.refs[0] : G.ref;
      Y.focus && (Y.focus(), _.shouldSelect && yr(Y.select) && Y.select());
    }
  }, Re = (C) => {
    r = {
      ...r,
      ...C
    };
  }, ze = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Xe,
      setError: Be,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: R,
      _setValid: F,
      _setFieldArray: H,
      _setDisabledField: Te,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => yr(n.defaultValues) && n.defaultValues().then((C) => {
        Ie(C, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(C) {
        s = C;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(C) {
        l = C;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(C) {
        n = {
          ...n,
          ...C
        };
      }
    },
    subscribe: je,
    trigger: ke,
    register: an,
    handleSubmit: Xe,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...ze,
    formControl: ze
  };
}
function L3(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: yr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: yr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : A3(e),
    formState: i
  }, e.formControl && e.defaultValues && !yr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Qr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Dt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = eS(i, o), n.current;
}
const V3 = "_modalBody_1clhs_1", z3 = {
  modalBody: V3
}, U3 = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = kn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = L3({
    defaultValues: u,
    mode: "onChange"
  }), N = tS({ control: f }), j = parseInt(N?.balance ?? "0", 10), w = m === j, F = w ? "Change the value to update the points" : "", y = j < 0, H = y ? "Points can not be negative" : "", T = N.description === "", E = T ? "Description can not be empty" : "";
  He(() => {
    j > m ? h(
      "transactionType",
      bm.Addition
    ) : j < m && h(
      "transactionType",
      bm.Deduction
    );
  }, [m, j, h]);
  const [$, { loading: U, error: Z, reset: Q }] = o(l3, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ie = () => {
    if (d) {
      const M = zz();
      $({
        variables: {
          input: {
            accountId: d,
            transactionId: M,
            amount: Math.abs(j - m),
            transactionType: N.transactionType,
            description: N.description,
            source: Yx.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    v(u), Q(), n();
  };
  return /* @__PURE__ */ B.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ B.jsx(jt, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ B.jsxs(wt, { className: z3.modalBody, children: [
          /* @__PURE__ */ B.jsxs(Ut, { children: [
            /* @__PURE__ */ B.jsx(tn, { span: 6, children: /* @__PURE__ */ B.jsx(
              Ik,
              {
                name: "balance",
                control: f,
                render: ({ field: M }) => /* @__PURE__ */ B.jsx(
                  or,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: F || H
                    },
                    input: {
                      ...M,
                      value: M.value.toString(),
                      onChange: (R) => M.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ B.jsx(tn, { span: 6, children: /* @__PURE__ */ B.jsx(
              Ik,
              {
                name: "description",
                control: f,
                render: ({ field: M }) => /* @__PURE__ */ B.jsx(
                  or,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: M,
                    meta: {
                      warning: E
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ B.jsx(In, { error: Z })
        ] }),
        /* @__PURE__ */ B.jsx(
          It,
          {
            confirmName: "Save",
            confirmOnClick: () => ie(),
            confirmProps: {
              isLoading: U,
              disabled: w || y || T,
              loadingIndicator: /* @__PURE__ */ B.jsx(cn, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, M3 = "_wrapper_1ge6c_1", B3 = "_block_1ge6c_12", Uk = {
  wrapper: M3,
  block: B3
}, q3 = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = un(), { isCopied: i, copy: a } = is(), { isCopied: o, copy: s } = is(), { isCopied: l, copy: d } = is(), [m, u] = se(!1), [f, h] = se(), [v, N] = se(!1), {
    loading: j,
    data: w,
    refetch: F
  } = r(o3, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  He(() => {
    if (w) {
      const ee = w?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [w]);
  const y = !!f?.id, H = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: E,
    street: $,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ie,
    email: J,
    mobilePhone: M
  } = e, R = 14, q = `${T || ""} ${E || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", className: Uk.wrapper, children: [
    /* @__PURE__ */ B.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Uk.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-2", children: q }),
          j && /* @__PURE__ */ B.jsx(cn, { size: 12 }),
          y && !j && /* @__PURE__ */ B.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ B.jsxs(Un, { size: "small", variant: "warning", children: [
              H,
              " points"
            ] }),
            /* @__PURE__ */ B.jsx(Ge, { content: "Update points balance", children: /* @__PURE__ */ B.jsx(
              ue,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ B.jsx(Ge, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ B.jsx(
              ue,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    ($ || Z || U || Q || M || J) && /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
      M && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "phone" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: M })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(M),
            className: nt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "mail" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: nt.pointer
          }
        )
      ] }),
      ($ || Z || U || Q) && /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "home" }),
          /* @__PURE__ */ B.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ B.jsx(Qn, { children: $ }),
            /* @__PURE__ */ B.jsxs(Qn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ B.jsx(Qn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => d(`${$}, ${U} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ B.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(ue, { size: R, name: "sign-in" }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ B.jsx(
          ue,
          {
            name: ie ? "check-circle-filled" : "close-circle-filled",
            color: ie ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ B.jsx(
      U3,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: N,
        refetchPointsQuery: F
      }
    )
  ] });
}, H3 = "_list_yud4a_7", W3 = "_listItem_yud4a_11", K3 = "_listItemTooltip_yud4a_15", G3 = "_listItemTimestamp_yud4a_18", Uo = {
  list: H3,
  listItem: W3,
  listItemTooltip: K3,
  listItemTimestamp: G3
}, Y3 = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ B.jsx(Ke, { className: Uo.list, children: e.map((n, r) => /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: Uo.listItem, children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ B.jsx(Ge, { content: n?.comment, children: /* @__PURE__ */ B.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [Uo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { className: Uo.listItemTimestamp, children: An(n.date).format(dt) }),
          n?.comment && /* @__PURE__ */ B.jsx(ue, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ B.jsx(
      ue,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), J3 = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? An(e.latestChange).format(dt) : null, o = e?.expires ? `${An(e.expires).fromNow()} (${An(e.expires).format(dt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ B.jsx(Ge, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ B.jsx(
        ue,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ B.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ B.jsxs(Ke, { className: nt.list, children: [
      s && /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ge, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ge, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ge, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ge, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ B.jsx(Ge, { content: "", children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, Q3 = "_tagHover_kzbzk_1", X3 = "_channelUnsubscribed_kzbzk_6", Mk = {
  tagHover: Q3,
  channelUnsubscribed: X3
}, Ou = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = kn(), { useMutation: l } = un(), [d, m] = se(!1), [u, { loading: f }] = l(s3), h = async ({
    newPreference: N,
    isSubscribed: j,
    channelType: w
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...N
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? j ? s("voyado:channel:unsubscribe:succeeded", { channel: w }) : s("voyado:channel:subscribe:succeeded", { channel: w }) : j ? s("voyado:channel:unsubscribe:failed", { channel: w }) : s("voyado:channel:subscribe:failed", { channel: w }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ B.jsx(Ge, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ B.jsx(
    Pn,
    {
      className: Mk.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ B.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [Mk.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ B.jsx(cn, { size: 16 }) : /* @__PURE__ */ B.jsx(ue, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, Z3 = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        Ou,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        Ou,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ B.jsx(
        Ou,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, eU = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = c3({ contactId: e }), {
    isLoading: v,
    error: N,
    memberLevel: j
  } = h3({ contactId: e, skip: !s }), w = v || l, F = qn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || N ? no({
    errors: d?.graphQLErrors || N?.graphQLErrors || []
  }) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ B.jsx(In, { error: d || N }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : w ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
    r && /* @__PURE__ */ B.jsx(
      q3,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ B.jsx(J3, { memberLevel: j }),
    i && /* @__PURE__ */ B.jsx(
      Z3,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ B.jsx(Y3, { contactConsents: F })
  ] });
}, xm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, nU = "_list_zu4s7_1", tU = "_listItem_zu4s7_4", rU = "_listSum_zu4s7_7", Mo = {
  list: nU,
  listItem: tU,
  listSum: rU
}, iU = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ B.jsxs(Ke, { className: Mo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ B.jsx(Ke.Text, { variant: "dense", className: Mo.listItem, children: /* @__PURE__ */ B.jsx(Ge, { content: s, children: /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ B.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ B.jsx(b, { flex: "auto", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ B.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: xm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ B.jsx(
    Ke.Text,
    {
      variant: "dense",
      className: ut(Mo.listItem, Mo.listSum),
      children: /* @__PURE__ */ B.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: xm(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), aU = "_transaction_1kr8d_1", oU = "_transactionIsOpen_1kr8d_9", sU = "_transactionHeader_1kr8d_12", lU = "_transactionHeaderSubLine_1kr8d_15", cU = "_transactionHeaderAlignItemRight_1kr8d_19", Ii = {
  transaction: aU,
  transactionIsOpen: oU,
  transactionHeader: sU,
  transactionHeaderSubLine: lU,
  transactionHeaderAlignItemRight: cU
}, dU = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, N = m?.length ? m : [];
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Ii.transaction, {
        [Ii.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ii.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ B.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: An(o).format(dt) }),
                  /* @__PURE__ */ B.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: Ii.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ B.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Ii.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-4", children: xm(v, h) }),
                      /* @__PURE__ */ B.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: Ii.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ B.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ B.jsx(Fm, {}),
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ B.jsx(
                  iU,
                  {
                    lineItems: N,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, uU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = p3({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ B.jsx(In, { error: r }) : /* @__PURE__ */ B.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
          s === 0 && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ B.jsx(
            dU,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, mU = "_message_unsvt_48", pU = "_messageIsOpen_unsvt_56", fU = "_messageHeader_unsvt_60", hU = "_messageText_unsvt_64", yU = "_buttonLink_unsvt_86", Ta = {
  message: mU,
  messageIsOpen: pU,
  messageHeader: fU,
  messageText: hU,
  buttonLink: yU
}, Pu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Au = (e, n) => n && e in Pu && n in Pu[e] ? Pu[e][n] : null, gU = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = kn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? Au("type", l) : null, N = d ? Au("source", d) : null, j = u ? Au("status", u) : null, w = l?.replace("Message", "");
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Ta.message, {
        [Ta.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ta.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ B.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
                    /* @__PURE__ */ B.jsx(ue, { name: v, size: 16 }),
                    " ",
                    w
                  ] }),
                  s && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: An(s).format(dt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ B.jsx(Fm, {}),
          /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            j && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: j }),
              " ",
              u
            ] }) }),
            N && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: N }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ B.jsx(Pn, { children: /* @__PURE__ */ B.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ B.jsx(ue, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", className: Ta.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ B.jsx(
            St,
            {
              slotEnd: /* @__PURE__ */ B.jsx(ue, { name: "external-link" }),
              variant: "tertiary",
              className: Ta.buttonLink,
              navigate: () => {
                w && a("voyado:message:external-link:opened", {
                  channel: w.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, vU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = u3({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ B.jsx(In, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ B.jsx(Un, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ B.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(B.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ B.jsx(
        gU,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Qs = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Bk = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = is(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = tt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ B.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(ue, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ B.jsx(Ge, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, kU = "_order_19t4p_1", bU = "_orderIsOpen_19t4p_9", _U = "_orderHeader_19t4p_12", xU = "_orderIconColor_19t4p_15", Cr = {
  order: kU,
  orderIsOpen: bU,
  orderHeader: _U,
  orderIconColor: xU
}, SU = "_delivery_1m9nb_1", NU = "_deliveryCode_1m9nb_4", Lu = {
  delivery: SU,
  deliveryCode: NU
}, jU = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = er();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: "eye",
        className: Cr.orderIconColor
      }
    ),
    /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ B.jsx(
        Ge,
        {
          content: /* @__PURE__ */ B.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            An(s).format(dt)
          ] }),
          children: /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ B.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ B.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Lu.delivery,
                    children: [
                      /* @__PURE__ */ B.jsx(ue, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ B.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ut(Lu.delivery, Lu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ B.jsx(Ge, { content: "Copy tracking code", children: /* @__PURE__ */ B.jsx(
      ue,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, wU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "file-text",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ B.jsx(Ke, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ B.jsx(Ke.Item, { className: nt.listItem, children: /* @__PURE__ */ B.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ B.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ B.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Qs({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, CU = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "tag",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ B.jsx(Ke, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ B.jsx(
      Ke.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ B.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ B.jsx(
          Ge,
          {
            content: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ B.jsx(b, { children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: Qs({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ B.jsx(
          Mi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, FU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ B.jsx(
        ue,
        {
          size: 14,
          name: "credit-card",
          className: Cr.orderIconColor
        }
      ),
      /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ B.jsx(Ke, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ B.jsx(
      Ke.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ B.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "5", children: An(i?.paidAt).format(dt) }),
                    /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Qs({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, IU = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: N
  } = e, j = 14;
  return /* @__PURE__ */ B.jsxs(
    b,
    {
      className: ut(Cr.order, {
        [Cr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ B.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Cr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ B.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ B.jsx(b, { alignItems: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: An(m).format(dt) }) }),
                /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ B.jsx(
                Yt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ B.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: j,
                name: "activity",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ B.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ B.jsx(Ge, { content: "Internal status", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ B.jsx(Ge, { content: "External status", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: s }) }) }),
                /* @__PURE__ */ B.jsx(Ge, { content: "Last updated at", children: /* @__PURE__ */ B.jsx(A.Paragraph, { as: "span", variant: "5", children: An(u).format(dt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: j,
                name: "chart-bar",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: Qs({
                value: N,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ B.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ B.jsx(
              ue,
              {
                size: j,
                name: "channels",
                className: Cr.orderIconColor
              }
            ),
            /* @__PURE__ */ B.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "info", children: /* @__PURE__ */ B.jsx(B.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ B.jsx(Bk, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ B.jsx(
            Bk,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ B.jsx(jU, { delivery: e.delivery }),
          /* @__PURE__ */ B.jsx(CU, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ B.jsx(wU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ B.jsx(
            FU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, EU = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || no({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ B.jsx(In, { error: e }) : /* @__PURE__ */ B.jsx(B.Fragment, { children: r }), TU = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), [r, i] = se([]), { track: a } = kn(), {
    loading: o,
    error: s,
    data: l
  } = n(a3, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return He(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ B.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ B.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ B.jsx(Un, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsx(EU, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ B.jsx(
      IU,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, $U = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = f3({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: N
  } = n;
  return s ? /* @__PURE__ */ B.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ B.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? no({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ B.jsx(In, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ B.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ B.jsx(cn, {}) }) : /* @__PURE__ */ B.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ B.jsx(eU, { contactId: i, settings: n }),
        h && /* @__PURE__ */ B.jsx(vU, { contactId: i }),
        v && /* @__PURE__ */ B.jsx(uU, { contactId: i }),
        N && /* @__PURE__ */ B.jsx(TU, { contactId: i }),
        !l && /* @__PURE__ */ B.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ B.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, DU = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vu = { exports: {} }, $a = {}, qk;
function RU() {
  if (qk) return $a;
  qk = 1;
  var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return $a.Fragment = r, $a.jsx = s, $a.jsxs = s, $a;
}
var Bo = {}, Hk;
function OU() {
  return Hk || (Hk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Se, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), N = Symbol.iterator, j = "@@iterator";
    function w(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = N && t[N] || t[j];
      return typeof c == "function" ? c : null;
    }
    var F = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        H("error", t, p);
      }
    }
    function H(t, c, p) {
      {
        var g = F.ReactDebugCurrentFrame, P = g.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var T = !1, E = !1, $ = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Z || t === a || t === m || t === u || U || t === v || T || E || $ || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Q || t.getModuleId !== void 0));
    }
    function J(t, c, p) {
      var g = t.displayName;
      if (g)
        return g;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function M(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return M(c) + ".Consumer";
          case s:
            var p = t;
            return M(p._context) + ".Provider";
          case d:
            return J(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : R(t.type) || "Memo";
          case h: {
            var P = t, L = P._payload, I = P._init;
            try {
              return R(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ge, de, le, pe, W, ke, Ce;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ge = console.log, de = console.info, le = console.warn, pe = console.error, W = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ge
            }),
            info: q({}, t, {
              value: de
            }),
            warn: q({}, t, {
              value: le
            }),
            error: q({}, t, {
              value: pe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: ke
            }),
            groupEnd: q({}, t, {
              value: Ce
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = F.ReactCurrentDispatcher, Ue;
    function je(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (P) {
            var g = P.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Le = !1, Te;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new an();
    }
    function we(t, c) {
      if (!t || Le)
        return "";
      {
        var p = Te.get(t);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, qe();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              g = ne;
            }
            Reflect.construct(t, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              g = ne;
            }
            t.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            g = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && g && typeof ne.stack == "string") {
          for (var S = ne.stack.split(`
`), te = g.stack.split(`
`), x = S.length - 1, V = te.length - 1; x >= 1 && V >= 0 && S[x] !== te[V]; )
            V--;
          for (; x >= 1 && V >= 0; x--, V--)
            if (S[x] !== te[V]) {
              if (x !== 1 || V !== 1)
                do
                  if (x--, V--, V < 0 || S[x] !== te[V]) {
                    var X = `
` + S[x].replace(" at new ", " at ");
                    return t.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", t.displayName)), typeof t == "function" && Te.set(t, X), X;
                  }
                while (x >= 1 && V >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Be(), Error.prepareStackTrace = P;
      }
      var Ne = t ? t.displayName || t.name : "", xe = Ne ? je(Ne) : "";
      return typeof t == "function" && Te.set(t, xe), xe;
    }
    function We(t, c, p) {
      return we(t, !1);
    }
    function Xe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function me(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return we(t, Xe(t));
      if (typeof t == "string")
        return je(t);
      switch (t) {
        case m:
          return je("Suspense");
        case u:
          return je("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return We(t.render);
          case f:
            return me(t.type, c, p);
          case h: {
            var g = t, P = g._payload, L = g._init;
            try {
              return me(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var he = Object.prototype.hasOwnProperty, Ie = {}, Ae = F.ReactDebugCurrentFrame;
    function Re(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function ze(t, c, p, g, P) {
      {
        var L = Function.call.bind(he);
        for (var I in t)
          if (L(t, I)) {
            var S = void 0;
            try {
              if (typeof t[I] != "function") {
                var te = Error((g || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              S = t[I](c, I, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              S = x;
            }
            S && !(S instanceof Error) && (Re(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, I, typeof S), Re(null)), S instanceof Error && !(S.message in Ie) && (Ie[S.message] = !0, Re(P), y("Failed %s type: %s", p, S.message), Re(null));
          }
      }
    }
    var C = Array.isArray;
    function _(t) {
      return C(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function G(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function O(t) {
      if (G(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var z = F.ReactCurrentOwner, re = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, be;
    function en(t) {
      if (he.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pn(t) {
      if (he.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && z.current;
    }
    function dn(t, c) {
      {
        var p = function() {
          fe || (fe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function mn(t, c) {
      {
        var p = function() {
          be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var ln = function(t, c, p, g, P, L, I) {
      var S = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function vn(t, c, p, g, P) {
      {
        var L, I = {}, S = null, te = null;
        p !== void 0 && (O(p), S = "" + p), pn(c) && (O(c.key), S = "" + c.key), en(c) && (te = c.ref, rn(c));
        for (L in c)
          he.call(c, L) && !re.hasOwnProperty(L) && (I[L] = c[L]);
        if (t && t.defaultProps) {
          var x = t.defaultProps;
          for (L in x)
            I[L] === void 0 && (I[L] = x[L]);
        }
        if (S || te) {
          var V = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          S && dn(I, V), te && mn(I, V);
        }
        return ln(t, S, te, P, g, z.current, I);
      }
    }
    var Ze = F.ReactCurrentOwner, xn = F.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = me(t.type, t._source, c ? c.type : null);
        xn.setExtraStackFrame(p);
      } else
        xn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function hn() {
      {
        if (Ze.current) {
          var t = R(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Hn(t) {
      return "";
    }
    var Sn = {};
    function yn(t) {
      {
        var c = hn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function fn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = yn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var g = "";
        t && t._owner && t._owner !== Ze.current && (g = " It was passed a child from " + R(t._owner.type) + "."), Oe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), Oe(null);
      }
    }
    function Nn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (_(t))
          for (var p = 0; p < t.length; p++) {
            var g = t[p];
            sn(g) && fn(g, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = w(t);
          if (typeof P == "function" && P !== t.entries)
            for (var L = P.call(t), I; !(I = L.next()).done; )
              sn(I.value) && fn(I.value, c);
        }
      }
    }
    function Mn(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = R(c);
          ze(p, t.props, "prop", g, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var P = R(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            Oe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var bn = {};
    function _n(t, c, p, g, P, L) {
      {
        var I = ie(t);
        if (!I) {
          var S = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = Hn();
          te ? S += te : S += hn();
          var x;
          t === null ? x = "null" : _(t) ? x = "array" : t !== void 0 && t.$$typeof === n ? (x = "<" + (R(t.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : x = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, S);
        }
        var V = vn(t, c, p, P, L);
        if (V == null)
          return V;
        if (I) {
          var X = c.children;
          if (X !== void 0)
            if (g)
              if (_(X)) {
                for (var Ne = 0; Ne < X.length; Ne++)
                  Nn(X[Ne], t);
                Object.freeze && Object.freeze(X);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nn(X, t);
        }
        if (he.call(c, "key")) {
          var xe = R(t), ne = Object.keys(c).filter(function(jn) {
            return jn !== "key";
          }), nn = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[xe + nn]) {
            var En = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nn, xe, En, xe), bn[xe + nn] = !0;
          }
        }
        return t === i ? Vn(V) : Mn(V), V;
      }
    }
    function Wn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Bn = Wn;
    Bo.Fragment = i, Bo.jsx = Rn, Bo.jsxs = Bn;
  })()), Bo;
}
var Wk;
function PU() {
  return Wk || (Wk = 1, process.env.NODE_ENV === "production" ? Vu.exports = RU() : Vu.exports = OU()), Vu.exports;
}
var ce = PU();
const AU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, LU = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": AU
};
function VU(e) {
  return LU[e] ?? {};
}
const zU = VU(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), UU = "_copyIcon_nr4rl_48", MU = "_list_nr4rl_53", BU = "_listItem_nr4rl_63", Dr = {
  copyIcon: UU,
  list: MU,
  listItem: BU
}, $n = ({
  description: e,
  content: n,
  tooltip: r
}) => {
  if (n == null)
    return null;
  const i = MS(n);
  return /* @__PURE__ */ ce.jsx(Ke.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsx(Ge, { content: r, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : fb(n)
  ] }) }) });
}, Kk = ({
  channel: e
}) => {
  const n = (a) => Es(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: r } = e, i = "suppressions" in r && !!r.suppressions;
  return /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsx(Ke.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(r?.timestamp).format(dt) }),
        r?.consent && /* @__PURE__ */ ce.jsx(Un, { variant: "primary", size: "small", children: n(r?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ ce.jsx(Ke.Text, { variant: "dense", className: Dr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        r.suppressions?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: An(r.suppressions?.timestamp).format(
          dt
        ) }),
        r.suppressions?.suppression_reason && /* @__PURE__ */ ce.jsx(Un, { variant: "warning", size: "small", children: r.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, qU = "_channelHeadline_yeqqp_1", Gk = {
  channelHeadline: qU
}, HU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: r, yotpo_sms: i } = e;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Gk.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "mail" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ ce.jsxs(Ke, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Kk, { channel: n?.email }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: r?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: r?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: r?.last_delivered
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: r?.last_opened
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: r?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: r?.last_converted
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: r?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: Gk.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(ue, { name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ ce.jsxs(Ke, { className: Dr.list, children: [
        /* @__PURE__ */ ce.jsx(Kk, { channel: n?.sms }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, WU = "_wrapper_1xucg_1", KU = "_externalLink_1xucg_7", zu = {
  wrapper: WU,
  externalLink: KU
}, GU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = er(), { isCopied: i, copy: a } = er(), { isCopied: o, copy: s } = er();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: d,
    address: m,
    email: u,
    phone_number: f,
    account_created_at: h,
    account_status: v,
    accepts_sms_marketing: N,
    accepts_email_marketing: j
  } = e, w = 14, F = `${l || ""} ${d || ""}`.trim() || "A customer has no name", {
    address1: y,
    address2: H,
    city: T,
    company: E,
    state: $,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ie = [
    y,
    H,
    [U, T].filter(Boolean).join(", "),
    [Q, $, Z].filter(Boolean).join(", "),
    E
  ].filter(Boolean);
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: zu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: zu.block,
        alignItems: "center",
        children: /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-2", children: F })
      }
    ),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: An(h).format(dt) })
    ] }),
    u && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: zu.externalLink, children: u })
      ] }),
      /* @__PURE__ */ ce.jsx(Ge, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: w,
          name: n ? "done" : "copy",
          onClick: () => r(u),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "phone" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ ce.jsx(Ge, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: w,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    (y || T || E || $ || U || Q) && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "home" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ie.map((J) => /* @__PURE__ */ ce.jsx(Qn, { children: J }, J)) })
      ] }),
      /* @__PURE__ */ ce.jsx(Ge, { content: "Copy address", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        ue,
        {
          size: w,
          name: o ? "done" : "copy",
          onClick: () => s(ie.join(", ")),
          className: Dr.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: N ? "check-circle-filled" : "close-circle-filled",
          color: N ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "paper-plane" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        ue,
        {
          name: j ? "check-circle-filled" : "close-circle-filled",
          color: j ? "green.500" : "red.500"
        }
      )
    ] }),
    v && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(ue, { size: w, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ ce.jsx(Pn, { children: Es(v) })
    ] })
  ] }) });
}, YU = ({
  loyalty: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ ce.jsxs(Ke, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), JU = ({ tags: e }) => {
  const n = e?.split(","), r = n && n.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !r && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    r && /* @__PURE__ */ ce.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ ce.jsx(Pn, { children: i }, a)) })
  ] });
}, QU = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ ce.jsxs(Ke, { className: Dr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: An(e.last_review_date).format(
          dt
        )
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ ce.jsx(Un, { variant: "info", size: "small", children: /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), XU = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), { track: i } = kn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showTags ?? !1, N = n?.showChannels ?? !1, j = n?.showUserGeneratedContent ?? !1, w = n?.displayLoyalty ?? !1, F = n?.displayEmailData ?? !1, y = n?.displaySmsData ?? !1, H = n?.displaySubscriptions ?? !1, T = !h && !v && !N && !j && !w && !F && !y && !H, {
    loading: E,
    error: $,
    data: U
  } = r(zU, {
    skip: !d || !f,
    variables: {
      ...d && { email: d },
      // eslint-disable-next-line camelcase
      ...!d && m && { phone_number: m },
      storeId: f,
      expand: "all"
    }
  });
  if (He(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, E]), u)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (s)
    return /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (T)
    return /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if ($) {
    const Z = $.graphQLErrors;
    return Nm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : jm({ errors: Z }) ? /* @__PURE__ */ ce.jsx(
      A.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ce.jsx(In, { error: $ });
  }
  return E ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(cn, {}) }) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(GU, { customerDetails: a }),
        v && /* @__PURE__ */ ce.jsx(JU, { tags: a?.tags }),
        N && /* @__PURE__ */ ce.jsx(HU, { customerDetails: a }),
        j && /* @__PURE__ */ ce.jsx(
          QU,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        w && /* @__PURE__ */ ce.jsx(YU, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var fo = (e) => e.type === "checkbox", di = (e) => e instanceof Date, At = (e) => e == null;
const cS = (e) => typeof e == "object";
var ct = (e) => !At(e) && !Array.isArray(e) && cS(e) && !di(e), dS = (e) => ct(e) && e.target ? fo(e.target) ? e.target.checked : e.target.value : e, ZU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, uS = (e, n) => e.has(ZU(n)), eM = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ct(n) && n.hasOwnProperty("isPrototypeOf");
}, Ap = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ap && (e instanceof Blob || i)) && (r || ct(e)))
    if (n = r ? [] : {}, !r && !eM(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = xt(e[a]));
  else
    return e;
  return n;
}
var Xs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], at = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !ct(e))
    return r;
  const i = Xs(n.split(/[,[\].]+?/)).reduce((a, o) => At(a) ? a : a[o], e);
  return at(i) || i === e ? at(e[n]) ? r : e[n] : i;
}, Zt = (e) => typeof e == "boolean", Lp = (e) => /^\w*$/.test(e), mS = (e) => Xs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Jn = (e, n, r) => {
  let i = -1;
  const a = Lp(n) ? [n] : mS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ct(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ws = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, gr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, nM = Se.createContext(null), Vp = () => Se.useContext(nM);
var pS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== gr.all && (n._proxyFormState[s] = !i || gr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function tM(e) {
  const n = Vp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(r._formState), d = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Se.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Se.useMemo(() => pS(s, r, d.current, !1), [s, r]);
}
var $r = (e) => typeof e == "string", fS = (e, n, r, i, a) => $r(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function hS(e) {
  const n = Vp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), d = Se.useRef(a);
  l.current = i, Se.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(fS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Se.useState(r._getWatch(i, a));
  return Se.useEffect(() => r._removeUnmounted()), m;
}
function rM(e) {
  const n = Vp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = uS(a._names.array, r), l = hS({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = tM({
    control: a,
    name: r,
    exact: !0
  }), m = Se.useRef(e), u = Se.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Zt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = Se.useCallback((w) => u.current.onChange({
    target: {
      value: dS(w),
      name: r
    },
    type: ws.CHANGE
  }), [r]), v = Se.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: ws.BLUR
  }), [r, a._formValues]), N = Se.useCallback((w) => {
    const F = Qe(a._fields, r);
    F && w && (F._f.ref = {
      focus: () => w.focus(),
      select: () => w.select(),
      setCustomValidity: (y) => w.setCustomValidity(y),
      reportValidity: () => w.reportValidity()
    });
  }, [a._fields, r]), j = Se.useMemo(() => ({
    name: r,
    value: l,
    ...Zt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: N
  }), [r, i, d.disabled, h, v, N, l]);
  return Se.useEffect(() => {
    const w = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Zt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const F = (y, H) => {
      const T = Qe(a._fields, y);
      T && T._f && (T._f.mount = H);
    };
    if (F(r, !0), w) {
      const y = xt(Qe(a._options.defaultValues, r));
      Jn(a._defaultValues, r, y), at(Qe(a._formValues, r)) && Jn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? w && !a._state.action : w) ? a.unregister(r) : F(r, !1);
    };
  }, [r, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Se.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
const Yk = (e) => e.render(rM(e));
var iM = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Ka = (e) => Array.isArray(e) ? e : [e], Jk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Sm = (e) => At(e) || !cS(e);
function Xr(e, n) {
  if (Sm(e) || Sm(n))
    return e === n;
  if (di(e) && di(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (di(o) && di(s) || ct(o) && ct(s) || Array.isArray(o) && Array.isArray(s) ? !Xr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Rt = (e) => ct(e) && !Object.keys(e).length, zp = (e) => e.type === "file", vr = (e) => typeof e == "function", Cs = (e) => {
  if (!Ap)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, yS = (e) => e.type === "select-multiple", Up = (e) => e.type === "radio", aM = (e) => Up(e) || fo(e), Uu = (e) => Cs(e) && e.isConnected;
function oM(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = at(e) ? i++ : e[n[i++]];
  return e;
}
function sM(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !at(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : Lp(n) ? [n] : mS(n), i = r.length === 1 ? e : oM(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ct(i) && Rt(i) || Array.isArray(i) && sM(i)) && yt(e, r.slice(0, -1)), e;
}
var gS = (e) => {
  for (const n in e)
    if (vr(e[n]))
      return !0;
  return !1;
};
function Fs(e, n = {}) {
  const r = Array.isArray(e);
  if (ct(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ct(e[i]) && !gS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Fs(e[i], n[i])) : At(e[i]) || (n[i] = !0);
  return n;
}
function vS(e, n, r) {
  const i = Array.isArray(e);
  if (ct(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ct(e[a]) && !gS(e[a]) ? at(n) || Sm(r[a]) ? r[a] = Array.isArray(e[a]) ? Fs(e[a], []) : { ...Fs(e[a]) } : vS(e[a], At(n) ? {} : n[a], r[a]) : r[a] = !Xr(e[a], n[a]);
  return r;
}
var Da = (e, n) => vS(e, n, Fs(n));
const Qk = {
  value: !1,
  isValid: !1
}, Xk = { value: !0, isValid: !0 };
var kS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? Xk : { value: e[0].value, isValid: !0 } : Xk
    ) : Qk;
  }
  return Qk;
}, bS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => at(e) ? e : n ? e === "" ? NaN : e && +e : r && $r(e) ? new Date(e) : i ? i(e) : e;
const Zk = {
  isValid: !1,
  value: null
};
var _S = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Zk) : Zk;
function eb(e) {
  const n = e.ref;
  return zp(n) ? n.files : Up(n) ? _S(e.refs).value : yS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : fo(n) ? kS(e.refs).value : bS(at(n.value) ? e.ref.value : n.value, e);
}
var lM = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Jn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Is = (e) => e instanceof RegExp, Ra = (e) => at(e) ? e : Is(e) ? e.source : ct(e) ? Is(e.value) ? e.value.source : e.value : e, nb = (e) => ({
  isOnSubmit: !e || e === gr.onSubmit,
  isOnBlur: e === gr.onBlur,
  isOnChange: e === gr.onChange,
  isOnAll: e === gr.all,
  isOnTouch: e === gr.onTouched
});
const tb = "AsyncFunction";
var cM = (e) => !!e && !!e.validate && !!(vr(e.validate) && e.validate.constructor.name === tb || ct(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === tb)), dM = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), rb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ga = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ga(l, n))
          break;
      } else if (ct(l) && Ga(l, n))
        break;
    }
  }
};
function ib(e, n, r) {
  const i = Qe(e, r);
  if (i || Lp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var uM = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Rt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || gr.all));
}, mM = (e, n, r) => !e || !n || e === n || Ka(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), pM = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, fM = (e, n) => !Xs(Qe(e, n)).length && yt(e, n), hM = (e, n, r) => {
  const i = Ka(Qe(e, r));
  return Jn(i, "root", n[r]), Jn(e, r, i), e;
}, os = (e) => $r(e);
function ab(e, n, r = "validate") {
  if (os(e) || Array.isArray(e) && e.every(os) || Zt(e) && !e)
    return {
      type: r,
      message: os(e) ? e : "",
      ref: n
    };
}
var Ei = (e) => ct(e) && !Is(e) ? e : {
  value: e,
  message: ""
}, ob = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: N, name: j, valueAsNumber: w, mount: F } = e._f, y = Qe(r, j);
  if (!F || n.has(j))
    return {};
  const H = l ? l[0] : s, T = (M) => {
    a && H.reportValidity && (H.setCustomValidity(Zt(M) ? "" : M || ""), H.reportValidity());
  }, E = {}, $ = Up(s), U = fo(s), Z = $ || U, Q = (w || zp(s)) && at(s.value) && at(y) || Cs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ie = iM.bind(null, j, i, E), J = (M, R, q, ee = Mr.maxLength, ge = Mr.minLength) => {
    const de = M ? R : q;
    E[j] = {
      type: M ? ee : ge,
      message: de,
      ref: s,
      ...ie(M ? ee : ge, de)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Z && (Q || At(y)) || Zt(y) && !y || U && !kS(l).isValid || $ && !_S(l).isValid)) {
    const { value: M, message: R } = os(d) ? { value: !!d, message: d } : Ei(d);
    if (M && (E[j] = {
      type: Mr.required,
      message: R,
      ref: H,
      ...ie(Mr.required, R)
    }, !i))
      return T(R), E;
  }
  if (!Q && (!At(f) || !At(h))) {
    let M, R;
    const q = Ei(h), ee = Ei(f);
    if (!At(y) && !isNaN(y)) {
      const ge = s.valueAsNumber || y && +y;
      At(q.value) || (M = ge > q.value), At(ee.value) || (R = ge < ee.value);
    } else {
      const ge = s.valueAsDate || new Date(y), de = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), le = s.type == "time", pe = s.type == "week";
      $r(q.value) && y && (M = le ? de(y) > de(q.value) : pe ? y > q.value : ge > new Date(q.value)), $r(ee.value) && y && (R = le ? de(y) < de(ee.value) : pe ? y < ee.value : ge < new Date(ee.value));
    }
    if ((M || R) && (J(!!M, q.message, ee.message, Mr.max, Mr.min), !i))
      return T(E[j].message), E;
  }
  if ((m || u) && !Q && ($r(y) || o && Array.isArray(y))) {
    const M = Ei(m), R = Ei(u), q = !At(M.value) && y.length > +M.value, ee = !At(R.value) && y.length < +R.value;
    if ((q || ee) && (J(q, M.message, R.message), !i))
      return T(E[j].message), E;
  }
  if (v && !Q && $r(y)) {
    const { value: M, message: R } = Ei(v);
    if (Is(M) && !y.match(M) && (E[j] = {
      type: Mr.pattern,
      message: R,
      ref: s,
      ...ie(Mr.pattern, R)
    }, !i))
      return T(R), E;
  }
  if (N) {
    if (vr(N)) {
      const M = await N(y, r), R = ab(M, H);
      if (R && (E[j] = {
        ...R,
        ...ie(Mr.validate, R.message)
      }, !i))
        return T(R.message), E;
    } else if (ct(N)) {
      let M = {};
      for (const R in N) {
        if (!Rt(M) && !i)
          break;
        const q = ab(await N[R](y, r), H, R);
        q && (M = {
          ...q,
          ...ie(R, q.message)
        }, T(q.message), i && (E[j] = M));
      }
      if (!Rt(M) && (E[j] = {
        ref: H,
        ...M
      }, !i))
        return E;
    }
  }
  return T(!0), E;
};
const yM = {
  mode: gr.onSubmit,
  reValidateMode: gr.onChange,
  shouldFocusError: !0
};
function gM(e = {}) {
  let n = {
    ...yM,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: vr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ct(n.defaultValues) || ct(n.values) ? xt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : xt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Jk(),
    state: Jk()
  }, v = nb(n.mode), N = nb(n.reValidateMode), j = n.criteriaMode === gr.all, w = (C) => (_) => {
    clearTimeout(m), m = setTimeout(C, _);
  }, F = async (C) => {
    if (!n.disabled && (u.isValid || f.isValid || C)) {
      const _ = n.resolver ? Rt((await Q()).errors) : await J(i, !0);
      _ !== r.isValid && h.state.next({
        isValid: _
      });
    }
  }, y = (C, _) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((C || Array.from(l.mount)).forEach((D) => {
      D && (_ ? Jn(r.validatingFields, D, _) : yt(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Rt(r.validatingFields)
    }));
  }, H = (C, _ = [], D, G, Y = !0, O = !0) => {
    if (G && D && !n.disabled) {
      if (s.action = !0, O && Array.isArray(Qe(i, C))) {
        const z = D(Qe(i, C), G.argA, G.argB);
        Y && Jn(i, C, z);
      }
      if (O && Array.isArray(Qe(r.errors, C))) {
        const z = D(Qe(r.errors, C), G.argA, G.argB);
        Y && Jn(r.errors, C, z), fM(r.errors, C);
      }
      if ((u.touchedFields || f.touchedFields) && O && Array.isArray(Qe(r.touchedFields, C))) {
        const z = D(Qe(r.touchedFields, C), G.argA, G.argB);
        Y && Jn(r.touchedFields, C, z);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Da(a, o)), h.state.next({
        name: C,
        isDirty: R(C, _),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Jn(o, C, _);
  }, T = (C, _) => {
    Jn(r.errors, C, _), h.state.next({
      errors: r.errors
    });
  }, E = (C) => {
    r.errors = C, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (C, _, D, G) => {
    const Y = Qe(i, C);
    if (Y) {
      const O = Qe(o, C, at(D) ? Qe(a, C) : D);
      at(O) || G && G.defaultChecked || _ ? Jn(o, C, _ ? O : eb(Y._f)) : ge(C, O), s.mount && F();
    }
  }, U = (C, _, D, G, Y) => {
    let O = !1, z = !1;
    const re = {
      name: C
    };
    if (!n.disabled) {
      if (!D || G) {
        (u.isDirty || f.isDirty) && (z = r.isDirty, r.isDirty = re.isDirty = R(), O = z !== re.isDirty);
        const fe = Xr(Qe(a, C), _);
        z = !!Qe(r.dirtyFields, C), fe ? yt(r.dirtyFields, C) : Jn(r.dirtyFields, C, !0), re.dirtyFields = r.dirtyFields, O = O || (u.dirtyFields || f.dirtyFields) && z !== !fe;
      }
      if (D) {
        const fe = Qe(r.touchedFields, C);
        fe || (Jn(r.touchedFields, C, D), re.touchedFields = r.touchedFields, O = O || (u.touchedFields || f.touchedFields) && fe !== D);
      }
      O && Y && h.state.next(re);
    }
    return O ? re : {};
  }, Z = (C, _, D, G) => {
    const Y = Qe(r.errors, C), O = (u.isValid || f.isValid) && Zt(_) && r.isValid !== _;
    if (n.delayError && D ? (d = w(() => T(C, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Jn(r.errors, C, D) : yt(r.errors, C)), (D ? !Xr(Y, D) : Y) || !Rt(G) || O) {
      const z = {
        ...G,
        ...O && Zt(_) ? { isValid: _ } : {},
        errors: r.errors,
        name: C
      };
      r = {
        ...r,
        ...z
      }, h.state.next(z);
    }
  }, Q = async (C) => {
    y(C, !0);
    const _ = await n.resolver(o, n.context, lM(C || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(C), _;
  }, ie = async (C) => {
    const { errors: _ } = await Q(C);
    if (C)
      for (const D of C) {
        const G = Qe(_, D);
        G ? Jn(r.errors, D, G) : yt(r.errors, D);
      }
    else
      r.errors = _;
    return _;
  }, J = async (C, _, D = {
    valid: !0
  }) => {
    for (const G in C) {
      const Y = C[G];
      if (Y) {
        const { _f: O, ...z } = Y;
        if (O) {
          const re = l.array.has(O.name), fe = Y._f && cM(Y._f);
          fe && u.validatingFields && y([G], !0);
          const be = await ob(Y, l.disabled, o, j, n.shouldUseNativeValidation && !_, re);
          if (fe && u.validatingFields && y([G]), be[O.name] && (D.valid = !1, _))
            break;
          !_ && (Qe(be, O.name) ? re ? hM(r.errors, be, O.name) : Jn(r.errors, O.name, be[O.name]) : yt(r.errors, O.name));
        }
        !Rt(z) && await J(z, _, D);
      }
    }
    return D.valid;
  }, M = () => {
    for (const C of l.unMount) {
      const _ = Qe(i, C);
      _ && (_._f.refs ? _._f.refs.every((D) => !Uu(D)) : !Uu(_._f.ref)) && Le(C);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (C, _) => !n.disabled && (C && _ && Jn(o, C, _), !Xr(Ce(), a)), q = (C, _, D) => fS(C, l, {
    ...s.mount ? o : at(_) ? a : $r(C) ? { [C]: _ } : _
  }, D, _), ee = (C) => Xs(Qe(s.mount ? o : a, C, n.shouldUnregister ? Qe(a, C, []) : [])), ge = (C, _, D = {}) => {
    const G = Qe(i, C);
    let Y = _;
    if (G) {
      const O = G._f;
      O && (!O.disabled && Jn(o, C, bS(_, O)), Y = Cs(O.ref) && At(_) ? "" : _, yS(O.ref) ? [...O.ref.options].forEach((z) => z.selected = Y.includes(z.value)) : O.refs ? fo(O.ref) ? O.refs.length > 1 ? O.refs.forEach((z) => (!z.defaultChecked || !z.disabled) && (z.checked = Array.isArray(Y) ? !!Y.find((re) => re === z.value) : Y === z.value)) : O.refs[0] && (O.refs[0].checked = !!Y) : O.refs.forEach((z) => z.checked = z.value === Y) : zp(O.ref) ? O.ref.value = "" : (O.ref.value = Y, O.ref.type || h.state.next({
        name: C,
        values: xt(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(C, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && ke(C);
  }, de = (C, _, D) => {
    for (const G in _) {
      const Y = _[G], O = `${C}.${G}`, z = Qe(i, O);
      (l.array.has(C) || ct(Y) || z && !z._f) && !di(Y) ? de(O, Y, D) : ge(O, Y, D);
    }
  }, le = (C, _, D = {}) => {
    const G = Qe(i, C), Y = l.array.has(C), O = xt(_);
    Jn(o, C, O), Y ? (h.array.next({
      name: C,
      values: xt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: C,
      dirtyFields: Da(a, o),
      isDirty: R(C, O)
    })) : G && !G._f && !At(O) ? de(C, O, D) : ge(C, O, D), rb(C, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? C : void 0,
      values: xt(o)
    });
  }, pe = async (C) => {
    s.mount = !0;
    const _ = C.target;
    let D = _.name, G = !0;
    const Y = Qe(i, D), O = (z) => {
      G = Number.isNaN(z) || di(z) && isNaN(z.getTime()) || Xr(z, Qe(o, D, z));
    };
    if (Y) {
      let z, re;
      const fe = _.type ? eb(Y._f) : dS(C), be = C.type === ws.BLUR || C.type === ws.FOCUS_OUT, en = !dM(Y._f) && !n.resolver && !Qe(r.errors, D) && !Y._f.deps || pM(be, Qe(r.touchedFields, D), r.isSubmitted, N, v), pn = rb(D, l, be);
      Jn(o, D, fe), be ? (Y._f.onBlur && Y._f.onBlur(C), d && d(0)) : Y._f.onChange && Y._f.onChange(C);
      const rn = U(D, fe, be), dn = !Rt(rn) || pn;
      if (!be && h.state.next({
        name: D,
        type: C.type,
        values: xt(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? be && F() : be || F()), dn && h.state.next({ name: D, ...pn ? {} : rn });
      if (!be && pn && h.state.next({ ...r }), n.resolver) {
        const { errors: mn } = await Q([D]);
        if (O(fe), G) {
          const ln = ib(r.errors, i, D), vn = ib(mn, i, ln.name || D);
          z = vn.error, D = vn.name, re = Rt(mn);
        }
      } else
        y([D], !0), z = (await ob(Y, l.disabled, o, j, n.shouldUseNativeValidation))[D], y([D]), O(fe), G && (z ? re = !1 : (u.isValid || f.isValid) && (re = await J(i, !0)));
      G && (Y._f.deps && ke(Y._f.deps), Z(D, re, z, rn));
    }
  }, W = (C, _) => {
    if (Qe(r.errors, _) && C.focus)
      return C.focus(), 1;
  }, ke = async (C, _ = {}) => {
    let D, G;
    const Y = Ka(C);
    if (n.resolver) {
      const O = await ie(at(C) ? C : Y);
      D = Rt(O), G = C ? !Y.some((z) => Qe(O, z)) : D;
    } else C ? (G = (await Promise.all(Y.map(async (O) => {
      const z = Qe(i, O);
      return await J(z && z._f ? { [O]: z } : z);
    }))).every(Boolean), !(!G && !r.isValid) && F()) : G = D = await J(i);
    return h.state.next({
      ...!$r(C) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: C },
      ...n.resolver || !C ? { isValid: D } : {},
      errors: r.errors
    }), _.shouldFocus && !G && Ga(i, W, C ? Y : l.mount), G;
  }, Ce = (C) => {
    const _ = {
      ...s.mount ? o : a
    };
    return at(C) ? _ : $r(C) ? Qe(_, C) : C.map((D) => Qe(_, D));
  }, K = (C, _) => ({
    invalid: !!Qe((_ || r).errors, C),
    isDirty: !!Qe((_ || r).dirtyFields, C),
    error: Qe((_ || r).errors, C),
    isValidating: !!Qe(r.validatingFields, C),
    isTouched: !!Qe((_ || r).touchedFields, C)
  }), qe = (C) => {
    C && Ka(C).forEach((_) => yt(r.errors, _)), h.state.next({
      errors: C ? r.errors : {}
    });
  }, Be = (C, _, D) => {
    const G = (Qe(i, C, { _f: {} })._f || {}).ref, Y = Qe(r.errors, C) || {}, { ref: O, message: z, type: re, ...fe } = Y;
    Jn(r.errors, C, {
      ...fe,
      ..._,
      ref: G
    }), h.state.next({
      name: C,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && G && G.focus && G.focus();
  }, Pe = (C, _) => vr(C) ? h.state.subscribe({
    next: (D) => C(q(void 0, _), D)
  }) : q(C, _, !0), Ue = (C) => h.state.subscribe({
    next: (_) => {
      mM(C.name, _.name, C.exact) && uM(_, C.formState || u, Re, C.reRenderRoot) && C.callback({
        values: { ...o },
        ...r,
        ..._
      });
    }
  }).unsubscribe, je = (C) => (s.mount = !0, f = {
    ...f,
    ...C.formState
  }, Ue({
    ...C,
    formState: f
  })), Le = (C, _ = {}) => {
    for (const D of C ? Ka(C) : l.mount)
      l.mount.delete(D), l.array.delete(D), _.keepValue || (yt(i, D), yt(o, D)), !_.keepError && yt(r.errors, D), !_.keepDirty && yt(r.dirtyFields, D), !_.keepTouched && yt(r.touchedFields, D), !_.keepIsValidating && yt(r.validatingFields, D), !n.shouldUnregister && !_.keepDefaultValue && yt(a, D);
    h.state.next({
      values: xt(o)
    }), h.state.next({
      ...r,
      ..._.keepDirty ? { isDirty: R() } : {}
    }), !_.keepIsValid && F();
  }, Te = ({ disabled: C, name: _ }) => {
    (Zt(C) && s.mount || C || l.disabled.has(_)) && (C ? l.disabled.add(_) : l.disabled.delete(_));
  }, an = (C, _ = {}) => {
    let D = Qe(i, C);
    const G = Zt(_.disabled) || Zt(n.disabled);
    return Jn(i, C, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: C } },
        name: C,
        mount: !0,
        ..._
      }
    }), l.mount.add(C), D ? Te({
      disabled: Zt(_.disabled) ? _.disabled : n.disabled,
      name: C
    }) : $(C, !0, _.value), {
      ...G ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Ra(_.min),
        max: Ra(_.max),
        minLength: Ra(_.minLength),
        maxLength: Ra(_.maxLength),
        pattern: Ra(_.pattern)
      } : {},
      name: C,
      onChange: pe,
      onBlur: pe,
      ref: (Y) => {
        if (Y) {
          an(C, _), D = Qe(i, C);
          const O = at(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, z = aM(O), re = D._f.refs || [];
          if (z ? re.find((fe) => fe === O) : O === D._f.ref)
            return;
          Jn(i, C, {
            _f: {
              ...D._f,
              ...z ? {
                refs: [
                  ...re.filter(Uu),
                  O,
                  ...Array.isArray(Qe(a, C)) ? [{}] : []
                ],
                ref: { type: O.type, name: C }
              } : { ref: O }
            }
          }), $(C, !1, void 0, O);
        } else
          D = Qe(i, C, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(uS(l.array, C) && s.action) && l.unMount.add(C);
      }
    };
  }, we = () => n.shouldFocusError && Ga(i, W, l.mount), We = (C) => {
    Zt(C) && (h.state.next({ disabled: C }), Ga(i, (_, D) => {
      const G = Qe(i, D);
      G && (_.disabled = G._f.disabled || C, Array.isArray(G._f.refs) && G._f.refs.forEach((Y) => {
        Y.disabled = G._f.disabled || C;
      }));
    }, 0, !1));
  }, Xe = (C, _) => async (D) => {
    let G;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = xt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: O, values: z } = await Q();
      r.errors = O, Y = z;
    } else
      await J(i);
    if (l.disabled.size)
      for (const O of l.disabled)
        Jn(Y, O, void 0);
    if (yt(r.errors, "root"), Rt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await C(Y, D);
      } catch (O) {
        G = O;
      }
    } else
      _ && await _({ ...r.errors }, D), we(), setTimeout(we);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Rt(r.errors) && !G,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), G)
      throw G;
  }, me = (C, _ = {}) => {
    Qe(i, C) && (at(_.defaultValue) ? le(C, xt(Qe(a, C))) : (le(C, _.defaultValue), Jn(a, C, xt(_.defaultValue))), _.keepTouched || yt(r.touchedFields, C), _.keepDirty || (yt(r.dirtyFields, C), r.isDirty = _.defaultValue ? R(C, xt(Qe(a, C))) : R()), _.keepError || (yt(r.errors, C), u.isValid && F()), h.state.next({ ...r }));
  }, he = (C, _ = {}) => {
    const D = C ? xt(C) : a, G = xt(D), Y = Rt(C), O = Y ? a : G;
    if (_.keepDefaultValues || (a = D), !_.keepValues) {
      if (_.keepDirtyValues) {
        const z = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Da(a, o))
        ]);
        for (const re of Array.from(z))
          Qe(r.dirtyFields, re) ? Jn(O, re, Qe(o, re)) : le(re, Qe(O, re));
      } else {
        if (Ap && at(C))
          for (const z of l.mount) {
            const re = Qe(i, z);
            if (re && re._f) {
              const fe = Array.isArray(re._f.refs) ? re._f.refs[0] : re._f.ref;
              if (Cs(fe)) {
                const be = fe.closest("form");
                if (be) {
                  be.reset();
                  break;
                }
              }
            }
          }
        for (const z of l.mount)
          le(z, Qe(O, z));
      }
      o = xt(O), h.array.next({
        values: { ...O }
      }), h.state.next({
        values: { ...O }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : _.keepDirty ? r.isDirty : !!(_.keepDefaultValues && !Xr(C, a)),
      isSubmitted: _.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Da(a, o) : r.dirtyFields : _.keepDefaultValues && C ? Da(a, C) : _.keepDirty ? r.dirtyFields : {},
      touchedFields: _.keepTouched ? r.touchedFields : {},
      errors: _.keepErrors ? r.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ie = (C, _) => he(vr(C) ? C(o) : C, _), Ae = (C, _ = {}) => {
    const D = Qe(i, C), G = D && D._f;
    if (G) {
      const Y = G.refs ? G.refs[0] : G.ref;
      Y.focus && (Y.focus(), _.shouldSelect && vr(Y.select) && Y.select());
    }
  }, Re = (C) => {
    r = {
      ...r,
      ...C
    };
  }, ze = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: K,
      handleSubmit: Xe,
      setError: Be,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: q,
      _getDirty: R,
      _setValid: F,
      _setFieldArray: H,
      _setDisabledField: Te,
      _setErrors: E,
      _getFieldArray: ee,
      _reset: he,
      _resetDefaultValues: () => vr(n.defaultValues) && n.defaultValues().then((C) => {
        Ie(C, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: M,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(C) {
        s = C;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(C) {
        l = C;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(C) {
        n = {
          ...n,
          ...C
        };
      }
    },
    subscribe: je,
    trigger: ke,
    register: an,
    handleSubmit: Xe,
    watch: Pe,
    setValue: le,
    getValues: Ce,
    reset: Ie,
    resetField: me,
    clearErrors: qe,
    unregister: Le,
    setError: Be,
    setFocus: Ae,
    getFieldState: K
  };
  return {
    ...ze,
    formControl: ze
  };
}
function vM(e = {}) {
  const n = Se.useRef(void 0), r = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: vr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: vr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : gM(e),
    formState: i
  }, e.formControl && e.defaultValues && !vr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !Xr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Rt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = pS(i, o), n.current;
}
const kM = "_settingsWrapper_1ycvy_1", bM = "_settingsWrapperHeader_1ycvy_6", _M = "_settingsWrapperContent_1ycvy_10", xM = "_settingsWrapperContentCode_1ycvy_18", SM = "_settingsWrapperContentCURL_1ycvy_26", Oa = {
  settingsWrapper: kM,
  settingsWrapperHeader: bM,
  settingsWrapperContent: _M,
  settingsWrapperContentCode: xM,
  settingsWrapperContentCURL: SM
}, NM = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = er(), { control: o } = vM({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = hS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = tt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsx(tn, { span: 6, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", className: Oa.settingsWrapper, children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Oa.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ ce.jsx(ue, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: Oa.settingsWrapperContent,
        children: [
          /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            $s,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ ce.jsxs("ol", { children: [
                /* @__PURE__ */ ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ ce.jsx("span", { className: Oa.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ ce.jsx(
            Yk,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                or,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ ce.jsx(
            Yk,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                or,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
            /* @__PURE__ */ ce.jsx(Ln, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Oa.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ ce.jsx(
              Ge,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ ce.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, jM = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], wM = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: eo
  }
], CM = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: NM
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], FM = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, IM = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, EM = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: TL,
  featureSettings: []
} : n ? {
  authSettings: $L,
  featureSettings: [...zx]
} : e ? {
  authSettings: [
    ...lk,
    ...IL
  ],
  featureSettings: [...ck]
} : {
  authSettings: [
    ...lk,
    ...EL
  ],
  featureSettings: [...ck]
}, TM = ({
  hasYotpoOAuth: e = !1,
  isCreationMode: n = !1
}) => e || n ? wM : CM, xS = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = IM(a?.value, r), s = i !== void 0 ? i : FM(
    r
  );
  return o !== void 0 ? o : s;
}, SS = (e = {
  SHOPIFY: {},
  YOTPO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r } = e, {
    authSettings: i,
    featureSettings: a
  } = EM(n), o = TM(r);
  return {
    SHOPIFY: {
      widget: Oz,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...i,
        ...a
      ]
    },
    JIRA: {
      widget: MF,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...rh ? [...rh] : []
      ]
    },
    GITHUB: {
      widget: KC,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...GC]
    },
    MIUROS: {
      widget: YP,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...JP]
    },
    KLAVIYO: {
      widget: tE,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...rE]
    },
    LINEAR: {
      widget: FO,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...IO]
    },
    VOYADO: {
      widget: $U,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...DU]
    },
    LOYALTYLION: {
      widget: oP,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...sP]
    },
    RECHARGE: {
      widget: _A,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...xA]
    },
    BRAZE: {
      widget: iw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...aw]
    },
    YOTPO: {
      widget: XU,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...o, ...jM]
    },
    INGRID: {
      widget: b1,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [..._1]
    }
  };
}, $M = (e) => {
  const n = SS();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      integrationKey: l
    }) => {
      const m = n[i], { settingsConfiguration: u } = m, f = u?.filter(({ secret: h }) => !h)?.map(
        ({
          key: h,
          type: v,
          defaultValue: N
        }) => ({
          key: h,
          value: xS({
            key: h,
            configuration: o,
            settingType: v,
            settingDefault: N
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: f,
        misconfigured: s,
        icon: m.icon,
        iconColors: m.iconColors,
        widget: m.widget,
        integrationKey: l
      };
    }
  );
}, I4 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d
}) => {
  const m = ui(
    {}
  ), u = (T) => (m.current[T] || (m.current[T] = { current: null }), m.current[T]), { track: f } = kn(), h = qn(
    () => $M(e),
    [e]
  ), v = {
    headline: "",
    text: "",
    onConfirm: () => H(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, j] = se(v), [w, F] = se(!1), y = (T) => {
    F(!0), j(T);
  }, H = () => {
    F(!1), j(v);
  };
  return /* @__PURE__ */ Me.jsxs(Me.Fragment, { children: [
    h.map(
      ({
        id: T,
        name: E,
        type: $,
        widget: U,
        settings: Z,
        misconfigured: Q,
        icon: ie,
        iconColors: J,
        integrationKey: M
      }, R) => {
        const q = `partner-integration-${$}`, ee = /* @__PURE__ */ Me.jsx(Im, { icon: ie, color: J }), ge = Z?.reduce(
          (de, le) => (de[le.key] = le.value, de),
          {}
        );
        return s ? /* @__PURE__ */ Me.jsx("div", { className: "icon-holder", children: ee }, `partner-icon-${T}`) : /* @__PURE__ */ Me.jsxs(
          ar,
          {
            onToggle: () => {
              f(
                o(M) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: T,
                  widgetType: $.toLowerCase()
                }
              ), a(M);
            },
            isOpen: o(M),
            className: q,
            containerRef: (de) => {
              u(M).current = de;
            },
            children: [
              /* @__PURE__ */ Me.jsx(
                ar.Header,
                {
                  wrap: "normal",
                  avatar: ee,
                  slotBeforeTitle: d?.(
                    M,
                    R,
                    u(M)
                  ),
                  slotAfterTitle: l?.(M),
                  children: E
                }
              ),
              /* @__PURE__ */ Me.jsx(ar.Content, { children: Q ? /* @__PURE__ */ Me.jsx(In, { isMisconfigured: !0 }) : /* @__PURE__ */ Me.jsx(
                kb.Provider,
                {
                  value: {
                    onError: (de, le) => console.warn(
                      `Something went wrong with a partner widget of type '${$}' and id '${T}'`,
                      de,
                      le
                    )
                  },
                  children: /* @__PURE__ */ Me.jsx(
                    e_,
                    {
                      integrationId: T,
                      type: $,
                      configuration: n,
                      showNotification: i,
                      showModal: y,
                      children: BS(U, {
                        conversationContext: r,
                        settings: ge
                      })
                    }
                  )
                }
              ) })
            ]
          },
          M
        );
      }
    ),
    /* @__PURE__ */ Me.jsx(
      gb,
      {
        isOpen: w,
        setIsOpen: F,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            F(!1), j(v);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            F(!1), j(v);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, DM = Zr`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function E4(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return He(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Zb(e).query({
      query: DM
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const RM = ({
  widgetConfiguration: e
}) => {
  const n = qn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = qn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, OM = "FULL_ACCESS", PM = "2", AM = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [OM],
        version: PM
      })
    }).then((l) => l.json())
  };
}, LM = "dixaApiToken", Mp = "dixaApiTokenId", NS = "dixaApiTokenName", sb = (e) => [Mp, NS].every(
  (r) => e.find((i) => i?.key === r)
);
function VM({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = zM(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const zM = (e) => [
  {
    key: LM,
    value: e.value,
    secret: !0
  },
  {
    key: Mp,
    value: e.id,
    secret: !1
  },
  {
    key: NS,
    value: e.name,
    secret: !1
  }
], UM = Zr`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, MM = Zr`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, BM = Zr`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, qM = Zr`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, HM = "_wrapper_1lmim_1", WM = "_wrapperBox_1lmim_4", KM = "_wrapperBoxErrorBorder_1lmim_9", Mu = {
  wrapper: HM,
  wrapperBox: WM,
  wrapperBoxErrorBorder: KM
}, GM = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (H) => H.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, N = `Insert your ${h.label.toLowerCase()}`, j = `Insert your ${v.label.toLowerCase()}`, [w, F] = se({
    username: "",
    password: ""
  }), y = tt(
    (H) => {
      m({
        target: {
          name: s,
          value: H
        }
      });
    },
    [s, m]
  );
  return He(() => {
    y(
      w.username !== "" && w.password !== "" ? window.btoa(`${w.username}:${w.password}`) : ""
    );
  }, [w]), /* @__PURE__ */ Me.jsx(
    Ln,
    {
      required: e,
      label: a,
      meta: l,
      className: Mu.wrapper,
      children: /* @__PURE__ */ Me.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ut(Mu.wrapperBox, {
            [Mu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Me.jsx(
              or,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: N,
                input: {
                  name: s,
                  value: w.username,
                  onChange: (H) => F({
                    username: H?.target.value ?? "",
                    password: w.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Me.jsx(
              or,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: j,
                input: {
                  name: s,
                  value: w.password,
                  onChange: (H) => F({
                    username: w.username,
                    password: H?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function lb({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: N,
  prefix: j,
  integrationId: w,
  integrationType: F,
  configuration: y,
  settings: H,
  otherProps: T
}) {
  const E = v === "custom" && T?.component, $ = u(n)?.value;
  return E ? /* @__PURE__ */ Me.jsx(
    E,
    {
      configuration: y,
      integrationId: w,
      integrationType: F,
      label: r,
      settings: H,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Me.jsxs(Me.Fragment, { children: [
    /* @__PURE__ */ Me.jsx(tn, { span: 3, children: /* @__PURE__ */ Me.jsx(
      YM,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: N,
        children: v === "input" ? /* @__PURE__ */ Me.jsx(
          or,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: $,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: j,
            ...e && !N && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Me.jsx(
          GM,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: N,
            label: r,
            widgetSettingsKey: n,
            settings: H,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Me.jsx(Ln, { label: r, children: /* @__PURE__ */ Me.jsx(
          bb,
          {
            input: {
              name: n,
              value: "",
              checked: $,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Me.jsx(Ln, { label: r, children: /* @__PURE__ */ Me.jsx(
          Yr,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Me.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ Me.jsx(Me.Fragment, {}),
            value: $ ? [
              {
                label: (T?.selectItems || []).find(
                  (U) => U.value === $
                )?.label,
                value: $
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: (T?.selectItems || []).map((U) => /* @__PURE__ */ Me.jsx(ot.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Me.jsx(Me.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Me.jsx(tn, { span: 3 })
  ] });
}
function YM({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Me.jsx(Ln, { label: n, children: /* @__PURE__ */ Me.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Ya = "partner-integrations-widget-name-form-field", cb = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: xS({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), JM = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (T) => i(T), l = (T) => !T || T === "", d = (T) => {
    const { [T]: E, ...$ } = a;
    o($);
  }, m = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: E }) => E).map(({ key: E, value: $, secret: U }) => ({
      key: E,
      value: $,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, value: $ }
    } = T;
    a[E] && !l($) && d(E), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === E ? { ...U, value: $ } : U
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: E, checked: $ }
    } = T;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === E ? { ...U, value: $ } : U
      )
    });
  }, v = (T, E) => {
    if (!E)
      return;
    const { selectedValues: $ } = E, U = $?.[0];
    if (U) {
      const Z = r.settings.map(
        (Q) => Q.key === T ? { ...Q, value: U?.value } : Q
      );
      i({
        ...r,
        settings: Z
      });
    } else {
      const Z = r.settings.filter(
        (Q) => Q.key !== T
      );
      i({
        ...r,
        settings: Z
      });
    }
  }, N = (T) => {
    i({
      ...r,
      enabled: T
    });
  }, j = (T) => {
    if (!T)
      return;
    const {
      target: { value: E }
    } = T;
    a[Ya] && !l(E) && d(Ya), i({
      ...r,
      name: E
    });
  }, w = (T, E) => {
    const { settings: $ } = r, U = $.map((Z) => Z.key === E ? {
      ...Z,
      isEditing: T,
      ...!T && { value: "" }
    } : Z);
    a[E] && !T && d(E), i({
      ...r,
      settings: U
    });
  }, F = (T) => r.settings.find(
    (E) => E.key === T
  ), y = async (T) => {
    T.preventDefault(), H() && n(m(r));
  }, H = () => {
    const T = {}, { name: E, settings: $ } = r;
    return l(E) && (T[Ya] = u.input), $.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ie, type: J, customValidation: M }) => {
        if (Q && ie)
          if (M) {
            const R = M(Z);
            typeof R == "string" && (T[U] = R);
          } else
            typeof Z == "string" && l(Z) && (T[U] = u[J]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: N,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: w,
    handleChangeName: j,
    handleSubmit: y,
    getSettingValueByKey: F,
    initializeFormData: s,
    validate: H
  };
}, QM = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], db = "The configuration of the integration is not correct. Please check the settings.", XM = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o
}) => {
  const { track: s } = kn(), { deleteDixaApiToken: l, createDixaApiToken: d } = AM({
    type: n,
    baseUrl: a.baseUrl
  }), u = l0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), f = !e && !!n && !!u, h = QM.includes(n), [v, N] = se(), [j, w] = se(!1), [F, y] = se(!1), [H, T] = se(!1), [E, $] = se(null), [U, Z] = se(), { isInboundOAuth: Q } = VS(), ie = Q && f ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: J,
    isShopifyMarketplaceApp: M,
    initialValuesForShopify: R
  } = RM({
    featureFlags: a.featureFlags,
    widgetConfiguration: U
  }), q = n === "YOTPO" && !!U?.additionalProperties?.isUsingOAuth, ee = f && n === "SHOPIFY", le = SS({
    SHOPIFY: {
      hasShopifyOAuth: J,
      isShopifyMarketplaceApp: M,
      isCreationMode: f
    },
    YOTPO: {
      hasYotpoOAuth: q,
      isCreationMode: f
    }
  })[n].settingsConfiguration, pe = le.filter(({ type: ze }) => ze !== "hidden").filter(({ hideOnCreate: ze }) => f ? !ze : !0), W = pe.filter(
    ({ additionalProperties: ze }) => ze?.renderAboveForm === !0
  ), ke = pe.filter(
    ({ additionalProperties: ze }) => ze?.renderAboveForm !== !0
  ), {
    error: Ce,
    loading: K,
    refetch: qe
  } = a0(UM, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (ze) => {
      if (Object.keys(ze).length === 0)
        T(!0);
      else {
        T(!1);
        const C = ze?.Management?.widgetConfigurations?.[0];
        C && Z({
          ...C,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${C.id}`,
          additionalProperties: C.additionalProperties ?? void 0
        });
      }
    }
  }), [Be, { error: Pe }] = Hp(
    f ? BM : MM,
    {
      onError: (ze) => {
        N(ze), w(!1), i({
          title: "Something went wrong",
          text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (ze) => {
        if (w(!1), Object.keys(ze).length !== 0) {
          if (f && r(
            ze.Management?.createWidgetConfiguration?.id
          ), !f) {
            const _ = ze.Management?.updateWidgetConfiguration;
            _?.misconfigured ? $(
              _.misconfigurationCause ?? db
            ) : $(null);
          }
          i({
            title: `${f ? "Creating" : "Updating"} was successful`,
            text: `${f ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${f ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Ue] = Hp(qM, {
    onError: (ze) => {
      N(ze), w(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      w(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: je,
    handleIsEnabled: Le,
    errors: Te,
    handleChangeText: an,
    handleChangeBoolean: we,
    handleChangeSelect: We,
    handleEditSecret: Xe,
    handleChangeName: me,
    handleSubmit: he,
    getSettingValueByKey: Ie,
    initializeFormData: Ae
  } = JM({
    onSubmit: async (ze) => {
      f ? s("settings:create:submitted", { widgetType: n }) : e && s("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), w(!0);
      const C = ze.settings.map(
        (Y) => typeof Y.value == "boolean" ? { ...Y, value: Y.value.toString() } : Y
      ), _ = sb(C) && f;
      let D = [];
      if (_) {
        const Y = await d().catch(
          (O) => {
            w(!1), console.warn("API-Token (creation) error resonse", O), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        Y?.data && (D = VM({
          token: Y.data,
          settings: C
        }));
      }
      const G = {
        ...ze,
        settings: [
          ...D.length > 0 ? D : C
        ]
      };
      (_ && D.length > 1 || !_ && D.length === 0) && (Be({
        variables: {
          ...!f && { id: e },
          ...f && { type: n },
          ...G
        }
      }), C.forEach(
        (Y) => Y.secret && Xe(!1, Y.key)
      ));
    },
    ...f && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: cb({
          settingsFromBackend: R,
          settingsConfiguration: le,
          creating: !0
        })
      }
    }
  });
  He(() => {
    if (U) {
      const ze = cb({
        settingsFromBackend: U.settings,
        settingsConfiguration: le
      });
      Ae({
        enabled: !!U.enabled,
        name: U.name,
        settings: ze
      }), U.misconfigured ? $(
        U?.misconfigurationCause ?? db
      ) : $(null);
    }
  }, [U]);
  const Re = qn(() => o ? !o.isCoupled : !0, [o]);
  return Ce || Pe || v ? /* @__PURE__ */ Me.jsx(
    In,
    {
      error: Ce || v,
      retry: Ce ? qe : void 0
    }
  ) : j || K ? /* @__PURE__ */ Me.jsx(cn, { "data-testid": "widget-settings-loading" }) : H ? /* @__PURE__ */ Me.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Me.jsx(Pn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Me.jsxs("form", { children: [
    E && /* @__PURE__ */ Me.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Me.jsx(
      $s,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Me.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Me.jsx(A.Paragraph, { children: E }),
          /* @__PURE__ */ Me.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Me.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Me.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Me.jsxs(
      Ut,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          W.map(
            ({ key: ze, label: C, ..._ }) => /* @__PURE__ */ Me.jsx(
              lb,
              {
                widgetSettingsKey: ze,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: Ie,
                isSecret: !1,
                label: C,
                placeholder: "",
                required: !1,
                errors: Te,
                type: "custom",
                isCreationMode: f,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: le,
                otherProps: _
              },
              ze
            )
          ),
          !ee && /* @__PURE__ */ Me.jsxs(Me.Fragment, { children: [
            /* @__PURE__ */ Me.jsx(tn, { children: /* @__PURE__ */ Me.jsx(Ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Me.jsx(
              bb,
              {
                input: {
                  name: "enabled",
                  checked: je.enabled,
                  value: "dummy",
                  onChange: (ze) => Le(ze.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Me.jsx(tn, { span: 3, children: /* @__PURE__ */ Me.jsx(
              or,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Ya,
                  value: je.name,
                  onChange: me
                },
                meta: {
                  error: Te[Ya]
                }
              }
            ) }),
            /* @__PURE__ */ Me.jsx(tn, { span: 3 })
          ] }),
          ke?.map(
            ({
              key: ze,
              secret: C,
              label: _,
              placeholder: D = "",
              required: G = !1,
              type: Y,
              prefix: O,
              readOnly: z,
              ...re
            }) => {
              const { settings: fe } = je, be = fe.find(
                (en) => en.key === ze
              );
              return /* @__PURE__ */ Me.jsx(qS, { children: /* @__PURE__ */ Me.jsx(
                lb,
                {
                  widgetSettingsKey: ze,
                  isEditingField: !!be?.isEditing,
                  handleEditSecret: Xe,
                  handleChangeText: an,
                  handleChangeBoolean: we,
                  handleChangeSelect: We,
                  getValueByKey: Ie,
                  isSecret: C,
                  label: _,
                  placeholder: D,
                  required: G,
                  errors: Te,
                  type: Y,
                  isCreationMode: f,
                  prefix: O,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: z,
                  settings: le,
                  otherProps: re
                }
              ) }, ze);
            }
          )
        ]
      }
    ),
    !ee && /* @__PURE__ */ Me.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Me.jsx(Kn, { onClick: he, children: ie }),
      !f && /* @__PURE__ */ Me.jsx(
        Ge,
        {
          content: "The widget is used in automations",
          disabled: Re,
          children: /* @__PURE__ */ Me.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && s("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), y(!0);
              },
              disabled: !Re,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Me.jsx(
      gb,
      {
        isOpen: F,
        setIsOpen: y,
        confirmVariant: h ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && s("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && s("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), sb(je.settings)) {
            const ze = je.settings.find(
              ({ key: C }) => C === Mp
            )?.value;
            ze && l(ze).catch((C) => {
              console.warn("API-Token (deletion) error response", C), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Ue({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Me.jsx(b, { children: h ? /* @__PURE__ */ Me.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Me.jsx(
            ue,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Me.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Me.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Me.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Me.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              je.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Me.jsxs(Me.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          je.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, T4 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o
}) => /* @__PURE__ */ Me.jsx(
  kb.Provider,
  {
    value: {
      onError: (s, l) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        s,
        l
      )
    },
    children: /* @__PURE__ */ Me.jsx(
      e_,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Me.jsx(
          XM,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o
          }
        )
      }
    )
  }
), ub = "__PairingContext__", jS = globalThis[ub] ?? (() => {
  const e = vb({});
  return globalThis[ub] = e, e;
})(), $4 = () => Cm(jS), D4 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Me.jsx(jS.Provider, { value: e, children: n });
var qo = { exports: {} }, mb;
function ZM() {
  if (mb) return qo.exports;
  mb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(E, $, U) {
    return Function.prototype.apply.call(E, $, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : r = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  qo.exports = o, qo.exports.once = F, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || a(E))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function d(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(E) {
    for (var $ = [], U = 1; U < arguments.length; U++) $.push(arguments[U]);
    var Z = E === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ie;
      if ($.length > 0 && (ie = $[0]), ie instanceof Error)
        throw ie;
      var J = new Error("Unhandled error." + (ie ? " (" + ie.message + ")" : ""));
      throw J.context = ie, J;
    }
    var M = Q[E];
    if (M === void 0)
      return !1;
    if (typeof M == "function")
      n(M, this, $);
    else
      for (var R = M.length, q = N(M, R), U = 0; U < R; ++U)
        n(q[U], this, $);
    return !0;
  };
  function m(T, E, $, U) {
    var Z, Q, ie;
    if (l($), Q = T._events, Q === void 0 ? (Q = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (Q.newListener !== void 0 && (T.emit(
      "newListener",
      E,
      $.listener ? $.listener : $
    ), Q = T._events), ie = Q[E]), ie === void 0)
      ie = Q[E] = $, ++T._eventsCount;
    else if (typeof ie == "function" ? ie = Q[E] = U ? [$, ie] : [ie, $] : U ? ie.unshift($) : ie.push($), Z = d(T), Z > 0 && ie.length > Z && !ie.warned) {
      ie.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ie.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = T, J.type = E, J.count = ie.length, i(J);
    }
    return T;
  }
  o.prototype.addListener = function(E, $) {
    return m(this, E, $, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, $) {
    return m(this, E, $, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, E, $) {
    var U = { fired: !1, wrapFn: void 0, target: T, type: E, listener: $ }, Z = u.bind(U);
    return Z.listener = $, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(E, $) {
    return l($), this.on(E, f(this, E, $)), this;
  }, o.prototype.prependOnceListener = function(E, $) {
    return l($), this.prependListener(E, f(this, E, $)), this;
  }, o.prototype.removeListener = function(E, $) {
    var U, Z, Q, ie, J;
    if (l($), Z = this._events, Z === void 0)
      return this;
    if (U = Z[E], U === void 0)
      return this;
    if (U === $ || U.listener === $)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[E], Z.removeListener && this.emit("removeListener", E, U.listener || $));
    else if (typeof U != "function") {
      for (Q = -1, ie = U.length - 1; ie >= 0; ie--)
        if (U[ie] === $ || U[ie].listener === $) {
          J = U[ie].listener, Q = ie;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : j(U, Q), U.length === 1 && (Z[E] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", E, J || $);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var $, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[E]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ie;
      for (Z = 0; Z < Q.length; ++Z)
        ie = Q[Z], ie !== "removeListener" && this.removeAllListeners(ie);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if ($ = U[E], typeof $ == "function")
      this.removeListener(E, $);
    else if ($ !== void 0)
      for (Z = $.length - 1; Z >= 0; Z--)
        this.removeListener(E, $[Z]);
    return this;
  };
  function h(T, E, $) {
    var U = T._events;
    if (U === void 0)
      return [];
    var Z = U[E];
    return Z === void 0 ? [] : typeof Z == "function" ? $ ? [Z.listener || Z] : [Z] : $ ? w(Z) : N(Z, Z.length);
  }
  o.prototype.listeners = function(E) {
    return h(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return h(this, E, !1);
  }, o.listenerCount = function(T, E) {
    return typeof T.listenerCount == "function" ? T.listenerCount(E) : v.call(T, E);
  }, o.prototype.listenerCount = v;
  function v(T) {
    var E = this._events;
    if (E !== void 0) {
      var $ = E[T];
      if (typeof $ == "function")
        return 1;
      if ($ !== void 0)
        return $.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function N(T, E) {
    for (var $ = new Array(E), U = 0; U < E; ++U)
      $[U] = T[U];
    return $;
  }
  function j(T, E) {
    for (; E + 1 < T.length; E++)
      T[E] = T[E + 1];
    T.pop();
  }
  function w(T) {
    for (var E = new Array(T.length), $ = 0; $ < E.length; ++$)
      E[$] = T[$].listener || T[$];
    return E;
  }
  function F(T, E) {
    return new Promise(function($, U) {
      function Z(ie) {
        T.removeListener(E, Q), U(ie);
      }
      function Q() {
        typeof T.removeListener == "function" && T.removeListener("error", Z), $([].slice.call(arguments));
      }
      H(T, E, Q, { once: !0 }), E !== "error" && y(T, Z, { once: !0 });
    });
  }
  function y(T, E, $) {
    typeof T.on == "function" && H(T, "error", E, $);
  }
  function H(T, E, $, U) {
    if (typeof T.on == "function")
      U.once ? T.once(E, $) : T.on(E, $);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(E, function Z(Q) {
        U.once && T.removeEventListener(E, Z), $(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return qo.exports;
}
var e4 = ZM();
function R4() {
  const e = new e4.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  Cj as GraphQLClientProvider,
  jS as PairingContext,
  D4 as PairingProvider,
  I4 as PartnerIntegrations,
  T4 as PartnerIntegrationsSettings,
  BM as createWidgetConfigurationMutation,
  qM as deleteWidgetConfigurationMutation,
  UM as getWidgetConfigurationByIdQuery,
  SS as getWidgetDefinitions,
  R4 as initializePartnerEventEmitter,
  MM as updateWidgetConfigurationMutation,
  $4 as usePairing,
  E4 as usePartnerIntegrationWidgetConfigurations,
  RM as useShopifyConfiguration
};
